// Facturen.js
// vFCT-046 - Waarschuwing bij mislukte UBL-administratiekopie na geslaagde klantmail duidelijk tonen.
// vFCT-045 - Btw verlegd: categorie uit opgeslagen factuurregels herstellen; artikelkolom compact 0%, totalen Btw verlegd.
// vFCT-044 - Alle factuurteksten Calibri 11 pt, inclusief titel, kenmerk en voettekst; bestaande logica behouden.
// vFCT-043 - PDF-documentbasis Calibri 11 pt / 1,15; bestaande specifieke opmaak behouden.
// vFCT-042
// - Dunne scheidingslijnen onder artikelregels verwijderd in factuurweergave, voorbeeld en PDF.
// - Lege voettekst toont geen scheidingslijn meer; ingevulde voettekst blijft behouden zonder bovenlijn.
// - Kolomkop en totaalstrepen, bedragen, btw, UBL en factuurverwerking ongewijzigd.
// vFCT-041
// - Artikelomschrijvingen op zichtbare tekst controleren vóór definitief maken, handmatige admin-statuswijziging en e-mail/UBL.
// - Projectovername blokkeert artikelen zonder Offertetekst; bestaande factuurgegevens, bedragen en status blijven intact.
// - Factuurtotalen omvatten alle artikelregels met aantal en prijs, ook als een bestaande omschrijving leeg is; sluit aan bij database en UBL.
// - Middengrid: Status direct na Relatie; volgorde van kolommen afgestemd op Offertes; lege contactpersoon toont geen losse komma.
// - Bestaande documentvolgorde, artikel-/tekstblokken, PDF, UBL en boekingen verder ongewijzigd.
// vFCT-039
// - Tekstregels als zelfstandige blokken over de volle documentbreedte, ook vóór en tussen artikelen.
// - Kolomkop eenmaal, vlak boven eerste Artikel; Voorbeeld en PDF gebruiken dezelfde weergave.
// - Factuurregels, berekeningen, UBL en opslag ongewijzigd.
// vFCT-038
// - Nieuwe/bewerkte factuurregels alleen Artikel/Tekst; oude Kop/Subtotaal/Totaal blijven historisch leesbaar.
// - Vrije tekst begint onder kolom Omschrijving en loopt door over de overige kolommen, ook bij PDF.
// - Projectbeheer-import normaliseert historische niet-financiële regels naar Tekst; berekeningen/UBL ongewijzigd.
// vFCT-037
// - Niet-financiële regels (Tekst/Kop/Subtotaal/Totaal) beginnen links op de factuurregel, zonder inspringing.
// - Bestaande artikelkolommen, totalen, PDF-, UBL- en opslaglogica zijn ongewijzigd.
// vFCT-036
// - Factuurregels bewaren type Artikel/Tekst/Kop/Subtotaal/Totaal; niet-financiële regels zonder aantallen, bedragen of btw.
// - Projectbeheer en Opdracht→Factuur houden het regeltype; ook bestaande conceptregels kunnen via Bewerken worden gecorrigeerd.
// - PDF en UBL: tekstregels worden niet als financiële regels geteld; bestaande definitieve facturen blijven ongewijzigd.
// vFCT-035
// - Grid: Factuurnr iets breder voor volledige weergave; factuurlogica en UBL ongewijzigd.
// vFCT-034
// - Projectbeheer-teksten met HTML-opmaak worden als leesbare factuurtekst overgenomen; ook eerder opgeslagen HTML-regels worden schoon getoond.
// - Factuurregels worden bij opslaan als platte tekst vastgelegd; bestaande financiële, PDF- en UBL-logica ongewijzigd.
// vFCT-033
// - UBL XML bij definitieve factuur downloaden als relatie UBL wenst; mail toont apart foutmelding als administratiekopie mislukt.
// - PDF-factuur en BCC-UBL via server.js v563 blijven ongewijzigd; bestaand factuur- en CAO-gedrag behouden.
// vFCT-032
// - Calibri 11 pt standaard in factuurdocument en print-/PDF-weergave; bestaande specifieke opmaak behouden.
// vFCT-031
// - Creditnota: negatieve factuurregels toegestaan; negatieve totalen worden automatisch als Creditnota getoond, geprint en gemaild.
// - MKB eigen briefpapier: Bewerken blijft schoon zonder achtergrond; Voorbeeld toont de echte server-gerenderde PDF met A4-pagina's.
// - MKB eigen briefpapier: factuur-PDF, documentopslag en e-mailbijlage gebruiken dezelfde A4-rendering met gereserveerde kop/voet.
// - Factuurvoorbeeld gebruikt consequent de aparte MKB-factuurinstellingen per bedrijfscode
// - Lege factuurvelden vallen niet meer terug op oude legacy factuurgegevens
// - Gekozen factuursjabloon wordt nu ook bij bestaande conceptfacturen opgeslagen
// - Facturen gebruiken nu de aparte MKB-factuurinstellingen per bedrijfscode
// Layout + UX afgestemd op Organisaties/Contactpersonen/Notities:
// - Links: zoek + knoppen
// - Midden: overzicht (met kolomfilters per kolom)
// - Rechts: details geselecteerde factuur + betalingen (deelbetalingen)
//
// Belangrijk:
// - Alleen concepten zijn wijzigbaar; gefactureerd is read-only (crediteer-route later).
// - Voor adres op factuur: correspondentieadres van de organisatie (ophalen via /api/organisations/:id)
//
// Verwachtte API's (server.js):
// - GET    /api/invoices?q=...
// - GET    /api/invoices/:id
// - POST   /api/invoices
// - PUT    /api/invoices/:id
// - DELETE /api/invoices/:id
// - GET    /api/invoices/:id/payments
// - POST   /api/invoices/:id/payments
// - PUT    /api/invoices/:id/payments/:pid
// - DELETE /api/invoices/:id/payments/:pid
// - GET    /api/organisations
// - GET    /api/organisations/:id
// - GET    /api/contacts?organisation_id=...

import React, { useEffect, useMemo, useRef, useState } from "react";
import useVoiceCommands from "../components/useVoiceCommands";
import HelpButton from "../components/HelpButton";

// ===== FACTUURREGELS POPUP =====
function makeEmptyInvoiceLine() {
  return {
    qty: "",
    description: "",
    price: "",
    vat: "21",
  };
}

const buildUrl = (u) =>
  u.startsWith("http") ? u : `${u.startsWith("/") ? u : `/${u}`}`;

// ---------------- helpers ----------------
function getParam(name) {
  try {
    const url = new URL(window.location.href);
    return url.searchParams.get(name) || "";
  } catch {
    return "";
  }
}

function norm(s) {
  return String(s || "")
    .toLowerCase()
    .trim()
    .replace(/[，、]/g, ",")
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/[;:!?]/g, "")
    .replace(/\s+/g, " ");
}

function safeTrim(s) {
  return String(s || "").trim();
}

function isEmptyWord(t) {
  const x = norm(t);
  return x === "geen" || x === "blanco" || x === "leeg" || x === "null";
}

async function tryFetchJson(urls, options = {}) {
  const token =
    sessionStorage.getItem("token") ||
    localStorage.getItem("token") ||
    "";

  const tenant =
    sessionStorage.getItem("tenant") ||
    localStorage.getItem("tenant") ||
    "demo";

  let parsedUser = {};
  try {
    parsedUser = JSON.parse(
      sessionStorage.getItem("user") ||
      localStorage.getItem("user") ||
      "{}"
    );
  } catch {}

  const role = parsedUser?.role || "user";

  const companyCodeIds =
    sessionStorage.getItem("staffiq_company_code_ids") ||
    localStorage.getItem("staffiq_company_code_ids") ||
    "";

  let lastErr;
  for (const url of urls) {
    try {
      const headers = {
        ...(options.headers || {}),
        Authorization: token ? `Bearer ${token}` : undefined,
        "x-tenant": tenant,
        "x-role": role,
        "x-staffiq-user-id": parsedUser?.id || undefined,
        "x-staffiq-user-email": parsedUser?.email || undefined,
        "x-staffiq-user-name": parsedUser?.display_name || parsedUser?.name || undefined,
        "x-company-code-ids": companyCodeIds || undefined,
      };

      Object.keys(headers).forEach(
        (k) => headers[k] === undefined && delete headers[k]
      );

      const res = await fetch(buildUrl(url), { ...options, headers });
      if (!res.ok) {
        const msg = await res.text().catch(() => '');
        throw new Error(`${res.status} ${res.statusText}${msg ? ` - ${msg}` : ''}`);
      }
      const ct = res.headers.get('content-type') || '';
      if (ct.includes('application/json')) return await res.json();
      return await res.text();
    } catch (e) {
      lastErr = e;
    }
  }
  throw lastErr || new Error('Failed to fetch');
}

// vFCT-030: binary fetch voor het echte PDF-voorbeeld bij eigen briefpapier.
async function fetchPdfBlob(url, options = {}) {
  const token =
    sessionStorage.getItem("token") ||
    localStorage.getItem("token") ||
    "";

  const tenant =
    sessionStorage.getItem("tenant") ||
    localStorage.getItem("tenant") ||
    "demo";

  let parsedUser = {};
  try {
    parsedUser = JSON.parse(
      sessionStorage.getItem("user") ||
      localStorage.getItem("user") ||
      "{}"
    );
  } catch {}

  const companyCodeIds =
    sessionStorage.getItem("staffiq_company_code_ids") ||
    localStorage.getItem("staffiq_company_code_ids") ||
    "";

  const headers = {
    ...(options.headers || {}),
    Authorization: token ? `Bearer ${token}` : undefined,
    "x-tenant": tenant,
    "x-role": parsedUser?.role || "user",
    "x-staffiq-user-id": parsedUser?.id || undefined,
    "x-staffiq-user-email": parsedUser?.email || undefined,
    "x-staffiq-user-name": parsedUser?.display_name || parsedUser?.name || undefined,
    "x-company-code-ids": companyCodeIds || undefined,
  };

  Object.keys(headers).forEach(
    (key) => headers[key] === undefined && delete headers[key]
  );

  const response = await fetch(buildUrl(url), { ...options, headers });
  if (!response.ok) {
    const message = await response.text().catch(() => "");
    throw new Error(
      `${response.status} ${response.statusText}${message ? ` - ${message}` : ""}`
    );
  }

  return await response.blob();
}

function normalizePhoneForCommunication(raw, defaultCountryCode = "+31") {
  let s = String(raw || "").trim();

  if (!s || s === "-") return "";

  s = s
    .replace(/[^\d+]/g, "")
    .replace(/^00/, "+");

  if (!s) return "";

  if (s.startsWith("+")) return s;

  if (s.startsWith("0")) {
    return `${defaultCountryCode}${s.slice(1)}`;
  }

  if (s.startsWith("31")) {
    return `+${s}`;
  }

  return `${defaultCountryCode}${s}`;
}

async function loadCommunicationSettingsSafe() {
  try {
    const data = await tryFetchJson(["/api/communication-settings"]);

    return {
      email_enabled: data?.email_enabled !== false,
      whatsapp_enabled: data?.whatsapp_enabled !== false,
      sms_enabled: data?.sms_enabled === true,
      default_country_code: data?.default_country_code || "+31",
      default_sms_text: data?.default_sms_text || "",
      default_whatsapp_text: data?.default_whatsapp_text || "",
    };
  } catch {
    return {
      email_enabled: true,
      whatsapp_enabled: true,
      sms_enabled: false,
      default_country_code: "+31",
      default_sms_text: "",
      default_whatsapp_text: "",
    };
  }
}

function stopGridClick(e) {
  try {
    e.preventDefault();
    e.stopPropagation();
  } catch {}
}

function askCommunicationChoice(raw) {
  return new Promise((resolve) => {
    const overlay = document.createElement("div");

    overlay.style.position = "fixed";
    overlay.style.left = "0";
    overlay.style.top = "0";
    overlay.style.right = "0";
    overlay.style.bottom = "0";
    overlay.style.background = "rgba(0,0,0,0.35)";
    overlay.style.zIndex = "999999";
    overlay.style.display = "flex";
    overlay.style.alignItems = "center";
    overlay.style.justifyContent = "center";
    overlay.style.padding = "18px";
    overlay.style.boxSizing = "border-box";

    const box = document.createElement("div");

    box.style.width = "min(520px, 100%)";
    box.style.background = "#fff";
    box.style.borderRadius = "12px";
    box.style.boxShadow = "0 18px 50px rgba(0,0,0,0.35)";
    box.style.padding = "18px";
    box.style.boxSizing = "border-box";
    box.style.fontFamily = "Arial, Helvetica, sans-serif";
    box.style.color = "#111";

    const title = document.createElement("div");
    title.style.fontWeight = "700";
    title.style.fontSize = "18px";
    title.style.marginBottom = "12px";
    title.textContent = `Wat wil je doen met ${raw}?`;

    const help = document.createElement("div");
    help.style.fontSize = "16px";
    help.style.lineHeight = "1.8";
    help.style.marginBottom = "12px";
    help.innerHTML = "1 = Bellen<br/>2 = SMS<br/>3 = WhatsApp";

    const input = document.createElement("input");
    input.type = "text";
    input.value = "3";
    input.inputMode = "numeric";
    input.autocomplete = "off";
    input.style.width = "100%";
    input.style.fontSize = "20px";
    input.style.padding = "10px 12px";
    input.style.border = "2px solid #1f4e79";
    input.style.borderRadius = "8px";
    input.style.boxSizing = "border-box";
    input.style.marginBottom = "14px";

    const buttons = document.createElement("div");
    buttons.style.display = "flex";
    buttons.style.gap = "10px";
    buttons.style.justifyContent = "flex-end";

    const okButton = document.createElement("button");
    okButton.type = "button";
    okButton.textContent = "OK";
    okButton.style.padding = "10px 18px";
    okButton.style.border = "none";
    okButton.style.borderRadius = "8px";
    okButton.style.background = "#1f4e79";
    okButton.style.color = "#fff";
    okButton.style.fontSize = "16px";
    okButton.style.cursor = "pointer";

    const cancelButton = document.createElement("button");
    cancelButton.type = "button";
    cancelButton.textContent = "Annuleren";
    cancelButton.style.padding = "10px 18px";
    cancelButton.style.border = "1px solid #d0d0d0";
    cancelButton.style.borderRadius = "8px";
    cancelButton.style.background = "#fff";
    cancelButton.style.color = "#111";
    cancelButton.style.fontSize = "16px";
    cancelButton.style.cursor = "pointer";

    let done = false;

    function cleanup(value) {
      if (done) return;
      done = true;

      try {
        document.body.removeChild(overlay);
      } catch {}

      resolve(value);
    }

    okButton.onclick = () => cleanup(input.value);
    cancelButton.onclick = () => cleanup(null);

    input.onkeydown = (ev) => {
      if (ev.key === "Enter") {
        ev.preventDefault();
        cleanup(input.value);
      }

      if (ev.key === "Escape") {
        ev.preventDefault();
        cleanup(null);
      }
    };

    overlay.onclick = (ev) => {
      if (ev.target === overlay) {
        cleanup(null);
      }
    };

    buttons.appendChild(cancelButton);
    buttons.appendChild(okButton);

    box.appendChild(title);
    box.appendChild(help);
    box.appendChild(input);
    box.appendChild(buttons);

    overlay.appendChild(box);
    document.body.appendChild(overlay);

    setTimeout(() => {
      try {
        input.focus();
        input.select();
      } catch {}
    }, 80);
  });
}

async function handleEmailGridClick(e, email) {
  stopGridClick(e);

  const mail = String(email || "").trim();

  if (!mail || mail === "-") return;

  const settings = await loadCommunicationSettingsSafe();

  if (settings.email_enabled === false) {
    alert("E-mail is niet actief in Communicatie-instellingen.");
    return;
  }

  window.location.href = `mailto:${encodeURIComponent(mail)}`;
}

function handlePhoneGridClick(e, phone) {
  stopGridClick(e);

  const tel = String(phone || "").trim();

  if (!tel || tel === "-") return;

  window.location.href = `tel:${tel}`;
}

async function handleMobileGridClick(e, mobile) {
  stopGridClick(e);

  const raw = String(mobile || "").trim();

  if (!raw || raw === "-") return;

  const settings = await loadCommunicationSettingsSafe();
  const normalized = normalizePhoneForCommunication(raw, settings.default_country_code || "+31");

  if (!normalized) return;

  const choice = await askCommunicationChoice(raw);

  const c = String(choice || "").trim().toLowerCase();

  if (!c) return;

  if (c === "1" || c === "bellen" || c === "bel") {
    window.location.href = `tel:${raw}`;
    return;
  }

  if (c === "2" || c === "sms") {
    if (settings.sms_enabled !== true) {
      alert("SMS is niet actief in Communicatie-instellingen.");
      return;
    }

    const text = window.prompt(
      `SMS naar ${raw}`,
      settings.default_sms_text || ""
    );

    if (text === null) return;

    const message = String(text || "").trim();

    if (!message) {
      alert("SMS tekst ontbreekt.");
      return;
    }

    try {
      await tryFetchJson(["/api/communications/sms"], {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          to: raw,
          text: message,
        }),
      });

      alert(`SMS verstuurd naar ${raw}`);
    } catch (err) {
      alert(err?.message || "SMS verzenden mislukt.");
    }

    return;
  }

  if (c === "3" || c === "whatsapp" || c === "app") {
    if (settings.whatsapp_enabled === false) {
      alert("WhatsApp is niet actief in Communicatie-instellingen.");
      return;
    }

    const whatsappNumber = normalized.replace(/[^\d]/g, "");
    const text = String(settings.default_whatsapp_text || "").trim();
    const suffix = text ? `?text=${encodeURIComponent(text)}` : "";

    window.open(`https://wa.me/${whatsappNumber}${suffix}`, "_blank", "noopener,noreferrer");
  }
}

function upsertById(arr, item) {
  const id = item?.id;
  if (id === null || id === undefined) return arr;
  const idx = arr.findIndex((x) => String(x.id) === String(id));
  if (idx === -1) return [item, ...arr];
  const copy = arr.slice();
  copy[idx] = { ...copy[idx], ...item };
  return copy;
}

function removeById(arr, id) {
  return arr.filter((x) => String(x.id) !== String(id));
}

function euro(n) {
  const x = Number(n || 0);
  if (!Number.isFinite(x)) return "€ 0,00";
  try {
    return x.toLocaleString("nl-NL", { style: "currency", currency: "EUR" });
  } catch {
    return `€ ${x.toFixed(2)}`;
  }
}

function isoDate(s) {
  const t = String(s || "").slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(t) ? t : "";
}

function formatNlDate(s) {
  const iso = isoDate(s);
  if (!iso) return "";
  const [yyyy, mm, dd] = iso.split("-");
  return `${dd}-${mm}-${yyyy}`;
}

function addDaysIso(iso, days) {
  const base = isoDate(iso);
  const n = Number(days || 0);
  if (!base || !Number.isFinite(n)) return "";

  const [y, m, d] = base.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  dt.setDate(dt.getDate() + Math.trunc(n));

  const yy = dt.getFullYear();
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const dd = String(dt.getDate()).padStart(2, "0");

  return `${yy}-${mm}-${dd}`;
}

function normalizeSpokenInvoiceNumber(raw) {
  const s = String(raw || "").trim().toLowerCase();
  if (!s) return "";

  const map = {
    nul: "0",
    null: "0",
    zero: "0",
    een: "1",
    "één": "1",
    twee: "2",
    drie: "3",
    vier: "4",
    vijf: "5",
    zes: "6",
    zeven: "7",
    acht: "8",
    negen: "9",
  };

  const parts = s
    .replace(/-/g, " ")
    .replace(/\./g, " ")
    .replace(/,/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .filter(Boolean);

  if (!parts.length) return "";

  let out = "";
  let ok = true;

  for (const p of parts) {
    if (/^\d+$/.test(p)) {
      out += p;
    } else if (map[p]) {
      out += map[p];
    } else {
      ok = false;
      break;
    }
  }

  if (!ok) {
    out = s.replace(/[^\d]/g, "");
  }

  if (!out) return "";

  return out.padStart(4, "0");
}

function parseDutchDateToISO(raw) {
  const s0 = safeTrim(raw);
  if (!s0) return "";

  const digits = s0.replace(/[^\d]/g, "");

  if (digits.length === 8) {
    const dd = parseInt(digits.slice(0, 2), 10);
    const mm = parseInt(digits.slice(2, 4), 10);
    const yyyy = parseInt(digits.slice(4, 8), 10);
    if (yyyy >= 1900 && yyyy <= 2100 && mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31) {
      const iso = `${String(yyyy).padStart(4, "0")}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
      const d = new Date(`${iso}T00:00:00`);
      if (!Number.isNaN(d.getTime())) return iso;
    }
  }

  if (digits.length === 6) {
    const dd = parseInt(digits.slice(0, 2), 10);
    const mm = parseInt(digits.slice(2, 4), 10);
    const yy = parseInt(digits.slice(4, 6), 10);
    const yyyy = 2000 + yy;
    if (yyyy >= 1900 && yyyy <= 2100 && mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31) {
      const iso = `${String(yyyy).padStart(4, "0")}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
      const d = new Date(`${iso}T00:00:00`);
      if (!Number.isNaN(d.getTime())) return iso;
    }
  }

  const s = norm(s0).replace(/[\.\,]/g, " ");
  const tokens = s.split(" ").filter(Boolean);

  const monthMap = {
    jan: 1,
    januari: 1,
    feb: 2,
    februari: 2,
    mrt: 3,
    maart: 3,
    apr: 4,
    april: 4,
    mei: 5,
    jun: 6,
    juni: 6,
    jul: 7,
    juli: 7,
    aug: 8,
    augustus: 8,
    sep: 9,
    sept: 9,
    september: 9,
    okt: 10,
    oktober: 10,
    nov: 11,
    november: 11,
    dec: 12,
    december: 12,
  };

  const splitMore = [];
  for (const t of tokens) {
    const parts = t.split(/[-/]/g).filter(Boolean);
    splitMore.push(...parts);
  }
  const tt = splitMore.filter(Boolean);

  if (tt.length >= 2) {
    const d1 = parseInt(tt[0], 10);
    const mWord = tt[1];
    const m1 = monthMap[mWord];

    if (Number.isFinite(d1) && m1) {
      let y1 = null;
      if (tt.length >= 3) {
        const yTry = parseInt(tt[2], 10);
        if (Number.isFinite(yTry)) y1 = yTry;
      }
      if (!y1) y1 = new Date().getFullYear();
      if (y1 < 100) y1 = 2000 + y1;

      if (y1 >= 1900 && y1 <= 2100 && d1 >= 1 && d1 <= 31) {
        const iso = `${String(y1).padStart(4, "0")}-${String(m1).padStart(2, "0")}-${String(d1).padStart(2, "0")}`;
        const d = new Date(`${iso}T00:00:00`);
        if (!Number.isNaN(d.getTime())) return iso;
      }
    }
  }

  if (tt.length >= 3) {
    const dd = parseInt(tt[0], 10);
    const mm = parseInt(tt[1], 10);
    let yyyy = parseInt(tt[2], 10);

    if (Number.isFinite(yyyy) && yyyy < 100) yyyy = 2000 + yyyy;

    if (yyyy >= 1900 && yyyy <= 2100 && mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31) {
      const iso = `${String(yyyy).padStart(4, "0")}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
      const d = new Date(`${iso}T00:00:00`);
      if (!Number.isNaN(d.getTime())) return iso;
    }
  }

  return "";
}

function speechDigitsPreserveZeros(raw) {
  const s = String(raw || "").trim().toLowerCase();
  if (!s) return "";

  const map = {
    "nul": "0",
    "null": "0",
    "zero": "0",
    "een": "1",
    "één": "1",
    "twee": "2",
    "drie": "3",
    "vier": "4",
    "vijf": "5",
    "zes": "6",
    "zeven": "7",
    "acht": "8",
    "negen": "9",
  };

  const cleaned = s
    .replace(/-/g, " ")
    .replace(/\./g, " ")
    .replace(/,/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  const parts = cleaned.split(" ").filter(Boolean);
  if (!parts.length) return "";

  let out = "";
  let allKnown = true;

  for (const p of parts) {
    if (/^\d+$/.test(p)) {
      out += p;
    } else if (map[p]) {
      out += map[p];
    } else {
      allKnown = false;
      break;
    }
  }

  if (allKnown && out) return out;

  // fallback: alleen cijfers uit de tekst halen
  const digits = cleaned.replace(/[^\d]/g, "");
  return digits;
}

function decimal2OrEmptyString(s) {
  const raw = String(s || "").trim();
  if (!raw) return "";
  const cleaned = raw.replace(/,/g, ".").replace(/[^\d.]/g, "");
  const parts = cleaned.split(".");
  const a = parts[0] || "";
  const b = (parts[1] || "").slice(0, 2);
  if (parts.length === 1) return a;
  return `${a}.${b}`;
}

function punctToChar(t) {
  const x = norm(t);
  if (x === "punt") return ".";
  if (x === "komma") return ",";
  if (x === "dubbele punt" || x === "dubbelpunt") return ":";
  if (x === "puntkomma") return ";";
  if (x === "vraagteken") return "?";
  if (x === "uitroepteken") return "!";
  if (x === "nieuwe regel" || x === "enter") return "\n";
  return null;
}

function normalizeDbStatus(status) {
  const s = String(status || "").trim().toUpperCase();

  if (!s) return "DRAFT";

  if (s === "DRAFT" || s === "CONCEPT") return "DRAFT";
  if (s === "FINAL" || s === "GEFACTUREERD" || s === "FACTUUR") return "FINAL";
  if (s === "PARTIAL" || s === "DEELBETALING") return "PARTIAL";
  if (s === "PAID" || s === "BETAALD") return "PAID";

  return s;
}

function statusLabel(status) {
  const s = normalizeDbStatus(status);

  switch (s) {
    case "DRAFT":
      return "Concept";
    case "FINAL":
      return "Gefactureerd";
    case "PARTIAL":
      return "Deelbetaling";
    case "PAID":
      return "Betaald";
    default:
      return s ? s[0] + s.slice(1).toLowerCase() : "";
  }
}


function boolPaidLabel(openAmount) {
  return openAmount <= 0.00001 ? "betaald" : "open";
}

function normalizeVatRate(v) {
  const s = String(v ?? "").toLowerCase().trim();
  if (["hoog", "high", "21", "21%", "h"].includes(s)) return "hoog";
  if (["laag", "low", "9", "9%", "l"].includes(s)) return "laag";
  if (["0", "0%", "nul", "zero"].includes(s)) return "0";
  if (["verlegd", "reverse", "btw verlegd"].includes(s)) return "verlegd";
  return "hoog";
}

function vatPercentForRate(rate) {
  const r = normalizeVatRate(rate);
  if (r === "hoog") return 21;
  if (r === "laag") return 9;
  return 0;
}

function vatLabelForRate(rate) {
  const r = normalizeVatRate(rate);
  if (r === "hoog") return "21% btw";
  if (r === "laag") return "9% btw";
  if (r === "0") return "0% btw";
  if (r === "verlegd") return "Btw verlegd";
  return "21% btw";
}

function pickOrgDefaultVatRate(org) {
  if (!org) return "hoog";

  const raw =
    org.vat_rate ??
    org.default_vat_rate ??
    org.default_vat_type ??
    org.vat_rate_default ??
    org.vat_type ??
    org.btw_type ??
    org.btw_soort ??
    org.invoice_vat_rate ??
    "hoog";

  return normalizeVatRate(raw);
}

function pickOrgVatNumber(org) {
  if (!org) return "";
  return (
    org.vat_number ||
    org.vat_no ||
    org.btw_number ||
    org.btw_nummer ||
    org.tax_number ||
    ""
  );
}

function pickOrgGrekeningPercent(org) {
  if (!org) return 0;
  const raw =
    org.g_account_percentage ??
    org.grekening_percentage ??
    org.g_rekening_percentage ??
    org.g_percentage ??
    org.g_account_percent ??
    0;

  const n = Number(raw);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.max(0, Math.min(100, n));
}

function lineQty(line) {
  return Number(line?.quantity ?? line?.qty ?? 0);
}

function lineUnitPrice(line) {
  return Number(line?.unit_price ?? line?.price ?? 0);
}

function lineVatRate(line) {
  // De server bewaart verlegging als percentage 0 plus vat_category="verlegd".
  // Die categorie gaat vóór het numerieke percentage.
  if (normalizeVatRate(line?.vat_category) === "verlegd" &&
      /verlegd/i.test(String(line?.vat_category ?? ""))) return "verlegd";
  return normalizeVatRate(line?.vat_rate ?? line?.vat ?? "hoog");
}

// vFCT-034: Projectbeheer gebruikt een rijke teksteditor. Facturen gebruiken
// platte tekst. Verwijder alleen opmaak (geen bedragen, aantallen of btw),
// maar behoud wel alinea's en handmatige regeleinden.
function invoicePlainText(value) {
  const raw = String(value ?? "");
  if (!raw.trim()) return "";

  // Gewone, handmatig getypte tekst blijft ongewijzigd.
  // Ook een letterlijke vergelijking zoals "prijs < 100" is geen HTML.
  const hasHtml = /<\/?(?:div|p|span|br|strong|b|em|i|u|font|ul|ol|li|h[1-6]|blockquote|table|thead|tbody|tr|td|th|section|article)\b[^>]*>/i.test(raw);
  const hasEntity = /&(?:nbsp|amp|lt|gt|quot|apos|#\d+|#x[0-9a-f]+);/i.test(raw);
  if (!hasHtml && !hasEntity) return raw.trim();

  if (typeof DOMParser === "undefined") {
    // Alleen in een omgeving zonder browser-parser: opmaak verwijderen.
    return raw
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/(?:p|div|li|tr|h[1-6])\s*>/gi, "\n")
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/gi, " ")
      .replace(/&amp;/gi, "&")
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/[ \t]+\n/g, "\n")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
  }

  // DOMParser verwerkt HTML-entiteiten en geneste opmaak betrouwbaar, zonder
  // de HTML aan de pagina toe te voegen of scripts uit te voeren.
  const documentHtml = new DOMParser().parseFromString(raw, "text/html");
  let result = "";
  const newLine = () => {
    if (result && !result.endsWith("\n")) result += "\n";
  };
  const blockTags = new Set([
    "p", "div", "section", "article", "blockquote", "tr",
    "h1", "h2", "h3", "h4", "h5", "h6", "ul", "ol", "table"
  ]);

  function walk(node) {
    if (node.nodeType === 3) {
      result += String(node.nodeValue || "").replace(/\u00a0/g, " ");
      return;
    }
    if (node.nodeType !== 1) return;
    const tag = node.tagName.toLowerCase();
    if (["script", "style", "noscript", "iframe", "svg", "head"].includes(tag)) return;
    if (tag === "br") {
      newLine();
      return;
    }
    if (tag === "li") {
      newLine();
      result += "• ";
    } else if (blockTags.has(tag)) {
      newLine();
    }
    for (const child of node.childNodes) walk(child);
    if (blockTags.has(tag) || tag === "li") newLine();
    if (tag === "td" || tag === "th") result += "  ";
  }

  for (const child of documentHtml.body.childNodes) walk(child);
  return result
    .replace(/\r/g, "")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n[ \t]+/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

// vFCT-036: volg de regeltypen uit Projectbeheer/Offertes, met oud materiaal als Artikel.
function invoiceLineType(line) {
  const type = String(line?.line_type ?? line?.lineType ?? line?.type ?? "item").trim().toLowerCase();
  if (["text", "tekst"].includes(type)) return "text";
  if (["heading", "header", "kop"].includes(type)) return "heading";
  if (["subtotal", "subtotaal"].includes(type)) return "subtotal";
  if (["total", "totaal"].includes(type)) return "total";
  return "item";
}

function invoiceAmountLine(line) {
  return invoiceLineType(line) === "item";
}

function lineDescription(line) {
  return invoicePlainText(line?.description);
}

// vFCT-041: ook bestaande factuurregels valideren voordat ze definitief worden
// of via e-mail/UBL worden verstuurd. Een HTML-regeleinde is geen omschrijving.
function invalidInvoiceArticleIndex(rows) {
  return (Array.isArray(rows) ? rows : []).findIndex(
    (ln) => invoiceAmountLine(ln) && !lineDescription(ln)
  );
}

function calcInvoiceTotals(lines) {
  const vatMap = new Map();
  let subtotal = 0;

  const cleanLines = (Array.isArray(lines) ? lines : []).filter((ln) => {
    return invoiceAmountLine(ln) && lineQty(ln) > 0; // ook financieel geldige regels zonder omschrijving tellen mee
  });

  cleanLines.forEach((ln) => {
    const qty = lineQty(ln);
    const unit = lineUnitPrice(ln);
    const rate = lineVatRate(ln);
    const base = qty * unit;
    const pct = vatPercentForRate(rate);
    const vatAmount = base * (pct / 100);

    subtotal += base;

    if (!vatMap.has(rate)) {
      vatMap.set(rate, {
        rate,
        label: vatLabelForRate(rate),
        percent: pct,
        base: 0,
        vat: 0,
      });
    }

    const row = vatMap.get(rate);
    row.base += base;
    row.vat += vatAmount;
  });

  const vatRows = Array.from(vatMap.values());
  const vatTotal = vatRows.reduce((s, x) => s + x.vat, 0);
  const total = subtotal + vatTotal;

  const hasNormalVat = vatRows.some((x) => x.rate === "hoog" || x.rate === "laag");
  const allVerlegd = vatRows.length > 0 && vatRows.every((x) => x.rate === "verlegd");
  const allZero = vatRows.length > 0 && vatRows.every((x) => x.rate === "0");

return {
  subtotal,
  vatRows,
  vatTotal,
  total,
  hasNormalVat,
  allVerlegd,
  allZero,
  hideVatColumnOnInvoice: false,
};
}

function splitMultiline(text) {
  return String(text || "")
    .split(/\r?\n/)
    .map((s) => s.trim())
    .filter(Boolean);
}

// vFCT-039: de kop hoort bij de eerste artikelregel, niet bij voorafgaande Tekst.
function InvoiceArticleHeader({ popupMode, hideVatColumnOnInvoice }) {
  return (
<div
  style={{
    display: "grid",
    gridTemplateColumns:
      popupMode === "preview"
        ? hideVatColumnOnInvoice
          ? "70px 1fr 110px 110px"
          : "70px 1fr 110px 110px 70px"
        : hideVatColumnOnInvoice
          ? "70px 1fr 110px 110px 56px"
          : "70px 1fr 110px 110px 70px 56px",
    gap: 12,
    borderBottom: "2px solid #444",
    paddingBottom: 8,
    fontWeight: 700,
    fontSize: "11pt",
    marginTop: 8,
  }}
>
  <div style={{ textAlign: "right" }}>Aantal</div>
  <div>Omschrijving</div>
  <div style={{ textAlign: "right" }}>Bedrag</div>
  <div style={{ textAlign: "right" }}>Totaal</div>
  {!hideVatColumnOnInvoice && (
    <div style={{ textAlign: "right" }}>Btw</div>
  )}
  {popupMode !== "preview" && <div></div>}
</div>
  );
}

// ---------------- component ----------------
const emptyForm = {
  id: null,
  organisation_id: "",
  contact_id: "",
  template_id: "",
  invoice_intro_text: "",
  invoice_payment_text: "",
  invoice_footer_text: "",
  invoice_number: "",
  series_code: "",
  invoice_date: "",
  due_date: "",
  status: "DRAFT",
  notes: "",

  subtotal: 0,
  vat_total: 0,
  total: 0,

  created_at: "",
  updated_at: "",
};

function todayLocalIso() {
  return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 10);
}

export default function Facturen() {
  const rawUser =
    sessionStorage.getItem("user") ||
    localStorage.getItem("user") ||
    "";

  let role = "user";

  try {
    role = JSON.parse(rawUser || "{}")?.role || "user";
  } catch {}

  const isReadonly = String(role || "").toLowerCase() === "readonly";

  const VERSION = "vFCT-046";

  // data
  const [items, setItems] = useState([]);
  const [orgs, setOrgs] = useState([]);
  const [contacts, setContacts] = useState([]);
const [invoiceSettings, setInvoiceSettings] = useState({});
const [invoiceDocumentSettings, setInvoiceDocumentSettings] = useState({});
const [letterheadSettings, setLetterheadSettings] = useState({});
const [invoiceTemplates, setInvoiceTemplates] = useState([]);
const [projectItems, setProjectItems] = useState([]);
const [selectedProjectLineId, setSelectedProjectLineId] = useState("__manual__");
const [includeChildProjects, setIncludeChildProjects] = useState(false);

  function formatMoney(val) {
  return Number(val || 0).toLocaleString("nl-NL", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

  // selectie + form
  const [selectedId, setSelectedId] = useState(null);
  const [form, setForm] = useState(emptyForm);

  // NIEUW: factuur lock logica
const isLocked = form?.status ? form.status !== "DRAFT" : false;

// Admin mag alles
const isAdmin = role.toLowerCase() === "admin";

// Eindresultaat: readonly als:
// - readonly user
// - OF factuur niet meer DRAFT en geen admin
const isFormDisabled = isReadonly || (isLocked && !isAdmin);

  const [dueDateManual, setDueDateManual] = useState(false);

  // org detail (voor correspondentieadres)
  const [orgDetail, setOrgDetail] = useState(null);

  // payments
  const [payments, setPayments] = useState([]);
  const [lines, setLines] = useState([]);
  const [lineDraft, setLineDraft] = useState({
    line_type: "item",
    quantity: 1,
    description: "",
    unit_price: "",
    vat_rate: "hoog",
  });

useEffect(() => {
  if (!lineDescRef.current) return;

  setTimeout(() => {
    try {
      lineDescRef.current.style.height = "auto";
      lineDescRef.current.style.height = `${lineDescRef.current.scrollHeight}px`;
    } catch {}
  }, 0);
}, [lineDraft.description]);

const qtyInputRef = useRef(null);
  const lineDescRef = useRef(null);
  const linePriceRef = useRef(null);
  const lineVatRef = useRef(null);
  const [editingLineId, setEditingLineId] = useState(null);
  const [payDraft, setPayDraft] = useState({
  paid_on: new Date().toLocaleDateString("en-CA"),
  amount: "",
  notes: "",
});

const [payError, setPayError] = useState(null);

  // cursor index
  const [listIndex, setListIndex] = useState(-1);

  // ui status
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [saveError, setSaveError] = useState(null);
const [flash, setFlash] = useState("");
const [lineError, setLineError] = useState(null);
const [reloadKey, setReloadKey] = useState(0);
const [sendingEmail, setSendingEmail] = useState(false);

  // AI popup
  const [aiOpen, setAiOpen] = useState(false);
  const [aiBusy, setAiBusy] = useState(false);
  const [aiText, setAiText] = useState("");
  const [aiSource, setAiSource] = useState("page"); // page | popup
  const aiTextRef = useRef(null);

  // vFCT-PTT-05: helper om de lijst opnieuw te laden (gebruik door knop 'Vernieuw' en voice)
  function loadList() {
    setReloadKey((k) => k + 1);
  }

const [speechInfo, setSpeechInfo] = useState("");
  const [hideVoiceError, setHideVoiceError] = useState(false);
  const prevVoiceErrorRef = useRef("");
  const [pendingSpeechSearch, setPendingSpeechSearch] = useState(false);

  // zoek + filters
  const [q, setQ] = useState(getParam("q"));
  const [organisationFilterId, setOrganisationFilterId] = useState(getParam("organisation_id"));

  // dropdown filters (grid)
  const EMPTY_VAL = "__EMPTY__";
  const [zoeknaamFilter, setZoeknaamFilter] = useState("");
  const [contactFilter, setContactFilter] = useState("");
  const [invoiceNrFilter, setInvoiceNrFilter] = useState("");
  const [invoiceDateFilter, setInvoiceDateFilter] = useState("");
const [totaalFilter, setTotaalFilter] = useState("");
const [openstaandFilter, setOpenstaandFilter] = useState("");
  const [telFilter, setTelFilter] = useState("");
  const [mobFilter, setMobFilter] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  const [cityFilter, setCityFilter] = useState("");
  const [countryFilter, setCountryFilter] = useState("");
const [statusFilter, setStatusFilter] = useState("");
  const [companyCodeFilter, setCompanyCodeFilter] = useState("");
  const [paidFilter, setPaidFilter] = useState("");
  const [mode, setMode] = useState("search");
  const isFormLocked = mode !== "form";
  const [sort, setSort] = useState({ key: "invoice_date", dir: "desc" }); // standaard nieuw->oud
  const [showLinesPopup, setShowLinesPopup] = useState(false);
  const [popupLines, setPopupLines] = useState([]);
const [popupMode, setPopupMode] = useState("edit");
const [silentDocumentPreview, setSilentDocumentPreview] = useState(false);
const [letterheadPdfPreviewUrl, setLetterheadPdfPreviewUrl] = useState("");
const [letterheadPdfPreviewBusy, setLetterheadPdfPreviewBusy] = useState(false);
const [letterheadPdfPreviewError, setLetterheadPdfPreviewError] = useState("");
const letterheadPdfPreviewHtmlRef = useRef("");
const [popupWindow, setPopupWindow] = useState({
  x: 80,
  y: 50,
  width: 1180,
  height: 780,
});

const popupDragRef = useRef({
  dragging: false,
  startMouseX: 0,
  startMouseY: 0,
  startX: 0,
  startY: 0,
});

useEffect(() => {
  if (!showLinesPopup) return;

  focusFirstPopupField();

  const w = Math.min(window.innerWidth - 80, 1180);
  const h = Math.min(window.innerHeight - 80, 780);
  const x = Math.max(20, Math.round((window.innerWidth - w) / 2));
  const y = Math.max(20, Math.round((window.innerHeight - h) / 2));

  setPopupWindow({ x, y, width: w, height: h });
}, [showLinesPopup]);

useEffect(() => {
  function onMouseMove(e) {
    if (!popupDragRef.current.dragging) return;

    const dx = e.clientX - popupDragRef.current.startMouseX;
    const dy = e.clientY - popupDragRef.current.startMouseY;

    setPopupWindow((prev) => {
      const nextX = popupDragRef.current.startX + dx;
      const nextY = popupDragRef.current.startY + dy;

      const maxX = Math.max(20, window.innerWidth - prev.width - 20);
      const maxY = Math.max(20, window.innerHeight - prev.height - 20);

      return {
        ...prev,
        x: Math.min(Math.max(20, nextX), maxX),
        y: Math.min(Math.max(20, nextY), maxY),
      };
    });
  }

  function onMouseUp() {
    popupDragRef.current.dragging = false;
  }

  window.addEventListener("mousemove", onMouseMove);
  window.addEventListener("mouseup", onMouseUp);

  return () => {
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", onMouseUp);
  };
}, []);

function startPopupDrag(e) {
  popupDragRef.current = {
    dragging: true,
    startMouseX: e.clientX,
    startMouseY: e.clientY,
    startX: popupWindow.x,
    startY: popupWindow.y,
  };
}

useEffect(() => {
  return () => {
    if (letterheadPdfPreviewUrl) {
      try { URL.revokeObjectURL(letterheadPdfPreviewUrl); } catch {}
    }
  };
}, [letterheadPdfPreviewUrl]);

  // refs
  const searchRef = useRef(null);
  const rowRefs = useRef([]);
  const reopenInvoiceHandledRef = useRef(false);
  const midScrollRef = useRef(null);
  const rightScrollRef = useRef(null);
const popupPrintRef = useRef(null);
const letterheadPdfPreviewFrameRef = useRef(null);

  // right form refs (focus order)
  const orgRef = useRef(null);
  const contactRef = useRef(null);
  const invNumRef = useRef(null);
  const invDateRef = useRef(null);
  const dueDateRef = useRef(null);
  const statusRef = useRef(null);
  const payDateRef = useRef(null);
  const payAmtRef = useRef(null);
  const payNotesRef = useRef(null);

const focusOrderRefs = useMemo(
  () => [
    orgRef,
    contactRef,
    invNumRef,
    invDateRef,
    dueDateRef,
    payDateRef,
    payAmtRef,
    payNotesRef,
    statusRef,
  ],
  []
);

  const [focusedKey, setFocusedKey] = useState("");

function formHasId() {
  const id = form.id || selectedId;
  return id !== null && id !== undefined && String(id).length > 0;
}

  // ---------- LOAD ORGS ----------

useEffect(() => {
  let cancelled = false;

  async function loadProjectItems() {
    try {
      const data = await tryFetchJson(["/api/projectmanagement"]);
      if (!cancelled) setProjectItems(Array.isArray(data) ? data : []);
    } catch {
      if (!cancelled) setProjectItems([]);
    }
  }

  loadProjectItems();

  return () => {
    cancelled = true;
  };
}, []);

  useEffect(() => {
  let cancelled = false;

  async function loadInvoiceSettings() {
    try {
      const data = await tryFetchJson(["/api/invoice-settings"]);
      if (!cancelled) {
        setInvoiceSettings(data && typeof data === "object" ? data : {});
      }
    } catch {
      if (!cancelled) {
        setInvoiceSettings({});
      }
    }
  }

  loadInvoiceSettings();

  return () => {
    cancelled = true;
  };
}, []);
  


useEffect(() => {
  let cancelled = false;

  async function loadInvoiceDocumentSettings() {
    const selectedOrg = orgs.find(
      (x) => String(x.id || "") === String(form.organisation_id || "")
    );

    const selectedRow = items.find(
      (x) => String(x.id || "") === String(form.id || selectedId || "")
    );

    const companyCodeId =
      orgDetail?.company_code_id ||
      selectedOrg?.company_code_id ||
      selectedRow?.company_code_id ||
      "";

    const qs = companyCodeId
      ? `?company_code_id=${encodeURIComponent(companyCodeId)}`
      : "";

    try {
      const data = await tryFetchJson([
        `/api/company-section-settings/mkb_invoices${qs}`,
      ]);

      if (!cancelled) {
        setInvoiceDocumentSettings(data?.settings || {});
      }
    } catch {
      if (!cancelled) {
        setInvoiceDocumentSettings({});
      }
    }

    try {
      const letterheadData = await tryFetchJson([
        `/api/company-section-settings/mkb_letterhead${qs}`,
      ]);

      if (!cancelled) {
        setLetterheadSettings(letterheadData?.settings || {});
      }
    } catch {
      if (!cancelled) {
        setLetterheadSettings({});
      }
    }
  }

  loadInvoiceDocumentSettings();

  return () => {
    cancelled = true;
  };
}, [
  form.id,
  selectedId,
  form.organisation_id,
  orgDetail?.company_code_id,
  orgs,
  items,
]);


useEffect(() => {
  let cancelled = false;

  async function loadInvoiceTemplates() {
    try {
      const data = await tryFetchJson(["/api/invoice-templates?active=1", "/api/invoice-templates"]);
      if (!cancelled) setInvoiceTemplates(Array.isArray(data) ? data : []);
    } catch {
      if (!cancelled) setInvoiceTemplates([]);
    }
  }

  loadInvoiceTemplates();

  return () => {
    cancelled = true;
  };
}, []);

function applyInvoiceTemplate(templateId) {
  const tid = String(templateId || "");
  const tpl = invoiceTemplates.find((x) => String(x.id || "") === tid) || null;

  if (!tpl) {
    setForm((prev) => ({
      ...prev,
      template_id: "",
      invoice_intro_text: invoiceDocumentSettings.intro_text || "",
      invoice_payment_text:
        invoiceDocumentSettings.payment_text ||
        invoiceSettings.payment_text ||
        "",
      invoice_footer_text:
        invoiceDocumentSettings.footer_text ||
        invoiceSettings.footer_text ||
        "",
    }));
    return;
  }

  setForm((prev) => ({
    ...prev,
    template_id: tid,
    invoice_intro_text:
      tpl.intro_text ||
      invoiceDocumentSettings.intro_text ||
      "",
    invoice_payment_text:
      tpl.payment_text ||
      invoiceDocumentSettings.payment_text ||
      invoiceSettings.payment_text ||
      "",
    invoice_footer_text:
      tpl.footer_text ||
      invoiceDocumentSettings.footer_text ||
      invoiceSettings.footer_text ||
      "",
    notes: prev.notes || tpl.subject || "",
  }));
}

  useEffect(() => {
    let cancelled = false;

    async function loadOrgs() {
      try {
        const orgData = await tryFetchJson(["/api/organisations?q=", "/api/organisations"]);
        if (!cancelled) setOrgs(Array.isArray(orgData) ? orgData : []);
      } catch {
        if (!cancelled) setOrgs([]);
      }
    }

    loadOrgs();
    return () => {
      cancelled = true;
    };
  }, []);

function pickOrgName(o) {
  return o?.name || o?.naam || o?.bedrijfsnaam || "";
}

function pickOrgSearchName(o) {
  return (
    o?.search_name ||
    o?.zoeknaam ||
    o?.zoek_naam ||
    o?.organisation_search_name ||
    o?.organisatie_zoeknaam ||
    pickOrgName(o)
  );
}

function isPrivateRelation(o) {
  const entityType = String(
    o?.relation_entity_type ||
    o?.relation_type ||
    o?.entity_type ||
    ""
  )
    .toLowerCase()
    .trim();

  return (
    entityType === "private" ||
    entityType === "particulier" ||
    entityType === "person" ||
    entityType === "persoon"
  );
}

function pickOrgSearchNameFromRow(it) {
  const org =
    orgs.find((o) => String(o.id) === String(it?.organisation_id || "")) ||
    null;

  return (
    pickOrgSearchName(org) ||
    it?.organisation_search_name ||
    it?.organisation_zoeknaam ||
    it?.search_name ||
    it?.organisation_name ||
    ""
  );
}

function pickCompanyCodeName(row) {
  return (
    row?.company_code_name ||
    row?.bedrijfscode_naam ||
    row?.bedrijfscode ||
    row?.company_code ||
    ""
  );
}

function pickCompanyCodeNameFromOrganisation(org) {
  return (
    org?.company_code_name ||
    org?.bedrijfscode_naam ||
    org?.bedrijfscode ||
    org?.company_code ||
    ""
  );
}

function pickContactFullName(c) {
  const fn = c?.first_name || c?.voornaam || "";
  const tv = c?.name_prefix || c?.tussenvoegsels || c?.tussenvoegsel || "";
  const ln = c?.last_name || c?.achternaam || "";
  const merged = [fn, tv, ln].map(safeTrim).filter(Boolean).join(" ");
  const full = safeTrim(c?.full_name || c?.naam || "");
  return merged || full || "";
}

function pickContactNameFromRow(it) {
  const fn = safeTrim(it?.contact_first_name || "");
  const tv = safeTrim(it?.contact_name_prefix || "");
  const ln = safeTrim(it?.contact_last_name || "");
  const merged = [fn, tv, ln].filter(Boolean).join(" ").trim();
  const fallbackName = safeTrim(it?.contact_name || "");
  // De backend kan bij een ontbrekend contact de losse tekst "," teruggeven.
  return merged || (/^[,\s]*$/.test(fallbackName) ? "" : fallbackName);
}

// ---------- LOAD CONTACTS (voor gekozen relatie) ----------
// Bij Particulieren is Contactpersoon niet van toepassing.
useEffect(() => {
  let cancelled = false;

  async function loadContacts() {
    try {
      const selectedRelation = orgs.find(
        (o) => String(o.id) === String(form?.organisation_id || "")
      );

      const isPrivate = isPrivateRelation(selectedRelation);

      if (!form?.organisation_id || isPrivate) {
        if (!cancelled) setContacts([]);
        return;
      }

const data = await tryFetchJson([
  `/api/contacts?organisation_id=${encodeURIComponent(form.organisation_id)}`
]);

      if (!cancelled) setContacts(Array.isArray(data) ? data : []);
    } catch {
      if (!cancelled) setContacts([]);
    }
  }

  loadContacts();
  return () => {
    cancelled = true;
  };
}, [form?.organisation_id, orgs]);

// ---------- LOAD INVOICES ----------
const serverQuery = useMemo(() => {
  const p = new URLSearchParams();
  if (q) p.set("q", q);
  return p.toString();
}, [q]);

useEffect(() => {
  let cancelled = false;

  async function loadItems() {
    setLoading(true);
    setError(null);

    try {
      const data = await tryFetchJson(
        [`/api/invoices?${serverQuery}`, "/api/invoices"]
      );

      if (cancelled) return;

      const arr = Array.isArray(data) ? data : [];

      // 🔥 HIER ZAT HET PROBLEEM
      setItems(arr);

    } catch (e) {
      if (!cancelled) setError(e?.message || String(e));
    } finally {
      if (!cancelled) setLoading(false);
    }
  }

  loadItems();

  return () => {
    cancelled = true;
  };
}, [serverQuery, reloadKey]);

  // ---------- GRID OPTIONS ----------
const zoeknaamOptions = useMemo(() => {
    const set = new Set(
      items
        .map((x) => safeTrim(pickOrgSearchNameFromRow(x)))
        .filter(Boolean)
    );

    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items, orgs]);

  const contactOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(pickContactNameFromRow(x))).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

  const invoiceNrOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(x.invoice_number || "")).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

  const invoiceDateOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(isoDate(x.invoice_date) || "")).filter(Boolean));
    // nieuw->oud
    return Array.from(set).sort((a, b) => (a === b ? 0 : a < b ? 1 : -1));
  }, [items]);

const totaalOptions = [...new Set(items.map(x => x.total))];
const openstaandOptions = [...new Set(items.map(x => x.openstaand))];

const telOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(x.org_phone || "")).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

  const mobOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(x.org_mobile || "")).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

  const emailOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(x.org_email || "")).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

  const cityOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(x.org_city || "")).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

  const countryOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(x.org_country || "")).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

  const companyCodeOptions = useMemo(() => {
    const set = new Set(items.map((x) => safeTrim(pickCompanyCodeName(x))).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
  }, [items]);

const statusOptions = useMemo(() => {
  const order = ["Concept", "Gefactureerd", "Deelbetaling", "Betaald"];

  const arr = Array.from(
    new Set(items.map((x) => statusLabel(x.status)).filter(Boolean))
  );

  return arr.sort((a, b) => {
    const ia = order.indexOf(a);
    const ib = order.indexOf(b);
    if (ia !== -1 && ib !== -1) return ia - ib;
    if (ia !== -1) return -1;
    if (ib !== -1) return 1;
    return a.localeCompare(b, "nl");
  });
}, [items]);

  // paidFilter opties zijn (alle/open/betaald); wordt client-side berekend op basis van payments.
  // In grid tonen we status "open/betaald" op basis van payments in detail; voor grid gebruiken we server.status als indicatie.
  const paidOptions = ["open", "betaald"];

  // ---------- FILTER + SORT ----------
  const filteredItems = useMemo(() => {
    const qq = norm(q);
    const arr = items.slice();

    const byQ = (it) => {
      if (!qq) return true;
      const hay = norm(
        [
          it.organisation_name || "",
          pickContactNameFromRow(it),
          it.invoice_number || "",
          isoDate(it.invoice_date),
          it.org_city || "",
          it.org_country || "",
          it.status || "",
          pickCompanyCodeName(it),
        ].join(" ")
      );
      return hay.includes(qq);
    };

    const byCol = (it) => {
      const orgName = safeTrim(pickOrgSearchNameFromRow(it));
      const contactName = safeTrim(pickContactNameFromRow(it));
      const invNr = safeTrim(it.invoice_number || "");
      const invDt = safeTrim(isoDate(it.invoice_date) || "");
const tel = safeTrim(it.org_phone || "");
      const mob = safeTrim(it.org_mobile || "");
      const email = safeTrim(it.org_email || "");
      const city = safeTrim(it.org_city || "");
      const ctry = safeTrim(it.org_country || "");
      const companyCodeName = safeTrim(pickCompanyCodeName(it));
      const st = statusLabel(it.status);

      const match = (val, filt) => {
        if (!filt) return true;
        if (filt === EMPTY_VAL) return !safeTrim(val);
        return String(val) === String(filt);
      };

      if (!match(orgName, zoeknaamFilter)) return false;
      if (!match(contactName, contactFilter)) return false;
      if (!match(invNr, invoiceNrFilter)) return false;
      if (!match(invDt, invoiceDateFilter)) return false;
if (!match(it.total, totaalFilter)) return false;
if (!match(it.openstaand, openstaandFilter)) return false;
      if (!match(tel, telFilter)) return false;
      if (!match(mob, mobFilter)) return false;
      if (!match(email, emailFilter)) return false;
      if (!match(city, cityFilter)) return false;
      if (!match(ctry, countryFilter)) return false;
      if (!match(st, statusFilter)) return false;
      if (!match(companyCodeName, companyCodeFilter)) return false;

      // paidFilter: op grid-niveau hebben we geen payments per factuur geladen.
      // We gebruiken simpele heuristiek: status=gefactureerd => open/betaald onbekend (laat leeg), tenzij user filtert -> dan laten we alles door.
      if (!paidFilter) return true;
      // Als je wilt filteren op betaald/open: we laten dit nu nog "alle" (anders gaan we factuur-per-factuur payments ophalen: te zwaar).
      // Je kunt betaald/open wél rechts zien zodra je een factuur selecteert.
      return true;
    };

    return arr.filter((it) => {
      if (
        organisationFilterId &&
        String(it.organisation_id || "") !== String(organisationFilterId)
      ) {
        return false;
      }

      return byQ(it) && byCol(it);
    });
}, [
    items,
    orgs,
    q,
    zoeknaamFilter,
    contactFilter,
    invoiceNrFilter,
    invoiceDateFilter,
  totaalFilter,
  openstaandFilter,
    telFilter,
    mobFilter,
    emailFilter,
    cityFilter,
    countryFilter,
    statusFilter,
    companyCodeFilter,
    paidFilter,
    organisationFilterId,
  ]);

const sortedItems = useMemo(() => {
    const copy = filteredItems.slice();
    const dirMul = sort.dir === "desc" ? -1 : 1;

    const cmpText = (a, b) => {
      const aa = norm(a);
      const bb = norm(b);
      if (aa === bb) return 0;
      return aa < bb ? -1 : 1;
    };

    const cmpDate = (a, b) => {
      const aa = isoDate(a) || "";
      const bb = isoDate(b) || "";
      if (aa === bb) return 0;
      return aa < bb ? -1 : 1;
    };

    const customSort = (a, b) => {
      if (sort.key === "invoice_date") return dirMul * cmpDate(a.invoice_date, b.invoice_date);
      if (sort.key === "invoice_number") return dirMul * cmpText(a.invoice_number || "", b.invoice_number || "");
      if (sort.key === "org") return dirMul * cmpText(pickOrgSearchNameFromRow(a), pickOrgSearchNameFromRow(b));
      if (sort.key === "contact") return dirMul * cmpText(pickContactNameFromRow(a), pickContactNameFromRow(b));
if (sort.key === "totaal") return dirMul * ((Number(a.total || 0)) - (Number(b.total || 0)));
if (sort.key === "openstaand") return dirMul * ((Number(a.openstaand || 0)) - (Number(b.openstaand || 0)));
      if (sort.key === "city") return dirMul * cmpText(a.org_city || "", b.org_city || "");
      if (sort.key === "country") return dirMul * cmpText(a.org_country || "", b.org_country || "");
      if (sort.key === "status") return dirMul * cmpText(statusLabel(a.status), statusLabel(b.status));
      if (sort.key === "company_code") return dirMul * cmpText(pickCompanyCodeName(a), pickCompanyCodeName(b));
      return dirMul * cmpDate(a.invoice_date, b.invoice_date);
    };

    copy.sort(customSort);
    return copy;
  }, [filteredItems, sort, orgs]);

  useEffect(() => {
    if (loading || reopenInvoiceHandledRef.current) return;

    let requestedId = "";

    try {
      requestedId = safeTrim(
        sessionStorage.getItem("staffiq_reopen_invoice_id")
      );
    } catch {}

    if (!requestedId) {
      reopenInvoiceHandledRef.current = true;
      return;
    }

    const rowIndex = sortedItems.findIndex(
      (item) => String(item.id) === String(requestedId)
    );

    const row =
      rowIndex >= 0
        ? sortedItems[rowIndex]
        : items.find(
            (item) => String(item.id) === String(requestedId)
          );

    if (!row) {
      // De lijst kan nog opnieuw worden geladen. De sleutel blijft daarom
      // staan tot de gevraagde factuur daadwerkelijk is gevonden.
      return;
    }

    reopenInvoiceHandledRef.current = true;

    try {
      sessionStorage.removeItem("staffiq_reopen_invoice_id");
    } catch {}

    setQ("");
    setOrganisationFilterId("");
    resetAllGridFilters();
    setListIndex(rowIndex >= 0 ? rowIndex : 0);
    loadItemFromRow(row);
    setMode("form");

    setTimeout(() => {
      try {
        if (rowIndex >= 0) {
          scrollRowIntoView(rowIndex);
        }

        scrollRightTop();

        if (window.innerWidth <= 768) {
          focusFirstRightFieldMobile();
        } else {
          focusFirstRightField();
        }
      } catch {}
    }, 100);
  }, [loading, items, sortedItems]);

  const gridCount = Math.min(sortedItems.length, 9999);

  // ---------- LIST NAV HELPERS ----------
  function scrollMidTop() {
    try {
      if (midScrollRef.current) midScrollRef.current.scrollTop = 0;
    } catch {}
  }

  function scrollRightTop() {
    try {
      if (rightScrollRef.current) rightScrollRef.current.scrollTop = 0;
    } catch {}
  }

  function scrollRowIntoView(idx) {
    try {
      const el = rowRefs.current?.[idx];
      if (el && typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ block: "nearest" });
      }
    } catch {}
  }

  function clampIndex(idx, len) {
    const L = Number(len || 0);
    if (L <= 0) return -1;
    let x = Number.isFinite(idx) ? idx : 0;
    if (x < 0) x = 0;
    if (x > L - 1) x = L - 1;
    return x;
  }

  function ensureCursorExists() {
    const L = sortedItems.length;
    if (L <= 0) return -1;
    const idx = listIndex < 0 ? 0 : clampIndex(listIndex, L);
    if (idx !== listIndex) setListIndex(idx);
    return idx;
  }

  function moveCursor(delta) {
    setListIndex((prev) => {
      const L = sortedItems.length;
      if (L <= 0) return -1;
      const start = prev < 0 ? 0 : prev;
      const next = clampIndex(start + delta, L);
      setTimeout(() => scrollRowIntoView(next), 0);
      return next;
    });
  }



  function getFocusableElements() {
    const els = focusOrderRefs.map((r) => r?.current).filter(Boolean);
    return els.filter((el) => {
      try {
        if (el.disabled) return false;
        const rect = el.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      } catch {
        return false;
      }
    });
  }

  function focusFirstRightField() {
    setTimeout(() => {
      try {
        scrollRightTop();
        orgRef.current?.focus?.();
      } catch {}
    }, 0);
  }

  function focusNextField(dir = +1) {
    const els = getFocusableElements();
    if (!els.length) return;

    const active = document.activeElement;
    let idx = els.findIndex((el) => el === active);
    if (idx === -1) idx = dir > 0 ? -1 : els.length;

    let next = idx + dir;
    if (next < 0) next = 0;
    if (next > els.length - 1) next = els.length - 1;

    const el = els[next];
    if (!el) return;

    try {
      el.focus?.();
      el.scrollIntoView?.({ block: "nearest" });
    } catch {}
  }

  // ---------- RIGHT PANEL LOADERS ----------
  async function loadOrgDetail(organisation_id) {
    const oid = safeTrim(organisation_id);
    if (!oid) return setOrgDetail(null);
    try {
      const det = await tryFetchJson([`/api/organisations/${encodeURIComponent(oid)}`]);
      setOrgDetail(det && typeof det === "object" ? det : null);
    } catch {
      setOrgDetail(null);
    }
  }

const selectedOrgFromList = useMemo(() => {
    const oid = String(form.organisation_id || "");
    if (!oid) return null;
    return orgs.find((o) => String(o.id || "") === oid) || null;
  }, [orgs, form.organisation_id]);

const selectedRelationIsPrivate = isPrivateRelation(selectedOrgFromList);

useEffect(() => {
  if (!selectedRelationIsPrivate) return;
  if (!form.contact_id) return;

  setForm((prev) => ({
    ...prev,
    contact_id: "",
  }));
}, [selectedRelationIsPrivate, form.contact_id]);

const currentInvoiceEmail = useMemo(() => {
  const selectedRow = items.find((x) => String(x.id || "") === String(form.id || ""));
  return safeTrim(
    orgDetail?.email ||
    selectedOrgFromList?.email ||
    selectedRow?.org_email ||
    ""
  );
}, [orgDetail, selectedOrgFromList, items, form.id]);

const currentInvoiceDigital = useMemo(() => {
  const selectedRow = items.find((x) => String(x.id || "") === String(form.id || ""));
  const raw =
    orgDetail?.receives_invoices_digital ??
    orgDetail?.digital_invoices ??
    orgDetail?.invoice_digital ??
    selectedOrgFromList?.receives_invoices_digital ??
    selectedOrgFromList?.digital_invoices ??
    selectedOrgFromList?.invoice_digital ??
    selectedRow?.receives_invoices_digital ??
    selectedRow?.digital_invoices ??
    selectedRow?.invoice_digital ??
    false;

  return raw === true || raw === 1 || raw === "1" || raw === "true" || raw === "ja";
}, [orgDetail, selectedOrgFromList, items, form.id]);

// v033: de relatie-instelling bepaalt alleen de UBL-bijlage voor de KLANT.
// De BCC administratiekopie krijgt volgens server.js v563 altijd UBL.
const currentInvoiceUbl = useMemo(() => {
  const raw = orgDetail?.invoice_ubl ?? selectedOrgFromList?.invoice_ubl ?? false;
  return raw === true || raw === 1 || raw === "1" || raw === "true" || raw === "ja";
}, [orgDetail, selectedOrgFromList]);

async function loadPayments(invoiceId) {
  const id = safeTrim(invoiceId);
  if (!id) {
    setPayments([]);
    return [];
  }

  try {
    const data = await tryFetchJson([`/api/invoices/${encodeURIComponent(id)}/payments`]);
    const arr = Array.isArray(data) ? data : [];
    setPayments(arr);
    return arr;
  } catch {
    setPayments([]);
    return [];
  }
}

  function loadItemFromRowSync(it) {
    setSelectedId(it.id);

const f = {
  ...emptyForm,
  id: it.id,
  organisation_id: it.organisation_id ? String(it.organisation_id) : "",
  contact_id: it.contact_id ? String(it.contact_id) : "",
  template_id: it.template_id ? String(it.template_id) : "",
  invoice_intro_text: it.invoice_intro_text || "",
  invoice_payment_text: it.invoice_payment_text || "",
  invoice_footer_text: it.invoice_footer_text || "",
  invoice_number: it.invoice_number || "",
  series_code: it.series_code || "",
  invoice_date: isoDate(it.invoice_date) || "",
  due_date: isoDate(it.due_date) || "",
  status: normalizeDbStatus(it.status || "DRAFT"),
  notes: it.notes || "",
  subtotal: Number(it.subtotal || 0),
  vat_total: Number(it.vat_total || 0),
  total: Number(it.total || 0),
  created_at: it.created_at || "",
  updated_at: it.updated_at || "",
};

setForm(f);
    setDueDateManual(true);
    setPayError(null);
    setSaveError(null);
    setFlash("");
  }

  async function loadItemFromRow(it) {
    loadItemFromRowSync(it);

    // detail ophalen (zekerheid)
    try {
      const det = await tryFetchJson([`/api/invoices/${encodeURIComponent(it.id)}`]);
if (det && typeof det === "object") {
  const invoiceObj = det.invoice ? det.invoice : det;
  loadItemFromRowSync(invoiceObj);

  const loadedLines =
    Array.isArray(det.lines) ? det.lines :
    Array.isArray(det.items) ? det.items :
    Array.isArray(invoiceObj.lines) ? invoiceObj.lines :
    Array.isArray(invoiceObj.items) ? invoiceObj.items :
    [];

  setLines(loadedLines);
}
    } catch {}

    // org detail voor correspondentieadres
    loadOrgDetail(it.organisation_id);

    // payments
    loadPayments(it.id);

    setMode("form");
    setTimeout(() => {
      try {
        scrollRightTop();
        orgRef.current?.focus?.();
      } catch {}
    }, 0);
  }

  // ---------- ACTIES ----------
function resetRightPanelEmpty() {
  setSelectedId(null);
  setForm(emptyForm);
  setDueDateManual(false);
  setOrgDetail(null);

  setPayments([]);
  setLines([]);
  setLineDraft({
    quantity: 1,
    description: "",
    unit_price: "",
    vat_rate: "hoog",
  });

  setPayDraft({
    paid_on: new Date().toLocaleDateString("en-CA"),
    amount: "",
    notes: "",
  });

  setPayError(null);
  setSaveError(null);
  setLineError(null);
  setFlash("");
}

  function resetAllGridFilters() {
    setZoeknaamFilter("");
    setContactFilter("");
    setInvoiceNrFilter("");
    setInvoiceDateFilter("");
    setTelFilter("");
    setMobFilter("");
    setCityFilter("");
    setCountryFilter("");
    setStatusFilter("");
    setCompanyCodeFilter("");
    setPaidFilter("");
  }

  function vernieuwList() {
    setQ("");
    resetAllGridFilters();
    resetRightPanelEmpty();
    setListIndex(-1);

    setHideVoiceError(true);
    setSort({ key: "invoice_date", dir: "desc" });
    setReloadKey((k) => k + 1);

    setMode("search");
if (window.innerWidth > 768) {
  setTimeout(() => {
    try {
      searchRef.current?.focus?.();
    } catch {}
  }, 0);
}

    setFlash("Vernieuwd ✅");
    setTimeout(() => setFlash(""), 800);
    setTimeout(() => scrollMidTop(), 0);
  }


function newItem() {
  resetRightPanelEmpty();

  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const todayIso = `${yyyy}-${mm}-${dd}`;

  const newForm = {
    ...emptyForm,
    organisation_id: "",
    contact_id: "",
    invoice_number: "",
    status: "DRAFT",
    invoice_date: todayIso,
    due_date: "",
    invoice_intro_text: invoiceDocumentSettings.intro_text || "",
    invoice_payment_text:
      invoiceDocumentSettings.payment_text ||
      invoiceSettings.payment_text ||
      "",
    invoice_footer_text:
      invoiceDocumentSettings.footer_text ||
      invoiceSettings.footer_text ||
      "",
  };

  setForm(newForm);
  setDueDateManual(false);
  setMode("form");
  setListIndex(-1);
  setHideVoiceError(true);

  setTimeout(() => {
    try {
      scrollRightTop();
      orgRef.current?.focus?.();
    } catch {}
  }, 0);
}


useEffect(() => {
    if (dueDateManual) return;

    const inv = isoDate(form.invoice_date);

    const rawDays =
      orgDetail?.payment_term_days ??
      selectedOrgFromList?.payment_term_days ??
      0;

    const days = Number(rawDays);

    if (!inv) return;
    if (!Number.isFinite(days) || days <= 0) return;

    const calculated = addDaysIso(inv, days);
    if (!calculated) return;

    if (calculated !== (form.due_date || "")) {
      setForm((p) => ({ ...p, due_date: calculated }));
    }
  }, [
    form.invoice_date,
    dueDateManual,
    orgDetail?.payment_term_days,
    selectedOrgFromList?.payment_term_days,
  ]);

// DB-statuswaarden: DRAFT | FINAL | PARTIAL | PAID
  // Alleen DRAFT (concept) is bewerkbaar.

async function finalizeInvoice() {
  setSaveError(null);

  const currentStatus = normalizeDbStatus(form.status || "DRAFT");

  if (currentStatus !== "DRAFT") {
    setSaveError(`Alleen concept${isCreditInvoice ? "creditnota’s" : "facturen"} kunnen definitief worden gemaakt.`);
    return;
  }

  if (!safeTrim(form.organisation_id)) {
    setSaveError("Kies eerst een relatie.");
    return;
  }

  if (!safeTrim(form.invoice_date)) {
    setSaveError(`${isCreditInvoice ? "Creditnotadatum" : "Factuurdatum"} is verplicht.`);
    return;
  }

  // Neem de actuele regels van de server, zodat ook oude of net gewijzigde
  // conceptfacturen volledig gecontroleerd worden VOOR status FINAL.
  let latestInvoiceLines;
  try {
    const detail = await tryFetchJson([`/api/invoices/${encodeURIComponent(form.id || selectedId)}`]);
    latestInvoiceLines =
      Array.isArray(detail?.lines) ? detail.lines :
      Array.isArray(detail?.items) ? detail.items :
      Array.isArray(detail?.invoice_lines) ? detail.invoice_lines :
      Array.isArray(detail?.invoice?.lines) ? detail.invoice.lines :
      null;
    if (!latestInvoiceLines) throw new Error("Factuurregels niet beschikbaar");
  } catch (err) {
    setSaveError("De factuurregels konden niet worden gecontroleerd. Factuur blijft concept. " + (err?.message || ""));
    return;
  }
  const invalidIndex = invalidInvoiceArticleIndex(latestInvoiceLines);
  if (invalidIndex >= 0) {
    setSaveError(`Artikelregel ${invalidIndex + 1} heeft geen omschrijving. Vul die eerst in voordat je de factuur definitief maakt.`);
    return;
  }

  const ok = window.confirm(`Weet je zeker dat je deze ${isCreditInvoice ? "creditnota" : "factuur"} definitief wilt maken?`);
  if (!ok) return;

  const finalForm = {
    ...form,
    status: "FINAL",
  };

  setForm(finalForm);

  try {
    const payload = {
      organisation_id: finalForm.organisation_id ? Number(finalForm.organisation_id) : null,
      contact_id: finalForm.contact_id ? Number(finalForm.contact_id) : null,
      template_id: finalForm.template_id ? Number(finalForm.template_id) : null,
      invoice_intro_text:
        finalForm.invoice_intro_text ||
        effectiveInvoiceSettings.intro_text ||
        "",
      invoice_payment_text:
        finalForm.invoice_payment_text ||
        effectiveInvoiceSettings.payment_text ||
        "",
      invoice_footer_text:
        finalForm.invoice_footer_text ||
        effectiveInvoiceSettings.footer_text ||
        "",
      invoice_date: finalForm.invoice_date || null,
      due_date: finalForm.due_date || null,
      invoice_number: finalForm.invoice_number || null,
      status: "FINAL",
      series_code: finalForm.series_code || null,
      notes: finalForm.notes || "",
    };

    const saved = await tryFetchJson([`/api/invoices/${finalForm.id}`], {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (saved && typeof saved === "object") {
      setItems((prev) => upsertById(prev, saved));
      setForm((prev) => ({
        ...prev,
        ...saved,
        status: normalizeDbStatus(saved.status || "FINAL"),
      }));
    }

    await refreshSelectedInvoice();

    if (useOwnLetterhead) {
      setSilentDocumentPreview(true);
      setLetterheadPdfPreviewBusy(true);
      setLetterheadPdfPreviewError("");
    }

    setPopupMode("preview");
    setShowLinesPopup(true);

    await saveInvoiceDocumentFromPreview(finalForm.id);

    if (useOwnLetterhead) {
      try {
        const html = await waitForInvoicePreviewHtml();
        if (!html) throw new Error(`${invoiceDocumentLabel}-voorbeeld kon niet worden opgebouwd.`);

        letterheadPdfPreviewHtmlRef.current = html;

        const pdfBlob = await fetchPdfBlob("/api/mkb/preview-pdf-html", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ html, file_name: isCreditInvoice ? "voorbeeld-creditnota.pdf" : "voorbeeld-factuur.pdf" }),
        });

        if (letterheadPdfPreviewUrl) {
          try { URL.revokeObjectURL(letterheadPdfPreviewUrl); } catch {}
        }

        setLetterheadPdfPreviewUrl(URL.createObjectURL(pdfBlob));
      } catch (previewErr) {
        setLetterheadPdfPreviewError(previewErr?.message || "PDF-voorbeeld maken mislukt.");
      } finally {
        setPopupMode("edit");
        setSilentDocumentPreview(false);
        setLetterheadPdfPreviewBusy(false);
      }
    }

    setFlash(`${invoiceDocumentLabel} definitief gemaakt en opgeslagen bij documenten ✅`);
    setTimeout(() => setFlash(""), 1200);
  } catch (e) {
    setSaveError(e?.message || String(e));
  }
}

function buildInvoicePrintHtml() {
  const el = popupPrintRef.current;
  if (!el) return "";

  const letterheadImageHtml = useOwnLetterhead
    ? `<img class="staffiq-letterhead-background" src="${letterheadBackgroundDataUrl}" alt="" />`
    : "";

  return `
    <html>
      <head>
        <title>${invoiceDocumentLabel}</title>
        <style>
          @page {
            size: A4;
            margin: ${useOwnLetterhead ? "0" : "22mm 12mm 12mm 12mm"};
          }

          @page:first {
            size: A4;
            margin: ${useOwnLetterhead ? "0" : "12mm"};
          }

          html, body {
            margin: 0;
            padding: 0;
            background: #fff;
            font-family: Calibri, Carlito, Arial, sans-serif;
            color: #222;
          }

          body {
            font-size: 11pt;
            line-height: 1.15;
          }

          .print-wrap, .print-wrap * {
            font-family: Calibri, Carlito, Arial, sans-serif !important;
          }

          .staffiq-letterhead-background {
            position: fixed;
            left: 0;
            top: 0;
            width: 210mm;
            height: 297mm;
            object-fit: fill;
            z-index: 0;
            pointer-events: none;
          }

          .letterhead-page-table {
            width: 210mm;
            border-collapse: collapse;
            border-spacing: 0;
            table-layout: fixed;
          }

          .letterhead-page-table td {
            padding: 0 !important;
            border: 0 !important;
          }

          .letterhead-header-space { height: 48mm; }
          .letterhead-footer-space { height: 42mm; }

          .print-wrap {
            position: relative;
            z-index: 1;
            width: 186mm;
            max-width: 186mm;
            margin: 0 auto;
            box-sizing: border-box;
          }

          button,
          .invoice-top-actions,
          .invoice-bottom-actions {
            display: none !important;
          }

          .invoice-total-footer-block,
          .invoice-totals-block,
          .invoice-footer-block {
            break-inside: avoid;
            page-break-inside: avoid;
          }

          .invoice-footer-block {
            ${useOwnLetterhead ? "display: none !important;" : ""}
          }

          input, textarea, select {
            border: none !important;
            outline: none !important;
            box-shadow: none !important;
            background: transparent !important;
            appearance: none !important;
            -webkit-appearance: none !important;
            color: #222 !important;
          }

          ::-webkit-scrollbar {
            display: none;
          }
        </style>
      </head>
      <body>
        ${letterheadImageHtml}
        ${useOwnLetterhead ? `
          <table class="letterhead-page-table">
            <thead>
              <tr><td><div class="letterhead-header-space"></div></td></tr>
            </thead>
            <tbody>
              <tr><td><div class="print-wrap">${el.innerHTML}</div></td></tr>
            </tbody>
            <tfoot>
              <tr><td><div class="letterhead-footer-space"></div></td></tr>
            </tfoot>
          </table>
        ` : `
          <div class="print-wrap">
            ${el.innerHTML}
          </div>
        `}
      </body>
    </html>
  `;
}

async function waitForInvoicePreviewHtml() {
  for (let i = 0; i < 25; i += 1) {
    const html = buildInvoicePrintHtml();
    if (html) return html;

    await new Promise((resolve) => setTimeout(resolve, 100));
  }

  return "";
}

async function saveInvoiceDocumentFromPreview(invoiceId) {
  if (!invoiceId) return;

  const html = await waitForInvoicePreviewHtml();

  if (!html) {
    throw new Error("Factuurvoorbeeld niet gevonden voor documentopslag.");
  }

  await tryFetchJson(
    [`/api/invoices/${encodeURIComponent(invoiceId)}/save-document-html`],
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ html, total: Number(invoiceTotals.total || 0) }),
    }
  );
}

function printInvoicePopup() {
  const html = buildInvoicePrintHtml();
  if (!html) return;

  const printWindow = window.open("", "_blank", "width=1000,height=800");
  if (!printWindow) return;

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();

  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 300);
}

// v033: beschikbaar voor handmatige levering van definitieve factuur + UBL.
// XML komt van de backend uit de opgeslagen factuurregels, nooit uit de HTML-weergave.
async function downloadInvoiceUbl() {
  setSaveError(null);
  if (!formHasId() || !safeTrim(form.invoice_number || "") ||
      !["FINAL", "PARTIAL", "PAID"].includes(normalizeDbStatus(form.status || "DRAFT"))) {
    setSaveError("Maak de factuur eerst definitief voordat je UBL downloadt.");
    return;
  }
  if (!currentInvoiceUbl) {
    setSaveError("Bij deze relatie staat Ontvangt UBL-factuur uit.");
    return;
  }
  try {
    const blob = await fetchPdfBlob(`/api/invoices/${encodeURIComponent(form.id)}/ubl`);
    // Ook bij ontbrekend/misleidend content-type geen HTML als XML downloaden.
    const content = await blob.text();
    if (!content.trim().startsWith("<?xml") && !content.includes("<Invoice") && !content.includes("<CreditNote")) {
      throw new Error("De server leverde geen UBL XML-bestand terug.");
    }
    const fileName = `${String(form.invoice_number || "factuur").trim().replace(/[^A-Za-z0-9._-]/g,"_")}.xml`;
    const href = URL.createObjectURL(new Blob([content], { type: "application/xml;charset=utf-8" }));
    const el = document.createElement("a");
    el.href = href;
    el.download = fileName;
    document.body.appendChild(el);
    el.click();
    el.remove();
    setTimeout(() => URL.revokeObjectURL(href), 4000);
    setFlash(`UBL-factuur ${fileName} gedownload ✅`);
    setTimeout(() => setFlash(""), 2500);
  } catch (err) {
    const message = err?.message || "UBL XML downloaden mislukt.";
    setSaveError(message);
    alert(`UBL XML downloaden mislukt.\n\n${message}`);
  }
}

async function sendInvoiceEmail() {
  setSaveError(null);

  const currentStatus = normalizeDbStatus(form.status || "DRAFT");
  const invoiceNumber = safeTrim(form.invoice_number || "");
  const to = safeTrim(currentInvoiceEmail || "");

if (!["FINAL", "PARTIAL", "PAID"].includes(currentStatus) || !invoiceNumber) {
    setSaveError("Een conceptfactuur zonder factuurnummer mag niet worden gemaild.");
    return;
  }

  if (!formHasId()) {
    setSaveError("Sla de factuur eerst op.");
    return;
  }

  if (!to) {
    setSaveError("Bij deze relatie staat geen e-mailadres.");
    return;
  }

  if (!currentInvoiceDigital) {
    setSaveError("Deze relatie ontvangt geen facturen digitaal.");
    return;
  }

  // Extra controle voor oudere definitieve facturen: voorkom een cryptische UBL 500.
  // Bestaande definitieve facturen worden hierbij niet aangepast.
  try {
    const detail = await tryFetchJson([`/api/invoices/${encodeURIComponent(form.id)}`]);
    const currentLines =
      Array.isArray(detail?.lines) ? detail.lines :
      Array.isArray(detail?.items) ? detail.items :
      Array.isArray(detail?.invoice_lines) ? detail.invoice_lines :
      Array.isArray(detail?.invoice?.lines) ? detail.invoice.lines :
      null;
    if (!currentLines) throw new Error("Factuurregels niet beschikbaar");
    const invalidIndex = invalidInvoiceArticleIndex(currentLines);
    if (invalidIndex >= 0) {
      const message = `Artikelregel ${invalidIndex + 1} heeft geen omschrijving. Deze factuur kan niet als UBL worden verstuurd.`;
      setSaveError(message);
      alert(message);
      return;
    }
  } catch (err) {
    setSaveError("UBL-controle mislukt: " + (err?.message || "onbekende fout"));
    return;
  }

  // ✅ NIEUW: bevestiging popup
  const ok = window.confirm(`${invoiceDocumentLabel} versturen naar:\n\n${to} ?`);
  if (!ok) return;

  if (!popupPrintRef.current) {
    setSaveError(`${invoiceDocumentLabel}-weergave niet gevonden.`);
    return;
  }

  try {
    setSendingEmail(true);

    let invoiceTitle = safeTrim(effectiveInvoiceSettings.email_subject)
      ? effectiveInvoiceSettings.email_subject
          .replaceAll("{document_nummer}", invoiceNumber)
          .replaceAll("{relatie}", recipientName || "")
          .replaceAll(
            "{contactpersoon}",
            contactAanschrijving || pickContactFullName(selectedContact) || ""
          )
      : `${invoiceDocumentLabel} ${invoiceNumber}`;

    if (isCreditInvoice) {
      invoiceTitle = invoiceTitle.replace(/\bfactuur\b/gi, "Creditnota");
    }

const printableHtml =
      useOwnLetterhead && letterheadPdfPreviewHtmlRef.current
        ? letterheadPdfPreviewHtmlRef.current
        : buildInvoicePrintHtml();

    const mailResult = await tryFetchJson(
      [`/api/invoices/${encodeURIComponent(form.id)}/send-email`],
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          to,
          subject: invoiceTitle,
          invoiceNumber,
          html: printableHtml,
          total: Number(invoiceTotals.total || 0),
        }),
      }
    );

    // v033: bij afzonderlijke BCC-verzending kan de klantmail slagen en
    // de administratiekopie mislukken. Die waarschuwing NIET weggooien.
    if (mailResult?.warning) {
      const warning = String(mailResult.warning);
      alert(`${invoiceDocumentLabel} verstuurd naar ${to}.\n\nLET OP: ${warning}`);
      setSaveError(warning);
    } else {
      const administratieOk = mailResult?.accounting_copy?.sent === true;
      const administratieVerwacht = mailResult?.accounting_copy?.requested === true;
      alert(`${invoiceDocumentLabel} verstuurd naar ${to}${administratieVerwacht && administratieOk ? "\nAdministratiekopie met UBL eveneens verzonden." : ""}${mailResult?.warning ? "\n\nLET OP: " + mailResult.warning : ""}`);
      setFlash(`${invoiceDocumentLabel} verstuurd naar ${to} ✅`);
      setTimeout(() => setFlash(""), 1500);
    }

  } catch (e) {
    console.error(e);
    const message = String(e?.message || "Factuur e-mailen mislukt.").slice(0, 1000);
    alert(`Versturen mislukt.\n\n${message}`);
    setSaveError(message);
  } finally {
    setSendingEmail(false);
  }
}

async function saveItem() {
  if (isFormLocked || isReadonly) return;

  try {
    const status = normalizeDbStatus(form.status || "DRAFT");

    if (!isAdmin && ["FINAL", "PARTIAL", "PAID"].includes(status)) {
      alert("Deze factuur is definitief en kan niet meer worden opgeslagen.");
      return;
    }

    // Ook de handmatige admin-statuswijziging naar definitief moet de
    // omschrijvingen controleren. De gewone definitiefknop doet dit eveneens.
    if (["FINAL", "PARTIAL", "PAID"].includes(status) && form.id) {
      const detail = await tryFetchJson([`/api/invoices/${encodeURIComponent(form.id)}`]);
      const currentLines =
        Array.isArray(detail?.lines) ? detail.lines :
        Array.isArray(detail?.items) ? detail.items :
        Array.isArray(detail?.invoice_lines) ? detail.invoice_lines :
        Array.isArray(detail?.invoice?.lines) ? detail.invoice.lines :
        null;
      if (!currentLines) throw new Error("Factuurregels niet beschikbaar voor controle.");
      const invalidIndex = invalidInvoiceArticleIndex(currentLines);
      if (invalidIndex >= 0) {
        setSaveError(`Artikelregel ${invalidIndex + 1} heeft geen omschrijving. Factuur is niet opgeslagen.`);
        return;
      }
    }

    const payload = {
      ...form,
      status,
    };

    let saved;

    if (form.id) {
      saved = await tryFetchJson([`/api/invoices/${form.id}`], {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
    } else {
      saved = await tryFetchJson([`/api/invoices`], {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
    }

    setItems((prev) => upsertById(prev, saved));

    resetRightPanelEmpty();
    setSelectedId(null);
    setListIndex(-1);
    setMode("search");
    setReloadKey((k) => k + 1);

    setFlash("Factuur opgeslagen ✅");
    setTimeout(() => setFlash(""), 1000);

    setTimeout(() => {
      try {
        scrollRightTop();
        scrollMidTop();
        searchRef.current?.focus?.();
      } catch {}
    }, 0);
  } catch (e) {
    console.error(e);
    alert("Opslaan mislukt");
  }
}

async function openInvoicePopupEdit() {
  setPopupMode("edit");
  await saveItemForPopup();
}

async function openInvoicePopupPreview() {
  setLetterheadPdfPreviewError("");

  // Zonder eigen briefpapier blijft de bestaande HTML-voorbeeldweergave behouden.
  if (!useOwnLetterhead) {
    setPopupMode("preview");
    await saveItemForPopup();
    return;
  }

  try {
    setLetterheadPdfPreviewBusy(true);
    setSilentDocumentPreview(true);
    setPopupMode("preview");

    await saveItemForPopup();

    await new Promise((resolve) => requestAnimationFrame(resolve));
    await new Promise((resolve) => requestAnimationFrame(resolve));

    const html = buildInvoicePrintHtml();
    if (!html) throw new Error(`${invoiceDocumentLabel}-voorbeeld kon niet worden opgebouwd.`);

    letterheadPdfPreviewHtmlRef.current = html;

    const pdfBlob = await fetchPdfBlob("/api/mkb/preview-pdf-html", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ html, file_name: "voorbeeld-factuur.pdf" }),
    });

    if (letterheadPdfPreviewUrl) {
      try { URL.revokeObjectURL(letterheadPdfPreviewUrl); } catch {}
    }

    const nextUrl = URL.createObjectURL(pdfBlob);
    setLetterheadPdfPreviewUrl(nextUrl);
  } catch (err) {
    setLetterheadPdfPreviewError(err?.message || "PDF-voorbeeld maken mislukt.");
  } finally {
    setPopupMode("edit");
    setSilentDocumentPreview(false);
    setLetterheadPdfPreviewBusy(false);
  }
}

function closeLetterheadPdfPreview() {
  setLetterheadPdfPreviewError("");
  setLetterheadPdfPreviewUrl("");
}

function printLetterheadPdfPreview() {
  if (!letterheadPdfPreviewUrl) return;

  try {
    const frameWindow = letterheadPdfPreviewFrameRef.current?.contentWindow;
    if (frameWindow?.print) {
      frameWindow.focus?.();
      frameWindow.print();
      return;
    }
  } catch {}

  window.open(letterheadPdfPreviewUrl, "_blank", "noopener,noreferrer");
}
async function saveExistingInvoiceHeaderForPopup() {
  const invoiceId = form.id || selectedId;

  if (!invoiceId) return null;

  const payload = {
    organisation_id: form.organisation_id
      ? Number(form.organisation_id)
      : null,
    contact_id: form.contact_id
      ? Number(form.contact_id)
      : null,
    template_id: form.template_id
      ? Number(form.template_id)
      : null,
    invoice_intro_text:
      form.invoice_intro_text ||
      effectiveInvoiceSettings.intro_text ||
      "",
    invoice_payment_text:
      form.invoice_payment_text ||
      effectiveInvoiceSettings.payment_text ||
      "",
    invoice_footer_text:
      form.invoice_footer_text ||
      effectiveInvoiceSettings.footer_text ||
      "",
    invoice_date: form.invoice_date || null,
    due_date: form.due_date || null,
    invoice_number: form.invoice_number || null,
    status: normalizeDbStatus(form.status || "DRAFT"),
    series_code: form.series_code || null,
    notes: form.notes || "",
  };

  const saved = await tryFetchJson(
    [`/api/invoices/${encodeURIComponent(invoiceId)}`],
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );

  if (saved && typeof saved === "object") {
    setItems((prev) => upsertById(prev, saved));

    setForm((prev) => ({
      ...prev,
      ...saved,
      id: saved.id || invoiceId,
      organisation_id: saved.organisation_id
        ? String(saved.organisation_id)
        : prev.organisation_id,
      contact_id: saved.contact_id
        ? String(saved.contact_id)
        : "",
      template_id: saved.template_id
        ? String(saved.template_id)
        : "",
      status: normalizeDbStatus(saved.status || prev.status || "DRAFT"),
    }));
  }

  return saved;
}

async function saveItemForPopup() {
    setSaveError(null);
    setFlash("");

    if (isLocked) {
      if (formHasId()) {
        await refreshSelectedInvoice();
        setShowLinesPopup(true);
      }
      return;
    }

    if (!safeTrim(form.organisation_id)) {
      setSaveError("Kies eerst een relatie.");
      return;
    }

    if (!safeTrim(form.invoice_date)) {
      setSaveError("Factuurdatum is verplicht.");
      return;
    }

    // Bestaat al? Sla eerst de gekozen kopgegevens en het factuursjabloon op.
    if (formHasId()) {
      try {
        await saveExistingInvoiceHeaderForPopup();
        await refreshSelectedInvoice();
        setShowLinesPopup(true);
      } catch (e) {
        setSaveError(e?.message || String(e));
      }
      return;
    }

    const payload = {
      organisation_id: form.organisation_id ? Number(form.organisation_id) : null,
      contact_id: form.contact_id ? Number(form.contact_id) : null,
      template_id: form.template_id ? Number(form.template_id) : null,
      invoice_intro_text:
        form.invoice_intro_text ||
        effectiveInvoiceSettings.intro_text ||
        "",
      invoice_payment_text:
        form.invoice_payment_text ||
        effectiveInvoiceSettings.payment_text ||
        "",
      invoice_footer_text:
        form.invoice_footer_text ||
        effectiveInvoiceSettings.footer_text ||
        "",
      invoice_date: form.invoice_date || null,
      due_date: form.due_date || null,
      invoice_number: form.invoice_number || null,
      status: (form.status || "DRAFT"),
      series_code: form.series_code || null,
      notes: form.notes || "",
    };

    try {
      const saved = await tryFetchJson(["/api/invoices"], {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const newId = saved?.id ? String(saved.id) : "";

      if (saved && typeof saved === "object") {
        setItems((prev) => upsertById(prev, saved));
      }

if (newId) {
  setSelectedId(newId);

  setForm((prev) => ({
    ...prev,
    ...saved,
    id: newId,
    organisation_id: saved?.organisation_id ? String(saved.organisation_id) : prev.organisation_id,
    contact_id: saved?.contact_id ? String(saved.contact_id) : prev.contact_id,
    status: saved?.status || prev.status || "DRAFT",
  }));

  await loadOrgDetail(saved?.organisation_id || form.organisation_id);
  await loadPayments(newId);

  const pendingLine = getPendingLinePayload();

  if (pendingLine) {
    await tryFetchJson([`/api/invoices/${encodeURIComponent(newId)}/lines`], {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(pendingLine),
    });

    setLineDraft({
      quantity: 1,
      description: "",
      unit_price: "",
      vat_rate: pickOrgDefaultVatRate(activeOrg),
    });
  }

  await refreshSelectedInvoice();
}

      setFlash("Factuur opgeslagen ✅");
      setTimeout(() => setFlash(""), 800);
      setShowLinesPopup(true);
    } catch (e) {
      setSaveError(e?.message || String(e));
    }
  }

  async function deleteItem() {
    setSaveError(null);
    setFlash("");

    if (!formHasId()) return;
    if (isLocked) return setSaveError("Gefactureerde facturen kun je niet verwijderen (crediteer-route volgt).");

    const ok = window.confirm("Weet je zeker dat je deze factuur wilt verwijderen?");
    if (!ok) return;

    const id = form.id;
    try {
      await tryFetchJson([`/api/invoices/${id}`], { method: "DELETE" });
      setItems((prev) => removeById(prev, id));
      resetRightPanelEmpty();
      setListIndex(-1);

      setFlash("Verwijderd ✅");
      setTimeout(() => setFlash(""), 800);

setMode("search");
setTimeout(() => {
  try {
    scrollRightTop();
    scrollMidTop();
    searchRef.current?.focus?.();
  } catch {}
}, 0);
    } catch (e) {
      setSaveError(e?.message || String(e));
    }
  }

  // ---------- PAYMENTS ----------
const paidTotal = useMemo(() => payments.reduce((s, p) => s + Number(p.amount || 0), 0), [payments]);
  const openAmount = useMemo(() => Number(form.total || 0) - paidTotal, [form.total, paidTotal]);
  const paidLabel = useMemo(() => boolPaidLabel(openAmount), [openAmount]);

  const canEditPayments =
    formHasId() &&
    normalizeDbStatus(form.status || "DRAFT") !== "DRAFT";

async function addPayment() {
  setPayError(null);

  if (!formHasId()) {
    return setPayError("Sla eerst de factuur op, voordat je betalingen toevoegt.");
  }

  const currentStatus = normalizeDbStatus(form.status || "DRAFT");
  if (currentStatus === "DRAFT") {
    return setPayError("Bij een conceptfactuur mogen nog geen betalingen worden ingevoerd.");
  }

  const paid_on = isoDate(payDraft.paid_on);
  const amount = Number(String(payDraft.amount || "").replace(",", "."));

  if (!paid_on) return setPayError("Kies een betaaldatum.");
  if (!Number.isFinite(amount) || amount <= 0) {
    return setPayError("Bedrag moet > 0 zijn.");
  }

  const payload = {
    paid_on,
    amount,
    notes: payDraft.notes || "",
  };

  const beforeCount = payments.length;

  try {
    const saved = await tryFetchJson([`/api/invoices/${form.id}/payments`], {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (saved && typeof saved === "object") {
      const nextPayments = [...payments, saved].sort((a, b) =>
        isoDate(a.paid_on) < isoDate(b.paid_on) ? -1 : 1
      );
      setPayments(nextPayments);
    } else {
      await loadPayments(form.id);
    }

    setPayDraft({
      paid_on: new Date().toLocaleDateString("en-CA"),
      amount: "",
      notes: "",
    });

    setFlash("Betaling toegevoegd ✅");
    setTimeout(() => setFlash(""), 800);

    await refreshSelectedInvoice();
  } catch (e) {
    const loaded = await loadPayments(form.id);

    if (Array.isArray(loaded) && loaded.length > beforeCount) {
      setPayError(null);

      setPayDraft({
        paid_on: new Date().toLocaleDateString("en-CA"),
        amount: "",
        notes: "",
      });

      setFlash("Betaling toegevoegd ✅");
      setTimeout(() => setFlash(""), 800);

      await refreshSelectedInvoice();
      return;
    }

    setPayError(e?.message || String(e));
  }
}

  async function deletePayment(pid) {
    setPayError(null);
    if (!formHasId()) return;
    const ok = window.confirm("Betaling verwijderen?");
    if (!ok) return;

    try {
await tryFetchJson([`/api/invoices/${form.id}/payments/${pid}`], { method: "DELETE" });

const nextPayments = payments.filter((x) => String(x.id) !== String(pid));
setPayments(nextPayments);

setFlash("Betaling verwijderd ✅");
setTimeout(() => setFlash(""), 800);
await refreshSelectedInvoice();
    } catch (e) {
      setPayError(e?.message || String(e));
    }
  }

  // ---------- FACTUURREGELS ----------

async function refreshSelectedInvoice() {
  const invoiceId = form.id || selectedId;
  if (!invoiceId) return;

  try {
    const det = await tryFetchJson([`/api/invoices/${encodeURIComponent(invoiceId)}`]);
    const invoiceObj = det && det.invoice ? det.invoice : det;

    if (invoiceObj) {
      setForm((prev) => ({
        ...prev,
        ...invoiceObj,
        id: invoiceObj.id || invoiceId,
        status: normalizeDbStatus(invoiceObj.status || prev.status || "DRAFT"),
      }));
    }

    const loadedLines =
      Array.isArray(det?.lines) ? det.lines :
      Array.isArray(det?.items) ? det.items :
      Array.isArray(det?.invoice_lines) ? det.invoice_lines :
      Array.isArray(invoiceObj?.lines) ? invoiceObj.lines :
      Array.isArray(invoiceObj?.items) ? invoiceObj.items :
      Array.isArray(invoiceObj?.invoice_lines) ? invoiceObj.invoice_lines :
      [];

    setLines(loadedLines);
    setReloadKey((k) => k + 1);
  } catch (e) {
    console.error(e);
  }
}

function getPendingLinePayload() {
  const lineType = invoiceLineType(lineDraft);
  const isAmount = lineType === "item";
  const qty = isAmount ? Number(lineDraft.quantity || 0) : 0;
  const unit = isAmount ? Number(parseFloat(String(lineDraft.unit_price || "").replace(",", ".")).toFixed(2)) : 0;
  const desc = invoicePlainText(lineDraft.description);
  const vat = isAmount ? String(lineDraft.vat_rate || "hoog").toLowerCase() : "0";

  if (!desc) return null;
  if (isAmount && (!Number.isFinite(qty) || qty <= 0 || !Number.isFinite(unit))) return null;

  return {
    line_type: lineType,
    description: desc,
    quantity: qty,
    qty: qty,
    unit_price: unit,
    price: unit,
    vat_rate: vat,
    vat: vat,
  };
}

async function addInvoiceLine() {
  setLineError(null);

  const invoiceId = form.id || selectedId;

  if (!invoiceId) {
    setLineError("Sla eerst de factuur op.");
    return false;
  }

  if (isLocked) {
    setLineError("Deze factuur is gefactureerd/verzonden/betaald; regels zijn niet meer aanpasbaar.");
    return false;
  }

  const isEdit = !!editingLineId;

  const lineType = invoiceLineType(lineDraft);
  const isAmount = lineType === "item";
  const qty = isAmount ? Number(lineDraft.quantity || 0) : 0;
  const unit = isAmount ? Number(parseFloat(String(lineDraft.unit_price || "").replace(",", ".")).toFixed(2)) : 0;
  const desc = invoicePlainText(lineDraft.description);
  const vat = isAmount ? String(lineDraft.vat_rate || "hoog").toLowerCase() : "0";

  if (!desc) {
    setLineError("Omschrijving is verplicht. Een lege opmaakregel telt niet als omschrijving.");
    return false;
  }

  if (isAmount && (!Number.isFinite(qty) || qty <= 0)) {
    setLineError("Aantal moet groter dan 0 zijn.");
    return false;
  }

if (isAmount && !Number.isFinite(unit)) {
    setLineError("Bedrag moet een geldig getal zijn.");
    return false;
  }

  const payload = {
    invoice_id: Number(invoiceId),
    line_no: isEdit ? undefined : (lines.length + 1),
    line_type: lineType,
    description: desc,
    quantity: qty,
    qty: qty,
    unit_price: unit,
    price: unit,
    vat_rate: vat,
    vat: vat,
  };

  try {
    const saved = await tryFetchJson(
      isEdit
        ? [`/api/invoice-lines/${encodeURIComponent(editingLineId)}`]
        : [`/api/invoice-lines`, `/api/invoices/${encodeURIComponent(invoiceId)}/lines`],
      {
        method: isEdit ? "PUT" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );

    const savedLineRaw =
      saved?.line ||
      saved?.invoice_line ||
      saved?.data ||
      saved;

    const savedLine =
      savedLineRaw && typeof savedLineRaw === "object"
        ? { ...payload, ...savedLineRaw }
        : { ...payload, id: editingLineId || Date.now() };

    if (isEdit) {
      setLines((prev) =>
        prev.map((ln) =>
          String(ln.id) === String(editingLineId)
            ? { ...ln, ...savedLine }
            : ln
        )
      );
    } else {
      setLines((prev) => [...prev, savedLine]);
    }

setEditingLineId(null);

    setSelectedProjectLineId("__manual__");
    setIncludeChildProjects(false);

    setLineDraft({
      quantity: 1,
      description: "",
      unit_price: "",
      vat_rate: pickOrgDefaultVatRate(activeOrg),
    });

    setTimeout(() => {
      try {
        lineDescRef.current?.focus?.();
      } catch {}
    }, 80);

    setFlash(isEdit ? "Factuurregel gewijzigd ✅" : "Factuurregel toegevoegd ✅");
    setTimeout(() => setFlash(""), 900);

    await refreshSelectedInvoice();

    return true;
  } catch (e) {
    setLineError(e?.message || String(e));
    return false;
  }
}

function cancelEditInvoiceLine() {
  setEditingLineId(null);
  setLineError(null);
  setLineDraft({
    quantity: 1,
    description: "",
    unit_price: "",
    vat_rate: pickOrgDefaultVatRate(activeOrg),
  });
}

function annuleerInvoicePopup() {
  setLineError(null);
  setEditingLineId(null);
  setSelectedProjectLineId("__manual__");
  setIncludeChildProjects(false);

  setLineDraft({
    quantity: 1,
    description: "",
    unit_price: "",
    vat_rate: pickOrgDefaultVatRate(activeOrg),
  });

  setShowLinesPopup(false);
}

function getOnderliggendeProjecten(parentId) {
  const result = [];

  function walk(pid) {
    const children = projectItems
      .filter((x) => String(x.parent_id || "") === String(pid || ""))
      .sort((a, b) =>
        String(a.full_code || a.code || "").localeCompare(
          String(b.full_code || b.code || ""),
          "nl"
        )
      );

    children.forEach((child) => {
      result.push(child);
      walk(child.id);
    });
  }

  walk(parentId);

  return result;
}

async function voegProjectRegelsToe(projectId) {
  const invoiceId = form.id || selectedId;

  if (!invoiceId) {
    setLineError("Sla eerst de factuur op.");
    return;
  }

  const hoofd = projectItems.find(
    (x) => String(x.id) === String(projectId)
  );

  if (!hoofd) return;

  const alleRegels = [hoofd];

  if (includeChildProjects) {
    alleRegels.push(...getOnderliggendeProjecten(hoofd.id));
  }

  // Projectbeheer-artikelen moeten zelf een zichtbare Offertetekst hebben.
  // Voorkom gedeeltelijke overname wanneer meerdere onderdelen zijn gekozen.
  const invalidProjects = alleRegels.filter(
    (r) => invoiceAmountLine(r) && !invoicePlainText(r.offer_text)
  );
  if (invalidProjects.length) {
    setLineError(`Offertetekst ontbreekt in Projectbeheer bij: ${invalidProjects.map(r => r.full_code || r.code || r.name || r.id).join(", ")}. Vul deze eerst in.`);
    return;
  }

  const bruikbareRegels = alleRegels.filter((r) => {
    const hasPrijs = Number(r.price || 0) > 0;
    const hasTekst =
      invoicePlainText(r.offer_text) ||
      invoicePlainText(r.name);

    return hasPrijs || hasTekst;
  });

  try {
    for (const r of bruikbareRegels) {
      const omschrijving =
        invoicePlainText(r.offer_text) ||
        invoicePlainText(r.name) ||
        invoicePlainText(r.full_name) ||
        "";

      // Zonder echte omschrijving geen lege projectregel factureren.
      if (!omschrijving) continue;

      const projectLineType = invoiceAmountLine(r) ? "item" : "text";
      const isAmount = projectLineType === "item";
      const payload = {
        invoice_id: Number(invoiceId),
        line_no: lines.length + 1,
        line_type: projectLineType,
        description: omschrijving,
        quantity: isAmount ? 1 : 0,
        qty: isAmount ? 1 : 0,
        unit_price: isAmount ? Number(r.price || 0) : 0,
        price: isAmount ? Number(r.price || 0) : 0,
        vat_rate: isAmount ? normalizeVatRate(r.vat_rate || "hoog") : "0",
        vat: isAmount ? normalizeVatRate(r.vat_rate || "hoog") : "0",
      };

      await tryFetchJson(
        ["/api/invoice-lines", `/api/invoices/${encodeURIComponent(invoiceId)}/lines`],
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
    }

    await refreshSelectedInvoice();

    setSelectedProjectLineId("__manual__");
    setIncludeChildProjects(false);

    setLineDraft({
      quantity: 1,
      description: "",
      unit_price: "",
      vat_rate: pickOrgDefaultVatRate(activeOrg),
    });

    setFlash(
      includeChildProjects
        ? "Project + onderliggende onderdelen toegevoegd ✅"
        : "Project toegevoegd ✅"
    );

    setTimeout(() => setFlash(""), 1200);

    setTimeout(() => {
      try {
        lineDescRef.current?.focus?.();
      } catch {}
    }, 80);
  } catch (e) {
    setLineError(e?.message || String(e));
  }
}

function vulRegelUitProjectbeheer(projectId) {
  setSelectedProjectLineId(projectId);

  if (projectId === "__manual__") {
    setIncludeChildProjects(false);

    setLineDraft({
      quantity: 1,
      description: "",
      unit_price: "",
      vat_rate: pickOrgDefaultVatRate(activeOrg),
    });

    setTimeout(() => {
      try {
        lineDescRef.current?.focus?.();
      } catch {}
    }, 50);

    return;
  }

  const p = projectItems.find((x) => String(x.id) === String(projectId));
  if (!p) return;

  voegProjectRegelsToe(projectId);
}

function formatLineUnitPriceValue(raw) {
  const s = String(raw || "").trim();
  if (!s) return "";

  const normalized = s.replace(",", ".");
  const num = Number(normalized);
  if (!Number.isFinite(num)) return s;

  return num.toFixed(2).replace(".", ",");
}

function handleUnitPriceCommit() {
  setLineDraft((prev) => ({
    ...prev,
    unit_price: formatLineUnitPriceValue(prev.unit_price),
  }));
}

function startEditInvoiceLine(ln) {
  if (isLocked || popupMode === "preview") return;

  setLineError(null);
  setEditingLineId(ln.id);

  setLineDraft({
    line_type: invoiceAmountLine(ln) ? "item" : "text",
    quantity: invoiceAmountLine(ln) ? String(lineQty(ln) || 1) : "",
    description: String(lineDescription(ln) || ""),
    unit_price: String(lineUnitPrice(ln) || "").replace(".", ","),
    vat_rate: String(lineVatRate(ln) || "hoog"),
  });

  setTimeout(() => {
    try {
      qtyInputRef.current?.focus?.();
      qtyInputRef.current?.select?.();

      if (lineDescRef.current) {
        lineDescRef.current.style.height = "auto";
        lineDescRef.current.style.height = `${lineDescRef.current.scrollHeight}px`;
      }
    } catch {}
  }, 0);
}

  async function deleteInvoiceLine(lineId) {
    setLineError(null);
    if (!formHasId()) return;
    if (isLocked) {
      setLineError("Deze factuur is gefactureerd/verzonden/betaald; regels zijn niet meer aanpasbaar.");
      return;
    }

    try {
      await tryFetchJson([`/api/invoice-lines/${encodeURIComponent(lineId)}`], { method: "DELETE" });
      setLines((prev) => prev.filter((x) => String(x.id) !== String(lineId)));
      setFlash("Factuurregel verwijderd ✅");
      setTimeout(() => setFlash(""), 900);
      await refreshSelectedInvoice();
    } catch (e) {
      setLineError(e?.message || String(e));
    }
  }

  // ---------- SPEECH ----------

function isPopupOpen() {
    return !!showLinesPopup;
  }

  function isPopupField(el) {
    if (!el) return false;
    return (
      el === qtyInputRef.current ||
      el === lineDescRef.current ||
      el === linePriceRef.current ||
      el === lineVatRef.current
    );
  }

  function popupFocusOrder() {
    const arr = [qtyInputRef.current, lineDescRef.current, linePriceRef.current, lineVatRef.current]
      .filter(Boolean)
      .filter((el) => !el.disabled);
    return arr;
  }

function focusFirstPopupField() {
    setTimeout(() => {
      try {
        lineDescRef.current?.focus?.();
      } catch {}
    }, 120);
  }

  function focusNextPopupField(dir = +1) {
    const arr = popupFocusOrder();
    if (!arr.length) return;

    const active = document.activeElement;
    let idx = arr.findIndex((el) => el === active);
    if (idx === -1) idx = dir > 0 ? -1 : arr.length;

    let next = idx + dir;
    if (next < 0) next = 0;
    if (next > arr.length - 1) next = arr.length - 1;

    const el = arr[next];
    if (!el) return;

    try {
      el.focus?.();
      if (el.tagName?.toLowerCase() === "input" || el.tagName?.toLowerCase() === "textarea") {
        el.select?.();
      }
    } catch {}
  }

  function popupPunctMap(t) {
    const x = norm(t);
    if (x === "punt") return ".";
    if (x === "komma") return ",";
    if (x === "dubbele punt" || x === "dubbelpunt") return ":";
    if (x === "puntkomma") return ";";
    if (x === "vraagteken") return "?";
    if (x === "uitroepteken") return "!";
    if (x === "nieuwe regel" || x === "enter" || x === "nieuwe regel maken") return "\n";
    return null;
  }

  function normalizePopupQty(raw) {
    const s = String(raw || "").trim().replace(",", ".");
    const n = Number(s);
    if (!Number.isFinite(n) || n <= 0) return "";
    return String(n);
  }

  function normalizePopupPrice(raw) {
    const s = String(raw || "").trim().replace(",", ".");
    const n = Number(s);
    if (!Number.isFinite(n) || n <= 0) return "";
    return n.toFixed(2).replace(".", ",");
  }

  function popupVatFromSpeech(raw) {
    const x = norm(raw);
    if (x.includes("21") || x.includes("hoog")) return "hoog";
    if (x.includes("9") || x.includes("laag")) return "laag";
    if (x === "0" || x.includes("nul")) return "0";
    if (x.includes("verlegd")) return "verlegd";
    return "";
  }

  function applyDictationToPopupField(raw0) {
    const el = document.activeElement;
    if (!isPopupOpen() || !isPopupField(el)) return false;

    if (el === qtyInputRef.current) {
      const v = normalizePopupQty(raw0);
      if (!v) return false;
      setLineDraft((prev) => ({ ...prev, quantity: v }));
      return true;
    }

    if (el === lineDescRef.current) {
      const punct = popupPunctMap(raw0);

      if (punct !== null) {
        setLineDraft((prev) => ({
          ...prev,
          description: `${String(prev.description || "")}${punct}`,
        }));
        return true;
      }

      let txt = String(raw0 || "").trim()
        .replace(/\bnieuwe regel\b/gi, "\n")
        .replace(/\bpuntkomma\b/gi, ";")
        .replace(/\bdubbele punt\b/gi, ":")
        .replace(/\buitroepteken\b/gi, "!")
        .replace(/\bvraagteken\b/gi, "?")
        .replace(/\bkomma\b/gi, ",")
        .replace(/\bpunt\b/gi, ".")
        .replace(/\s+([.,!?;:])/g, "$1");

      txt = txt.replace(/(^|[\n.!?]\s*)([a-zà-ÿ])/g, (_, p1, p2) => p1 + p2.toUpperCase());

      setLineDraft((prev) => {
        const cur = String(prev.description || "");
        const sep = cur && !cur.endsWith(" ") && !cur.endsWith("\n") ? " " : "";
        return { ...prev, description: cur + sep + txt };
      });
      return true;
    }

    if (el === linePriceRef.current) {
      const v = normalizePopupPrice(raw0);
      if (!v) return false;
      setLineDraft((prev) => ({ ...prev, unit_price: v }));
      return true;
    }

    if (el === lineVatRef.current) {
      const v = popupVatFromSpeech(raw0);
      if (!v) return false;
      setLineDraft((prev) => ({ ...prev, vat_rate: v }));
      return true;
    }

    return false;
  }

function inFormContext() {
  try {
    const el = document.activeElement;
    if (!el) return false;

    if (isPopupOpen() && isPopupField(el)) return true;

    const inRight = rightScrollRef.current?.contains?.(el) || false;

    // Alleen echte invoer-velden in rechterblok tellen als formulier-context
    const tag = (el.tagName || "").toLowerCase();
    const isInputLike =
      tag === "input" ||
      tag === "textarea" ||
      tag === "select" ||
      el.isContentEditable;

    return inRight && isInputLike;
  } catch {
    return false;
  }
}

function handleVoiceCommandLike(raw) {
  const t = norm(raw);
  const parts = t.split(" ").filter(Boolean);
  const w1 = parts[0] || "";
  const active = document.activeElement;

  if (w1 === "factuur") {
    saveItemForPopup();
    return true;
  }

  if (w1 === "sluiten" && isPopupOpen()) {
    setShowLinesPopup(false);
    return true;
  }

  if (w1 === "regel" && isPopupOpen()) {
    addInvoiceLine();
    return true;
  }

  if (w1 === "volgende") {
    if (isPopupOpen() && isPopupField(active)) {
      if (active === lineVatRef.current) {
        addInvoiceLine();
        setTimeout(() => {
          qtyInputRef.current?.focus?.();
          qtyInputRef.current?.select?.();
        }, 0);
      } else {
        focusNextPopupField(+1);
      }
      return true;
    }

    if (inFormContext()) {
      if (active === dueDateRef.current) {
        setTimeout(() => {
          payDateRef.current?.focus?.();
        }, 0);
      } else if (active === payDateRef.current) {
        setTimeout(() => {
          payAmtRef.current?.focus?.();
        }, 0);
      } else if (active === payAmtRef.current) {
        addPayment();
        setTimeout(() => {
          payNotesRef.current?.focus?.();
        }, 0);
      } else {
        focusNextField(+1);
      }
    } else {
      moveCursor(+1);
    }
    return true;
  }

  if (w1 === "vorige") {
    if (isPopupOpen() && isPopupField(active)) {
      focusNextPopupField(-1);
      return true;
    }

    if (inFormContext()) {
      focusNextField(-1);
    } else {
      moveCursor(-1);
    }
    return true;
  }

  if (w1 === "terug" || w1 === "links") {
    if (isPopupOpen()) {
      setShowLinesPopup(false);
      return true;
    }

    resetRightPanelEmpty();
    setMode("search");
if (window.innerWidth > 768) {
      setTimeout(() => {
        try {
          searchRef.current?.focus?.();
        } catch {}
      }, 0);
    }
    return true;
  }

if (w1 === "rechts" || w1 === "selecteer" || w1 === "selecteren" || w1 === "item") {
  openCurrentRowToRight();
  return true;
}

  if (w1 === "nieuw" || w1 === "nieuwe") {
    if (isPopupOpen()) {
      setEditingLineId(null);
      setLineDraft({
        quantity: 1,
        description: "",
        unit_price: "",
        vat_rate: pickOrgDefaultVatRate(activeOrg),
      });
      focusFirstPopupField();
      return true;
    }

    newItem();
    return true;
  }

  if (w1 === "vernieuw" || w1 === "vernieuwen") {
    vernieuwList();
    return true;
  }

  if (w1 === "opslaan" || w1 === "bewaren") {
    if (isPopupOpen()) {
      addInvoiceLine();
      return true;
    }

    saveItem();
    return true;
  }

  if (w1 === "verwijder" || w1 === "verwijderen" || w1 === "delete") {
    deleteItem();
    return true;
  }

  if (w1 === "betaling") {
    addPayment();
    setTimeout(() => {
      payNotesRef.current?.focus?.();
    }, 0);
    return true;
  }

  return false;
}

  function highlightItemIndex(idx) {
    const L = sortedItems.length;
    if (L <= 0) return;
    const clamped = clampIndex(idx, L);
    setListIndex(clamped);
    setTimeout(() => scrollRowIntoView(clamped), 0);
  }

function openCurrentRowToRight() {
  const L = sortedItems.length;
  if (L <= 0) return;

  const idx = ensureCursorExists();
  if (idx < 0) return;

  const it = sortedItems[idx];
  if (!it) return;

  setListIndex(idx);
  loadItemFromRow(it);
  setMode("form");

  if (window.innerWidth <= 768) {
    focusFirstRightFieldMobile();
  } else {
    focusFirstRightField();
  }

  setTimeout(() => scrollRowIntoView(idx), 0);
}

function getFocusableElements() {
  const els = focusOrderRefs.map((r) => r?.current).filter(Boolean);
  return els.filter((el) => {
    try {
      if (el.disabled) return false;
      const rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    } catch {
      return false;
    }
  });
}

function focusFirstRightField() {
  setTimeout(() => {
    try {
      scrollRightTop();
      orgRef.current?.focus?.();
    } catch {}
  }, 0);
}

function focusFirstRightFieldMobile() {
  setTimeout(() => {
    try {
      const panel = rightScrollRef.current;
      if (!panel) return;

      panel.scrollTop = 0;
      panel.scrollIntoView?.({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    } catch {}
  }, 120);
}

function focusNextField(dir = +1) {
  const els = getFocusableElements();
  if (!els.length) return;

  const active = document.activeElement;
  let idx = els.findIndex((el) => el === active);
  if (idx === -1) idx = dir > 0 ? -1 : els.length;

  let next = idx + dir;
  if (next < 0) next = 0;
  if (next > els.length - 1) next = els.length - 1;

  const el = els[next];
  if (!el) return;

  try {
    el.focus?.();
    el.scrollIntoView?.({ block: "nearest" });
  } catch {}
}
useEffect(() => {
    if (!pendingSpeechSearch) return;
    if (loading) return;

    if (sortedItems.length > 0) {
      setListIndex(0);
      setTimeout(() => {
        scrollMidTop();
        scrollRowIntoView(0);
      }, 0);
    } else {
      setListIndex(-1);
      setTimeout(() => scrollMidTop(), 0);
    }

    setPendingSpeechSearch(false);
  }, [pendingSpeechSearch, loading, sortedItems.length]);

function applyDictationToFocusedField(raw0) {
  const el = document.activeElement;
  if (!el) return false;

  const containerHas = rightScrollRef.current?.contains?.(el);
  if (!containerHas) return false;

  const tag = (el.tagName || "").toLowerCase();
  const type = (el.getAttribute?.("type") || "").toLowerCase();

  if (el === orgRef.current) {
    const spoken = norm(raw0);
    const found = orgs.find((o) => norm(pickOrgName(o)) === spoken || norm(pickOrgName(o)).includes(spoken));
    if (!found) return false;

    setForm((prev) => ({
      ...prev,
      organisation_id: String(found.id || ""),
      contact_id: "",
    }));
    return true;
  }

  if (el === contactRef.current) {
    const spoken = norm(raw0);
    const found = contacts.find((c) => {
      const nm = pickContactFullName(c);
      return norm(nm) === spoken || norm(nm).includes(spoken);
    });
    if (!found) return false;

    setForm((prev) => ({
      ...prev,
      contact_id: String(found.id || ""),
    }));
    return true;
  }

  if (el === invNumRef.current) {
    const digits = speechDigitsPreserveZeros(raw0);
    const v = digits ? digits.padStart(4, "0") : String(raw0 || "").replace(/[^\dA-Za-z\-]/g, "").trim();
    setForm((prev) => ({ ...prev, invoice_number: v }));
    return true;
  }

  if (el === invDateRef.current || (tag === "input" && type === "date" && el === invDateRef.current)) {
    const iso = parseDutchDateToISO(raw0);
    if (!iso) return false;
    setForm((prev) => ({ ...prev, invoice_date: iso }));
    return true;
  }

  if (el === dueDateRef.current || (tag === "input" && type === "date" && el === dueDateRef.current)) {
    const iso = parseDutchDateToISO(raw0);
    if (!iso) return false;
    setDueDateManual(true);
    setForm((prev) => ({ ...prev, due_date: iso }));
    return true;
  }

  if (el === payDateRef.current) {
    const iso = parseDutchDateToISO(raw0);
    if (!iso) return false;
    setPayDraft((prev) => ({ ...prev, paid_on: iso }));
    return true;
  }

  if (el === payAmtRef.current) {
    const amt = decimal2OrEmptyString(raw0);
    if (!amt) return false;
    setPayDraft((prev) => ({ ...prev, amount: amt }));
    return true;
  }

  if (el === payNotesRef.current) {
    const punct = punctToChar(raw0);

    if (punct) {
      setForm((prev) => ({
        ...prev,
        notes: `${String(prev.notes || "")}${punct}`,
      }));
      return true;
    }

    let txt = String(raw0 || "").trim()
      .replace(/\bnieuwe regel\b/gi, "\n")
      .replace(/\bpuntkomma\b/gi, ";")
      .replace(/\bdubbele punt\b/gi, ":")
      .replace(/\buitroepteken\b/gi, "!")
      .replace(/\bvraagteken\b/gi, "?")
      .replace(/\bkomma\b/gi, ",")
      .replace(/\bpunt\b/gi, ".")
      .replace(/\s+([.,!?;:])/g, "$1");

    txt = txt.replace(/(^|[\n.!?]\s*)([a-zà-ÿ])/g, (_, p1, p2) => p1 + p2.toUpperCase());

    setForm((prev) => {
      const cur = String(prev.notes || "");
      const sep = cur && !cur.endsWith(" ") && !cur.endsWith("\n") ? " " : "";
      return { ...prev, notes: cur + sep + txt };
    });
    return true;
  }

  if (el === statusRef.current && tag === "select") {
    const spoken = norm(raw0);

    let next = "";
    if (spoken.includes("concept")) next = "DRAFT";
    else if (spoken.includes("gefactureerd")) next = "FINAL";
    else if (spoken.includes("verzonden")) next = "SENT";
    else if (spoken.includes("deelbetaling")) next = "PARTIAL";
    else if (spoken.includes("betaald")) next = "PAID";

    if (!next) return false;

    setForm((prev) => ({ ...prev, status: next }));
    return true;
  }

  return false;
}

  const voice = useVoiceCommands({
    lang: "nl-NL",
    timeoutMs: 8500,
    onCommand: (cmd, rawHeard) => {
      const raw = String(rawHeard || "").trim();

      if (raw) {
        setSpeechInfo(`🎙 ${raw}`);
        setTimeout(() => setSpeechInfo(""), 2000);
      }

      if (raw && handleVoiceCommandLike(raw)) return true;

      if (!cmd || !cmd.type) return false;
      if (cmd.type === "new" || cmd.type === "nieuw") { newItem(); return true; }
      if (cmd.type === "refresh") { vernieuwList(); return true; }
      if (cmd.type === "save") { saveItem(); return true; }
      if (cmd.type === "delete") { deleteItem(); return true; }
      return false;
    },

onDictation: (text) => {
  const raw0 = String(text || "").trim();
  if (!raw0) return;

  setSpeechInfo(`🎙 ${raw0}`);
  setTimeout(() => setSpeechInfo(""), 2000);

  if (handleVoiceCommandLike(raw0)) return;

  if (applyDictationToPopupField(raw0)) return;

  if (applyDictationToFocusedField(raw0)) return;

  if (mode === "search") {
    if (isEmptyWord(raw0)) {
      setQ("");
    } else {
      setQ(raw0);
    }
  }
},

  });

  useEffect(() => {
    const cur = String(voice.error || "");
    const prev = String(prevVoiceErrorRef.current || "");
    if (cur && cur !== prev) {
      setHideVoiceError(false);
      prevVoiceErrorRef.current = cur;
    }
    if (!cur) prevVoiceErrorRef.current = "";
  }, [voice.error]);

  function startSpeakSmart() {
    if (!voice.supported || voice.listening) return;
    setHideVoiceError(true);
    voice.startOnce();
  }

// ---------- LAYOUT (zelfde stijl als Contactpersonen) ----------
  const isMobile = window.innerWidth <= 768;
  const RIGHT_WIDTH = isMobile ? "100%" : 320;
  const GAP = isMobile ? 18 : 14;
  const TABLE_MIN_WIDTH = 1410;
  const MID_BOTTOM_OFFSET = isMobile ? 90 : 135;

  // Kolombreedtes
const colWidths = {
  zoeknaam: 68,
  contact: 62,
  invnr: 90,
  invdt: 58,
  totaal: 48,
  openstaand: 52,
  tel: 62,
  mob: 62,
  email: 78,
  city: 44,
  country: 40,
  status: 62,
  companyCode: 90,
};

  const searchInputStyle = {
    padding: "7px 10px",
    width: 180,
    border: "1px solid #d9d9d9",
    borderRadius: 4,
    background: "white",
    outline: "none",
    boxSizing: "border-box",
  };

const inputStyle = {
    padding: "7px 10px",
    width: "100%",
    minWidth: 0,
    border: "1px solid #d9d9d9",
    borderRadius: 4,
    background: "white",
    boxSizing: "border-box",
  };

  const dateInputStyle = {
    ...inputStyle,
    paddingRight: 30,
  };

  const buttonStyle = {
    padding: "7px 12px",
    border: "1px solid #d9d9d9",
    borderRadius: 4,
    background: "white",
    cursor: "pointer",
    whiteSpace: "nowrap",
  };

  const buttonPrimary = (bg) => ({
    ...buttonStyle,
    background: bg,
    color: "white",
    border: "1px solid rgba(0,0,0,0.05)",
  });

  const buttonDisabledStyle = { ...buttonStyle, opacity: 0.55, cursor: "not-allowed" };

  const selectStyle = {
    height: 30,
    padding: "0 8px",
    border: "1px solid #d9d9d9",
    borderRadius: 4,
    background: "white",
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
  };

  const tableStyle = { width: "100%", borderCollapse: "separate", borderSpacing: 0, tableLayout: "fixed" };

  const thBase = {
    textAlign: "left",
    fontSize: 12,
    color: "#444",
    fontWeight: 700,
    padding: "8px 6px",
    borderBottom: "1px solid #e6e6e6",
    whiteSpace: "nowrap",
    position: "sticky",
    top: 0,
    zIndex: 5,
    background: "#fff",
    userSelect: "none",
  };

  const thClickable = { ...thBase, cursor: "pointer" };

  const filterThStyle = {
    ...thBase,
    fontWeight: 400,
    padding: "6px 6px 8px 6px",
    borderBottom: "1px solid #ededed",
    top: 32,
    zIndex: 4,
    cursor: "default",
  };

  const tdStyle = {
    padding: "7px 6px",
    borderBottom: "1px solid #efefef",
    fontSize: 13,
    color: "#222",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const rowBgCursor = "#f3f7ff";
  const rowBgSelected = "#e6f0ff";

  function sortToggle(key) {
    setSort((s) => {
      if (s.key !== key) return { key, dir: key === "invoice_date" ? "desc" : "asc" };
      return { key, dir: s.dir === "asc" ? "desc" : "asc" };
    });
  }

  function sortArrow(key) {
    if (sort.key !== key) return "";
    return sort.dir === "asc" ? " ▲" : " ▼";
  }

  const deleteEnabled = formHasId() && !isLocked;

const effectiveInvoiceSettings = {
  // Gebruik de aparte MKB-factuurinstellingen zodra die zijn geladen.
  // Belangrijk: een bewust leeg veld (bijv. Adresregel 2) mag NIET
  // terugvallen op oude legacy invoice_settings-data.
  invoice_title:
    invoiceDocumentSettings.document_title ??
    invoiceSettings.invoice_title ??
    "Factuur",
  invoice_contact_person:
    invoiceDocumentSettings.contact_person ??
    invoiceSettings.invoice_contact_person ??
    "",
  company_name:
    invoiceDocumentSettings.company_name ??
    invoiceSettings.company_name ??
    "",
  company_address_1:
    invoiceDocumentSettings.company_address_1 ??
    invoiceSettings.company_address_1 ??
    "",
  company_address_2:
    invoiceDocumentSettings.company_address_2 ??
    invoiceSettings.company_address_2 ??
    "",
  company_postcode:
    invoiceDocumentSettings.company_postcode ??
    invoiceSettings.company_postcode ??
    "",
  company_city:
    invoiceDocumentSettings.company_city ??
    invoiceSettings.company_city ??
    "",
  company_country:
    invoiceDocumentSettings.company_country ??
    invoiceSettings.company_country ??
    "",
  company_email:
    invoiceDocumentSettings.company_email ??
    invoiceSettings.company_email ??
    "",
  company_website:
    invoiceDocumentSettings.company_website ??
    invoiceSettings.company_website ??
    "",
  company_phone:
    invoiceDocumentSettings.company_phone ??
    invoiceSettings.company_phone ??
    "",
  company_kvk:
    invoiceDocumentSettings.company_kvk ??
    invoiceSettings.company_kvk ??
    "",
  company_vat:
    invoiceDocumentSettings.company_vat ??
    invoiceSettings.company_vat ??
    "",
  company_iban:
    invoiceDocumentSettings.company_iban ??
    invoiceSettings.company_iban ??
    "",
  company_g_iban:
    invoiceDocumentSettings.company_g_iban ??
    invoiceSettings.company_g_iban ??
    "",
  logo_url:
    invoiceDocumentSettings.logo_url ??
    invoiceSettings.logo_url ??
    "",
  intro_text:
    invoiceDocumentSettings.intro_text ??
    "",
  payment_text:
    invoiceDocumentSettings.payment_text ??
    invoiceSettings.payment_text ??
    "",
  footer_text:
    invoiceDocumentSettings.footer_text ??
    invoiceSettings.footer_text ??
    "",
  email_subject:
    invoiceDocumentSettings.email_subject ??
    "Factuur {document_nummer}",
  email_text:
    invoiceDocumentSettings.email_text ??
    "",
};

const letterheadBackgroundDataUrl = safeTrim(
  letterheadSettings?.letterhead_background_data_url ||
    (
      /^data:image\//i.test(safeTrim(letterheadSettings?.letterhead_data_url))
        ? letterheadSettings?.letterhead_data_url
        : ""
    )
);

const useOwnLetterhead =
  letterheadSettings?.use_own_letterhead === true &&
  !!letterheadBackgroundDataUrl;

const companyInvoiceProfile = {
  name: effectiveInvoiceSettings.company_name,
  addressLines: [
    effectiveInvoiceSettings.company_address_1,
    effectiveInvoiceSettings.company_address_2,
    [
      effectiveInvoiceSettings.company_postcode,
      effectiveInvoiceSettings.company_city,
    ].filter(Boolean).join(" "),
    effectiveInvoiceSettings.company_country,
  ].filter(Boolean),
  email: effectiveInvoiceSettings.company_email,
  phone: effectiveInvoiceSettings.company_phone,
  kvk: effectiveInvoiceSettings.company_kvk,
  vatNumber: effectiveInvoiceSettings.company_vat,
  iban: effectiveInvoiceSettings.company_iban,
  gIban: effectiveInvoiceSettings.company_g_iban,
  footerText: effectiveInvoiceSettings.footer_text,
};

const activeOrg = orgDetail || selectedOrgFromList || null;
const orgVatNumber = pickOrgVatNumber(activeOrg);
const gPercentage = pickOrgGrekeningPercent(activeOrg);

const linesForTotals = useMemo(() => {
  const arr = Array.isArray(lines) ? [...lines] : [];

  const draftQty = invoiceAmountLine(lineDraft) ? Number(lineDraft.quantity || 0) : 0;
  const draftDesc = String(lineDraft.description || "").trim();
  const draftUnit = Number(String(lineDraft.unit_price || "").replace(",", ".") || 0);

  if (!editingLineId) {
    return arr;
  }

  if (!draftDesc || (invoiceAmountLine(lineDraft) && !(draftQty > 0 && Number.isFinite(draftUnit)))) {
    return arr;
  }

  const draftLine = {
    line_type: invoiceLineType(lineDraft),
    quantity: draftQty,
    qty: draftQty,
    description: draftDesc,
    unit_price: draftUnit,
    price: draftUnit,
    vat_rate: lineDraft.vat_rate || "hoog",
    vat: lineDraft.vat_rate || "hoog",
  };

  return arr.map((ln) =>
    String(ln.id) === String(editingLineId) ? { ...ln, ...draftLine } : ln
  );
}, [lines, lineDraft, editingLineId]);

const invoiceTotals = useMemo(
  () => calcInvoiceTotals(linesForTotals),
  [linesForTotals]
);

const betaaldTotaal = useMemo(
  () => (payments || []).reduce((sum, p) => sum + Number(p.amount || 0), 0),
  [payments]
);

const factuurTotaalBedrag = Number(invoiceTotals.total || 0);

const openstaandBedrag = Math.max(
  0,
  factuurTotaalBedrag - betaaldTotaal
);

const gAmount = useMemo(() => {
  return invoiceTotals.total * (gPercentage / 100);
}, [invoiceTotals.total, gPercentage]);

const ibanAmount = useMemo(() => {
  return invoiceTotals.total - gAmount;
}, [invoiceTotals.total, gAmount]);

const isCreditInvoice = invoiceTotals.total < 0;
const invoiceDocumentLabel = isCreditInvoice
  ? "Creditnota"
  : (effectiveInvoiceSettings.invoice_title || "Factuur");
const effectiveGPercentage = isCreditInvoice ? 0 : gPercentage;

const recipientName =
  activeOrg?.name ||
  activeOrg?.organisation_name ||
  activeOrg?.bedrijfsnaam ||
  "";

const selectedInvoiceRow = useMemo(() => {
  const rid = String(form.id || selectedId || "");
  if (!rid) return null;
  return items.find((x) => String(x.id || "") === rid) || null;
}, [items, form.id, selectedId]);

const selectedContact = useMemo(() => {
  const cid = String(form.contact_id || "");
  if (!cid) return null;
  return contacts.find((c) => String(c.id || "") === cid) || null;
}, [contacts, form.contact_id]);

const contactAanschrijving =
  safeTrim(
    selectedContact?.aanschrijving ||
    selectedContact?.aanhef ||
    selectedContact?.salutation ||
    ""
  );

 const recipientAddressLines = useMemo(() => {
  if (!activeOrg) return [];

  const line1 = safeTrim(
    [
      activeOrg.corr_street,
      activeOrg.corr_house_number,
      activeOrg.corr_addition,
    ]
      .filter(Boolean)
      .join(" ")
  );

  const pcCity = [
    safeTrim(activeOrg.corr_postcode),
    safeTrim(activeOrg.corr_city),
  ]
    .filter(Boolean)
    .join(" ");

  const country = safeTrim(activeOrg.corr_country);

  return [line1, pcCity, country].filter(Boolean);
}, [activeOrg]);

useEffect(() => {
  const defaultVat = pickOrgDefaultVatRate(activeOrg);
  setLineDraft((prev) => ({ ...prev, vat_rate: defaultVat }));
}, [form.organisation_id, activeOrg?.id]);



// ---------- AI FACTUREN ----------
function openAiPopup(source = "page") {
  setAiSource(source);
  setAiOpen(true);
  setAiText("");
  setFlash("");
  setTimeout(() => {
    try {
      aiTextRef.current?.focus?.({ preventScroll: true });
    } catch {
      try { aiTextRef.current?.focus?.(); } catch {}
    }
  }, 0);
}

function closeAiPopup() {
  if (aiBusy) return;
  setAiOpen(false);
  setAiText("");
  setAiSource("page");
}

function firstFilled(...vals) {
  for (const v of vals) {
    const t = safeTrim(v);
    if (t) return t;
  }
  return "";
}

function formatAnyAmount(v) {
  const n = Number(v || 0);
  if (!Number.isFinite(n)) return "-";
  return euro(n);
}

function getOrganisationIdForAi() {
  return form?.organisation_id || activeOrg?.id || selectedInvoiceRow?.organisation_id || "";
}

function getOrganisationNameForAi() {
  return firstFilled(
    activeOrg?.name,
    activeOrg?.organisation_name,
    selectedInvoiceRow?.organisation_name,
    recipientName
  );
}

function getContactForAi() {
  return selectedContact || null;
}

function buildCurrentInvoiceContext() {
  const orgName = getOrganisationNameForAi();
  const contact = getContactForAi();
  const contactName = firstFilled(
    contact?.search_name,
    contact?.full_name,
    contact?.naam,
    [contact?.first_name, contact?.name_prefix, contact?.last_name].filter(Boolean).join(" "),
    pickContactNameFromRow(selectedInvoiceRow || {})
  );

  const invoiceNumber = firstFilled(form.invoice_number, selectedInvoiceRow?.invoice_number);
  const invoiceDate = firstFilled(formatNlDate(form.invoice_date), formatNlDate(selectedInvoiceRow?.invoice_date));
  const dueDate = firstFilled(formatNlDate(form.due_date), formatNlDate(selectedInvoiceRow?.due_date));
  const status = statusLabel(form.status || selectedInvoiceRow?.status);

  const out = [];
  out.push("HUIDIGE FACTUUR");
  out.push(`Relatie: ${orgName || "-"}`);
  out.push(`Contactpersoon: ${contactName || "-"}`);
  out.push(`Factuurnummer: ${invoiceNumber || "-"}`);
  out.push(`Factuurdatum: ${invoiceDate || "-"}`);
  out.push(`Vervaldatum: ${dueDate || "-"}`);
  out.push(`Status: ${status || "-"}`);
  out.push(`Totaal: ${euro(invoiceTotals.total || form.total || selectedInvoiceRow?.total || 0)}`);
  out.push(`Betaald: ${euro(betaaldTotaal || 0)}`);
  out.push(`Openstaand: ${euro(openstaandBedrag || 0)}`);
  out.push("");
  out.push("REGELS");

  const useLines = Array.isArray(linesForTotals) ? linesForTotals : [];
  if (!useLines.length) {
    out.push("Geen factuurregels gevonden.");
  } else {
    useLines.forEach((ln, idx) => {
      out.push(`${idx + 1}. ${lineQty(ln)} x ${lineDescription(ln) || "-"} à ${euro(lineUnitPrice(ln))} (${vatLabelForRate(lineVatRate(ln))}) = ${euro(lineQty(ln) * lineUnitPrice(ln))}`);
    });
  }

  if (String(form.notes || "").trim()) {
    out.push("");
    out.push("OPMERKING");
    out.push(String(form.notes || ""));
  }

  return out.join("\n");
}

function buildOrganisationTextForAi() {
  const org = activeOrg || {};
  const linesOut = [];
  linesOut.push("RELATIE GEGEVENS");
  linesOut.push(`Naam: ${getOrganisationNameForAi() || "-"}`);
  linesOut.push(`Adres: ${recipientAddressLines.join(", ") || "-"}`);
  linesOut.push(`Telefoon: ${firstFilled(org.phone, selectedInvoiceRow?.org_phone) || "-"}`);
  linesOut.push(`Mobiel: ${firstFilled(org.mobile, selectedInvoiceRow?.org_mobile) || "-"}`);
  linesOut.push(`E-mail: ${firstFilled(org.email, selectedInvoiceRow?.org_email) || "-"}`);
  linesOut.push(`Plaats: ${firstFilled(org.city, org.corr_city, selectedInvoiceRow?.org_city) || "-"}`);
  linesOut.push(`Land: ${firstFilled(org.country, org.corr_country, selectedInvoiceRow?.org_country) || "-"}`);
  linesOut.push(`Btw-nummer: ${pickOrgVatNumber(org) || "-"}`);
  return linesOut.join("\n");
}

function buildContactTextForAi() {
  const c = getContactForAi();
  const fallbackName = pickContactNameFromRow(selectedInvoiceRow || {});
  if (!c && !fallbackName) return "Geen contactpersoon gekozen.";

  const contactName = firstFilled(
    c?.search_name,
    c?.full_name,
    c?.naam,
    [c?.first_name, c?.name_prefix, c?.last_name].filter(Boolean).join(" "),
    fallbackName
  );

  const linesOut = [];
  linesOut.push("CONTACTPERSOON GEGEVENS");
  linesOut.push(`Naam: ${contactName || "-"}`);
  linesOut.push(`Functie: ${firstFilled(c?.job_title, c?.function, c?.functie) || "-"}`);
  linesOut.push(`Telefoon: ${firstFilled(c?.phone, c?.telephone, selectedInvoiceRow?.contact_phone) || "-"}`);
  linesOut.push(`Mobiel: ${firstFilled(c?.mobile, selectedInvoiceRow?.contact_mobile) || "-"}`);
  linesOut.push(`E-mail: ${firstFilled(c?.email, selectedInvoiceRow?.contact_email) || "-"}`);
  return linesOut.join("\n");
}

function openAiText(title, text) {
  setAiText(`${title}\n\n${text}`);
  setFlash(`${title} gemaakt ✓`);
}

function runAiOrganisationData() {
  openAiText("Relatie gegevens", buildOrganisationTextForAi());
}

function runAiContactData() {
  openAiText("Contactpersoon gegevens", buildContactTextForAi());
}

async function runAiDossierOverview() {
  const orgId = getOrganisationIdForAi();
  if (!orgId) {
    setAiText("Kies eerst een relatie.");
    return;
  }

  try {
    setAiBusy(true);
    setFlash("Dossieroverzicht ophalen...");

    const dossier = await tryFetchJson([
      `/api/organisations/${encodeURIComponent(orgId)}/dossier`,
      `/api/organisations/${encodeURIComponent(orgId)}/dossier-overview`,
    ]);

    const contactsArr = Array.isArray(dossier?.contacts) ? dossier.contacts : [];
    const notesArr = Array.isArray(dossier?.notes_tasks) ? dossier.notes_tasks : Array.isArray(dossier?.notes) ? dossier.notes : [];
    const offers = Array.isArray(dossier?.offers) ? dossier.offers : [];
    const invoices = Array.isArray(dossier?.invoices) ? dossier.invoices : [];

    const linesOut = [];
    linesOut.push("DOSSIER OVERZICHT");
    linesOut.push(`Relatie: ${getOrganisationNameForAi() || "-"}`);
    linesOut.push("");

    linesOut.push(`CONTACTPERSONEN (${contactsArr.length})`);
    if (!contactsArr.length) linesOut.push("Geen contactpersonen gevonden.");
    contactsArr.forEach((c) => {
      const name = firstFilled(c.search_name, c.full_name, c.naam, [c.first_name, c.name_prefix, c.last_name].filter(Boolean).join(" "));
      linesOut.push(`- ${name || "-"} | ${firstFilled(c.email) || "-"} | ${firstFilled(c.phone, c.mobile) || "-"}`);
    });
    linesOut.push("");

    linesOut.push(`NOTITIES/TAKEN (${notesArr.length})`);
    if (!notesArr.length) linesOut.push("Geen notities/taken gevonden.");
    notesArr.forEach((n) => {
      linesOut.push(`- ${firstFilled(formatNlDate(n.due_date), formatNlDate(n.created_at)) || "-"} | ${firstFilled(n.kind, n.type) || "-"} | ${firstFilled(n.title, n.subject) || "-"}`);
    });
    linesOut.push("");

    linesOut.push(`OFFERTES (${offers.length}) - nieuw naar oud`);
    if (!offers.length) linesOut.push("Geen offertes gevonden.");
    offers.forEach((o) => {
      linesOut.push(`- ${firstFilled(o.dossier_date, formatNlDate(o.offer_date), formatNlDate(o.invoice_date)) || "-"} | ${firstFilled(o.dossier_number, o.offer_number, o.invoice_number) || "-"} | ${firstFilled(o.status) || "-"} | ${formatAnyAmount(firstFilled(o.dossier_total, o.total))}`);
    });
    linesOut.push("");

    linesOut.push(`FACTUREN (${invoices.length}) - nieuw naar oud`);
    if (!invoices.length) linesOut.push("Geen facturen gevonden.");
    invoices.forEach((i) => {
      linesOut.push(`- ${firstFilled(i.dossier_date, formatNlDate(i.invoice_date)) || "-"} | ${firstFilled(i.dossier_number, i.invoice_number) || "-"} | ${firstFilled(i.status) || "-"} | ${formatAnyAmount(firstFilled(i.dossier_total, i.total))}`);
    });

    setAiText(linesOut.join("\n"));
    setFlash("Dossieroverzicht gemaakt ✓");
  } catch (err) {
    setAiText("FOUT:\n" + (err?.message || "Onbekende fout"));
    setFlash("");
  } finally {
    setAiBusy(false);
  }
}

async function runAiInvoiceCheck() {
  try {
    setAiBusy(true);
    setFlash("AI controleert factuur...");

    const prompt = `
Je bent een ervaren Nederlandse administratie-assistent in StaffIQ.
Controleer deze factuur inhoudelijk, financieel en praktisch.

${buildCurrentInvoiceContext()}

Geef antwoord in duidelijk Nederlands met deze kopjes:
1. Korte conclusie
2. Mogelijke fouten of ontbrekende gegevens
3. Financiële controle
4. Administratieve aandachtspunten
5. Actiepunten
    `.trim();

    const res = await tryFetchJson(["/api/ai/organisations/check"], {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        organisation: activeOrg || {},
        mode: "chat",
        question: "Controleer deze factuur.",
        prompt,
      }),
    });

    if (!res?.ok) throw new Error(res?.error || "AI controle mislukt");

    setAiText(res.result || "Geen resultaat");
    setFlash("Factuur gecontroleerd ✓");
  } catch (err) {
    setAiText("FOUT:\n" + (err?.message || "Onbekende fout"));
    setFlash("");
  } finally {
    setAiBusy(false);
  }
}

function appendAiConversation(qText, aText) {
  const block =
    `Vraag:\n${qText || "-"}\n\n` +
    `----------------------------------------\n\n` +
    `Antwoord:\n${aText || "-"}\n\n` +
    `========================================\n\n`;

  setAiText((prev) => {
    const cur = String(prev || "").trim();
    if (!cur) return block;
    return `${cur}\n\n${block}`;
  });
}

async function runAiChat() {
  const question = String(aiText || "").trim();

  if (!question) {
    setAiText("Typ eerst een vraag voor Chat met AI.\n\nBijvoorbeeld:\nWat ontbreekt er nog in deze factuur?");
    setTimeout(() => {
      try { aiTextRef.current?.focus?.({ preventScroll: true }); } catch { try { aiTextRef.current?.focus?.(); } catch {} }
    }, 0);
    return;
  }

  try {
    setAiBusy(true);
    setFlash("AI beantwoordt vraag...");

    const prompt = `
Je bent een zakelijke administratie-assistent voor StaffIQ.
Beantwoord de vraag op basis van deze factuur, relatie en contactpersoon.

${buildCurrentInvoiceContext()}

VRAAG:
${question}

Antwoord in helder Nederlands. Zeg eerlijk als iets niet uit de gegevens blijkt.
    `.trim();

    const res = await tryFetchJson(["/api/ai/organisations/check"], {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        organisation: activeOrg || {},
        mode: "chat",
        question,
        prompt,
      }),
    });

    if (!res?.ok) throw new Error(res?.error || "AI chat mislukt");

    appendAiConversation(question, res.result || "Geen antwoord");
    setFlash("AI chat gereed ✓");
  } catch (err) {
    appendAiConversation(question, "FOUT: " + (err?.message || "Onbekende fout"));
    setFlash("");
  } finally {
    setAiBusy(false);
  }
}

function printAiDocument() {
  const title = aiSource === "popup" ? "StaffIQ AI Factuur" : "StaffIQ AI Facturen";
  const content = String(aiText || "").trim() || "Geen inhoud om te printen.";

  const html = `
    <html>
      <head>
        <title>${title}</title>
        <style>
          body { font-family: Calibri, Carlito, Arial, sans-serif; padding: 24px; color: #111; line-height: 1.45; white-space: pre-wrap; }
          h1 { font-size: 20px; margin: 0 0 18px 0; }
        </style>
      </head>
      <body>
        <h1>${title}</h1>
        <div>${content.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")}</div>
      </body>
    </html>
  `;

  const win = window.open("", "_blank", "width=900,height=700");
  if (!win) return;
  win.document.open();
  win.document.write(html);
  win.document.close();
  win.focus();
  setTimeout(() => { try { win.print(); } catch {} }, 300);
}

function startAiSpeak() {
  if (!voice.supported || voice.listening) return;
  try { aiTextRef.current?.focus?.({ preventScroll: true }); } catch { try { aiTextRef.current?.focus?.(); } catch {} }
  voice.startOnce();
}

  // ---------- RENDER ----------
return (
  <>
    <div>
<div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile
            ? "1fr"
            : `minmax(0, 1fr) minmax(${RIGHT_WIDTH}px, ${RIGHT_WIDTH}px)`,
          columnGap: GAP,
          rowGap: isMobile ? 22 : 0,
          alignItems: "start",
          minWidth: 0,
        }}
      >
        {/* LINKS */}
        <div style={{ minWidth: 0 }}>

<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginTop: 0,
    marginBottom: 10,
  }}
>
  <h1 style={{ margin: 0 }}>
    Facturen <span style={{ fontSize: 12, opacity: 0.5 }}>{VERSION}</span>
  </h1>

  <HelpButton
    topic="facturen"
    title="Help over Facturen"
  />
</div>

<>
  {!isMobile ? (
    <div
      style={{
        display: "flex",
        gap: 8,
        alignItems: "center",
        flexWrap: "nowrap",
      }}
    >
      <input
        ref={searchRef}
        value={q}
        onChange={(e) => {
          setQ(e.target.value);
          setMode("search");
        }}
        placeholder="Zoek…"
        style={searchInputStyle}
        onFocus={() => setMode("search")}
      />

      <div
        title={`Aantal regels in het grid: ${gridCount}`}
        style={{
          minWidth: 52,
          height: 32,
          padding: "0 10px",
          border: "1px solid #d9d9d9",
          borderRadius: 4,
          background: "#f7fafc",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 13,
          fontWeight: 700,
          color: "#1f4e79",
          boxSizing: "border-box",
          whiteSpace: "nowrap",
        }}
      >
        {gridCount}
      </div>

      <button
        onMouseDown={(e) => e.preventDefault()}
        onTouchStart={(e) => e.preventDefault()}
        onClick={startSpeakSmart}
        disabled={!voice.supported || voice.listening}
        style={!voice.supported || voice.listening ? buttonDisabledStyle : buttonStyle}
        title="1x klikken = 1 commando of invul-tekst dicteren"
      >
        {voice.listening ? "🎤 Luistert…" : "🎤 Spreek"}
      </button>

      <button
        onClick={newItem}
        disabled={isReadonly}
        style={
          isReadonly
            ? { ...buttonStyle, opacity: 0.5, cursor: "not-allowed" }
            : buttonStyle
        }
      >
        ✚ Nieuw
      </button>

      <button onClick={vernieuwList} style={buttonStyle}>
        🔄 Vernieuw
      </button>

      <button
        onClick={() => openAiPopup("page")}
        style={buttonStyle}
      >
        ✨ AI
      </button>
    </div>
  ) : (
    <>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "minmax(0, 1fr) 58px",
          gap: 6,
          marginBottom: 8,
          alignItems: "center",
        }}
      >
        <input
          ref={searchRef}
          value={q}
          onChange={(e) => {
            setQ(e.target.value);
            setMode("search");
          }}
          placeholder="Zoek…"
          style={{
            ...searchInputStyle,
            width: "100%",
            minWidth: 0,
          }}
          onFocus={() => setMode("search")}
        />

        <div
          title={`Aantal regels in het grid: ${gridCount}`}
          style={{
            height: 34,
            minHeight: 34,
            padding: "0 8px",
            border: "1px solid #d9d9d9",
            borderRadius: 4,
            background: "#f7fafc",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 13,
            fontWeight: 700,
            color: "#1f4e79",
            boxSizing: "border-box",
            whiteSpace: "nowrap",
            lineHeight: "1",
          }}
        >
          {gridCount}
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr 1fr",
          gap: 6,
        }}
      >
        <button
          onMouseDown={(e) => e.preventDefault()}
          onTouchStart={(e) => e.preventDefault()}
          onClick={startSpeakSmart}
          disabled={!voice.supported || voice.listening}
          style={{
            ...(!voice.supported || voice.listening ? buttonDisabledStyle : buttonStyle),
            padding: "10px 8px",
            fontSize: 13,
          }}
          title="1x klikken = 1 commando of invul-tekst dicteren"
        >
          {voice.listening ? "🎤..." : "🎤 Spreek"}
        </button>

        <button
          onClick={newItem}
          disabled={isReadonly}
          style={{
            ...(isReadonly
              ? { ...buttonStyle, opacity: 0.5, cursor: "not-allowed" }
              : buttonStyle),
            padding: "10px 8px",
            fontSize: 13,
          }}
        >
          ✚ Nieuw
        </button>

        <button
          onClick={vernieuwList}
          style={{
            ...buttonStyle,
            padding: "10px 8px",
            fontSize: 13,
          }}
        >
          🔄 Vernieuw
        </button>

        <button
          onClick={() => openAiPopup("page")}
          style={{
            ...buttonStyle,
            padding: "10px 8px",
            fontSize: 13,
          }}
        >
          ✨ AI
        </button>
      </div>
    </>
  )}
</>

          <div style={{ marginTop: 10 }}>
            {loading && <div>Laden…</div>}
            {error && <div style={{ color: "crimson" }}>{error}</div>}
            {flash && <div style={{ marginBottom: 8, color: "green" }}>{flash}</div>}
            {saveError && <div style={{ marginBottom: 8, color: "crimson" }}>{saveError}</div>}
            {payError && <div style={{ marginBottom: 8, color: "crimson" }}>{payError}</div>}
            {voice.error && !hideVoiceError && <div style={{ color: "crimson" }}>Spraakfout: {voice.error}</div>}
          </div>

          {!loading && !error && (
            <div style={{ marginTop: 8, minWidth: 0 }}>
              <div
                ref={midScrollRef}
                style={{
                  overflowX: "auto",
                  overflowY: "auto",
            
                  maxHeight: `calc(100vh - ${MID_BOTTOM_OFFSET}px)`,
                  border: "1px solid #f0f0f0",
                  borderRadius: 6,
                  background: "#fff",
                }}
              >
<div style={{ minWidth: TABLE_MIN_WIDTH }}>
                  <table style={tableStyle}>
                    <colgroup>

                      <col style={{ width: colWidths.zoeknaam }} />
                      <col style={{ width: colWidths.status }} />
                      <col style={{ width: colWidths.contact }} />
                      <col style={{ width: colWidths.invnr }} />
                      <col style={{ width: colWidths.invdt }} />
                      <col style={{ width: colWidths.totaal }} />
                      <col style={{ width: colWidths.openstaand }} />
                      <col style={{ width: colWidths.tel }} />
                      <col style={{ width: colWidths.mob }} />
                      <col style={{ width: colWidths.email }} />
                      <col style={{ width: colWidths.city }} />
                      <col style={{ width: colWidths.country }} />
                      <col style={{ width: colWidths.companyCode }} />
                    </colgroup>

                    <thead>
                      <tr>
                        <th style={thClickable} onClick={() => setSort({ key: "org", dir: sort.key === "org" && sort.dir === "asc" ? "desc" : "asc" })}>
                          Relatie
                        </th>
                        <th style={thClickable} onClick={() => setSort({ key: "status", dir: sort.key === "status" && sort.dir === "asc" ? "desc" : "asc" })}>
                          Status
                        </th>
                        <th style={thClickable} onClick={() => setSort({ key: "contact", dir: sort.key === "contact" && sort.dir === "asc" ? "desc" : "asc" })}>
                          Contactpersoon
                        </th>
                        <th style={thClickable} onClick={() => setSort({ key: "invoice_number", dir: sort.key === "invoice_number" && sort.dir === "asc" ? "desc" : "asc" })}>
                          Factuurnummer
                        </th>
                        <th style={thClickable} onClick={() => setSort({ key: "invoice_date", dir: sort.key === "invoice_date" && sort.dir === "asc" ? "desc" : "asc" })}>
                          Datum
                        </th>
                        <th
  style={{ ...thClickable, textAlign: "right" }}
  onClick={() =>
    setSort({
      key: "totaal",
      dir: sort.key === "totaal" && sort.dir === "asc" ? "desc" : "asc",
    })
  }
>
  Totaal
</th>
                        <th
  style={{ ...thClickable, textAlign: "right" }}
  onClick={() =>
    setSort({
      key: "openstaand",
      dir: sort.key === "openstaand" && sort.dir === "asc" ? "desc" : "asc",
    })
  }
>
  Openstaand
</th>
                        <th style={thBase}>Telefoon</th>
                        <th style={thBase}>Mobiel</th>
                        <th style={thBase}>E-mail</th>
                        <th style={thClickable} onClick={() => setSort({ key: "city", dir: sort.key === "city" && sort.dir === "asc" ? "desc" : "asc" })}>
                          Plaats
                        </th>
                        <th style={thClickable} onClick={() => setSort({ key: "country", dir: sort.key === "country" && sort.dir === "asc" ? "desc" : "asc" })}>
                          Land
                        </th>
                        <th style={thClickable} onClick={() => setSort({ key: "company_code", dir: sort.key === "company_code" && sort.dir === "asc" ? "desc" : "asc" })}>
                          Bedrijfscode
                        </th>
                      </tr>

                      <tr>
                        <th style={filterThStyle}>
                          <select value={zoeknaamFilter} onChange={(e) => setZoeknaamFilter(e.target.value)} style={selectStyle}>
                            <option value="">(alle)</option>
                            {zoeknaamOptions.map((x) => (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            ))}
                          </select>
                        </th>
                        <th style={filterThStyle}>
                          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} style={selectStyle}>
                            <option value="">(alle)</option>
                            {statusOptions.map((x) => (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            ))}
                          </select>
                        </th>
                        <th style={filterThStyle}>
                          <select value={contactFilter} onChange={(e) => setContactFilter(e.target.value)} style={selectStyle}>
                            <option value="">(alle)</option>
                            {contactOptions.map((x) => (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            ))}
                          </select>
                        </th>
                        <th style={filterThStyle}>
                          <select value={invoiceNrFilter} onChange={(e) => setInvoiceNrFilter(e.target.value)} style={selectStyle}>
                            <option value="">(alle)</option>
                            {invoiceNrOptions.map((x) => (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            ))}
                          </select>
                        </th>
                        <th style={filterThStyle}>
                          <select value={invoiceDateFilter} onChange={(e) => setInvoiceDateFilter(e.target.value)} style={selectStyle}>
                            <option value="">(alle)</option>
                            {invoiceDateOptions.map((x) => (
                              <option key={x} value={x}>
                                {formatNlDate(x)}
                              </option>
                            ))}
                          </select>
                        </th>
                        <th style={filterThStyle}>
  <select
    value={totaalFilter}
    onChange={(e) => setTotaalFilter(e.target.value)}
    style={selectStyle}
  >
    <option value="">(alle)</option>
    {totaalOptions.map((x) => (
      <option key={x} value={x}>
        € {formatMoney(x)}
      </option>
    ))}
  </select>
</th>
                        <th style={filterThStyle}>
  <select
    value={openstaandFilter}
    onChange={(e) => setOpenstaandFilter(e.target.value)}
    style={selectStyle}
  >
    <option value="">(alle)</option>
    {openstaandOptions.map((x) => (
      <option key={x} value={x}>
        € {formatMoney(x)}
      </option>
    ))}
  </select>
</th>
                        <th style={filterThStyle}>
                          <select value={telFilter} onChange={(e) => setTelFilter(e.target.value)} style={selectStyle}>
                            <option value="">(alle)</option>
                            {telOptions.map((x) => (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            ))}
                          </select>
                        </th>
                        <th style={filterThStyle}>
                          <select value={mobFilter} onChange={(e) => setMobFilter(e.target.value)} style={selectStyle}>
                            <option value="">(alle)</option>
                            {mobOptions.map((x) => (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            ))}
                          </select>
                        </th>
                        <th style={filterThStyle}>
                          <select value={emailFilter} onChange={(e) => setEmailFilter(e.target.value)} style={selectStyle}>
                            <option value="">(alle)</option>
                            {emailOptions.map((x) => (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            ))}
                          </select>
                        </th>
                        <th style={filterThStyle}>
                          <select value={cityFilter} onChange={(e) => setCityFilter(e.target.value)} style={selectStyle}>
                            <option value="">(alle)</option>
                            {cityOptions.map((x) => (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            ))}
                          </select>
                        </th>
                        <th style={filterThStyle}>
                          <select value={countryFilter} onChange={(e) => setCountryFilter(e.target.value)} style={selectStyle}>
                            <option value="">(alle)</option>
                            {countryOptions.map((x) => (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            ))}
                          </select>
                        </th>
                        <th style={filterThStyle}>
                          <select value={companyCodeFilter} onChange={(e) => setCompanyCodeFilter(e.target.value)} style={selectStyle}>
                            <option value="">(alle)</option>
                            {companyCodeOptions.map((x) => (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            ))}
                          </select>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {sortedItems.map((it, idx) => {
                        const isCursor = idx === listIndex;
                        const isSelected = selectedId === it.id;

                        let bg = "transparent";
                        if (isSelected) bg = rowBgSelected;
                        else if (isCursor) bg = rowBgCursor;

                        const orgName = safeTrim(pickOrgSearchNameFromRow(it) || "-") || "-";
                        const contactName = safeTrim(pickContactNameFromRow(it));
                        const invNr = safeTrim(it.invoice_number || "-") || "-";
                        const invDt = formatNlDate(it.invoice_date) || "-";
                        const totaal = Number(it.total || 0);
                        const openstaand = Number(it.openstaand || 0);
                        const tel = safeTrim(it.org_phone || "-") || "-";
                        const mob = safeTrim(it.org_mobile || "-") || "-";
                        const email = safeTrim(it.org_email || "-") || "-";
                        const city = safeTrim(it.org_city || "-") || "-";
                        const ctry = safeTrim(it.org_country || "-") || "-";
                        const companyCodeName = safeTrim(pickCompanyCodeName(it));
                        const st = statusLabel(it.status);

                        const paidText = it.id === selectedId ? paidLabel : "-";

                        return (
                          <tr
                            key={it.id}
                            ref={(el) => (rowRefs.current[idx] = el)}
onClick={() => {
                              setListIndex(idx);
                              loadItemFromRow(it);
                              setMode("form");

                              if (window.innerWidth <= 768) {
                                focusFirstRightFieldMobile();
                              } else {
                                focusFirstRightField();
                              }
                            }}
                            style={{ cursor: "pointer", backgroundColor: bg }}
                          >
                                                        <td style={tdStyle} title={orgName}>
                              {orgName}
                            </td>
                            <td style={tdStyle} title={String(st || "")}>
                              {st}
                            </td>
                            <td style={tdStyle} title={contactName}>
                              {contactName}
                            </td>
                            <td style={tdStyle} title={invNr}>
                              {invNr}
                            </td>
                            <td style={tdStyle} title={invDt}>
                              {invDt}
                            </td>
                            <td style={{ ...tdStyle, textAlign: "right" }}>
  {euro(totaal)}
</td>
                            <td style={{ ...tdStyle, textAlign: "right" }}>
  {euro(openstaand)}
</td>
                            <td style={tdStyle} title={tel}>
                              {tel && tel !== "-" ? (
                                <button
                                  type="button"
                                  onClick={(e) => handlePhoneGridClick(e, tel)}
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    padding: 0,
                                    margin: 0,
                                    color: "#1f4e79",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    font: "inherit",
                                  }}
                                  title={`Bellen: ${tel}`}
                                >
                                  {tel}
                                </button>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td style={tdStyle} title={mob}>
                              {mob && mob !== "-" ? (
                                <button
                                  type="button"
                                  onClick={(e) => handleMobileGridClick(e, mob)}
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    padding: 0,
                                    margin: 0,
                                    color: "#1f4e79",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    font: "inherit",
                                  }}
                                  title={`Bellen / SMS / WhatsApp: ${mob}`}
                                >
                                  {mob}
                                </button>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td style={tdStyle} title={email}>
                              {email && email !== "-" ? (
                                <button
                                  type="button"
                                  onClick={(e) => handleEmailGridClick(e, email)}
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    padding: 0,
                                    margin: 0,
                                    color: "#1f4e79",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    font: "inherit",
                                  }}
                                  title={`E-mailen: ${email}`}
                                >
                                  {email}
                                </button>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td style={tdStyle} title={city}>
                              {city}
                            </td>
                            <td style={tdStyle} title={ctry}>
                              {ctry}
                            </td>
                            <td style={tdStyle} title={companyCodeName}>
                              {companyCodeName || "-"}
                            </td>
                          </tr>
                        );
                      })}

                      {sortedItems.length === 0 && (
                        <tr>
                          <td colSpan={13} style={{ padding: 12, opacity: 0.7 }}>
                            Geen resultaten (filters te streng?)
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>

{/* RECHTS */}
        <div
          ref={rightScrollRef}
          style={{
            width: isMobile ? "100%" : 320,
            minWidth: isMobile ? 0 : 320,
            maxWidth: isMobile ? "100%" : 320,
            position: isMobile ? "relative" : "sticky",
            top: isMobile ? "auto" : 0,
            alignSelf: "start",
            maxHeight: isMobile ? "none" : "calc(100vh - 40px)",
            overflowY: isMobile ? "visible" : "auto",
            overflowX: "hidden",
            background: "linear-gradient(180deg, #0b4f7a 0%, #083b5c 100%)",
            borderRadius: 10,
            padding: 10,
            boxSizing: "border-box",
            marginTop: isMobile ? 6 : 0,
            paddingTop: isMobile ? 6 : 10,
          }}
        >
<div
            style={{
              background: "white",
              borderRadius: 10,
              padding: 12,
              boxSizing: "border-box",
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              overflowX: "hidden",
            }}
          >
            <h3 style={{ marginTop: 0 }}>
              <span>Factuur</span>
            </h3>

            <div style={{ display: "grid", gap: 8, width: "100%", minWidth: 0 }}>
<label style={{ fontSize: 13, color: "#333" }}>Relatie</label>
              <select
                ref={orgRef}
                value={form.organisation_id}
                onChange={(e) => {
                  const v = e.target.value;
                  setDueDateManual(false);
                  setForm((p) => ({ ...p, organisation_id: v, contact_id: "" }));
                  setOrgDetail(null);
                  if (v) loadOrgDetail(v);
                }}
                style={selectStyle}
                disabled={isFormLocked || isFormDisabled}
                title={isFormLocked ? "Kies eerst Nieuw of selecteer eerst een regel" : (isLocked ? "Read-only (gefactureerd)" : "")}
              >
                <option value="">(kies)</option>
                {orgs.map((o) => (
                  <option key={o.id} value={String(o.id)}>
                    {pickOrgSearchName(o)}
                  </option>
                ))}
              </select>

<label
  style={{
    fontSize: 13,
    color: "#333",
    opacity: selectedRelationIsPrivate ? 0.55 : 1,
  }}
>
  Contactpersoon
</label>
              <select
                ref={contactRef}
                value={selectedRelationIsPrivate ? "" : form.contact_id}
                onChange={(e) => setForm((p) => ({ ...p, contact_id: e.target.value }))}
                style={{
                  ...selectStyle,
                  opacity: selectedRelationIsPrivate ? 0.55 : 1,
                  cursor: selectedRelationIsPrivate ? "not-allowed" : "pointer",
                }}
                disabled={isFormLocked || isFormDisabled || selectedRelationIsPrivate}
                title={
                  selectedRelationIsPrivate
                    ? "Niet van toepassing bij particulier"
                    : isFormLocked
                      ? "Kies eerst Nieuw of selecteer eerst een regel"
                      : isLocked
                        ? "Read-only (gefactureerd)"
                        : ""
                }
              >
                <option value="">
                  {selectedRelationIsPrivate
                    ? "(niet van toepassing bij particulier)"
                    : "(geen)"}
                </option>
{!selectedRelationIsPrivate &&
  contacts
    .filter((c) => c.active !== false)
    .map((c) => (
      <option key={c.id} value={String(c.id)}>
        {pickContactFullName(c)}
      </option>
    ))}
              </select>

<label style={{ fontSize: 13, color: "#333" }}>Bedrijfscode</label>
<input
  value={pickCompanyCodeNameFromOrganisation(activeOrg) || ""}
  readOnly
  disabled
  style={{
    ...inputStyle,
    background: "#f7f7f7",
    color: "#555",
  }}
/>

<label style={{ fontSize: 13, color: "#333" }}>Factuursjabloon</label>
<select
  value={form.template_id || ""}
  onChange={(e) => applyInvoiceTemplate(e.target.value)}
  style={selectStyle}
  disabled={isFormLocked || isFormDisabled}
  title={isFormLocked ? "Kies eerst Nieuw of selecteer eerst een regel" : "Kies een factuursjabloon"}
>
  <option value="">(geen sjabloon)</option>
  {invoiceTemplates.map((tpl) => (
    <option key={tpl.id} value={String(tpl.id)}>
      {tpl.name || "(zonder naam)"}
    </option>
  ))}
</select>

<label style={{ fontSize: 13, color: "#333" }}>Factuurnummer</label>
<input
  ref={invNumRef}
  value={form.invoice_number || ""}
  onChange={(e) => setForm((p) => ({ ...p, invoice_number: e.target.value }))}
  style={inputStyle}
  disabled={isFormLocked || isFormDisabled || !isAdmin}
  placeholder="(optioneel / auto later)"
  title={isFormLocked ? "Kies eerst Nieuw of selecteer eerst een regel" : (!isAdmin ? "Alleen administrator mag factuurnummer wijzigen" : "")}
/>

<label style={{ fontSize: 13, color: "#333" }}>Factuurdatum</label>
              <input
                ref={invDateRef}
                type="date"
                value={form.invoice_date || ""}
                onChange={(e) => setForm((p) => ({ ...p, invoice_date: e.target.value }))}
                style={dateInputStyle}
                disabled={isFormLocked || isFormDisabled}
              />

<label style={{ fontSize: 13, color: "#333" }}>Vervaldatum</label>
<input
  ref={dueDateRef}
  type="date"
  value={form.due_date || ""}
  onChange={(e) => {
    setDueDateManual(true);
    setForm((p) => ({ ...p, due_date: e.target.value }));
  }}
  style={dateInputStyle}
  disabled={isFormLocked || isFormDisabled}
/>

<div style={{ display: "grid", gap: 8 }}>
<button
  onClick={openInvoicePopupEdit}
  disabled={isFormLocked}
  style={{
    ...buttonPrimary("#2f7dd1"),
    width: "100%",
    boxSizing: "border-box",
    ...(isFormLocked ? { opacity: 0.5, cursor: "not-allowed" } : {}),
  }}
  title={
    isFormLocked
      ? "Kies eerst Nieuw of selecteer eerst een regel"
      : (!formHasId() ? "Sla op en open factuur" : "Open complete factuur in popup")
  }
>
  Factuur
</button>
</div>

<hr style={{ margin: "10px 0" }} />

<div style={{ fontWeight: 600, marginBottom: 6 }}>Factuurtotalen</div>

<div
  style={{
    border: "1px solid #e5e5e5",
    borderRadius: 8,
    padding: 10,
    fontSize: 12,
    display: "grid",
    gap: 6,
  }}
>

<div style={{ display: "flex", justifyContent: "space-between" }}>
  <span>Subtotaal</span>
  <b>{euro(invoiceTotals.subtotal)}</b>
</div>

{invoiceTotals.vatRows.map((row) => (
  <div
    key={row.rate}
    style={{ display: "flex", justifyContent: "space-between" }}
  >
    <span>{row.label}</span>
    <span>{euro(row.vat)}</span>
  </div>
))}

<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    borderTop: "1px solid #ddd",
    paddingTop: 6,
    marginTop: 2,
    fontSize: 13,
  }}
>
  <span><b>Totaal</b></span>
  <b>{euro(invoiceTotals.total)}</b>
</div>

<div style={{ display: "flex", justifyContent: "space-between" }}>
  <span>Betaald</span>
  <span>{euro(betaaldTotaal)}</span>
</div>

<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    borderTop: "1px solid #ddd",
    paddingTop: 6,
    marginTop: 2,
    fontSize: 13,
  }}
>
  <span><b>Openstaand</b></span>
  <b>{euro(openstaandBedrag)}</b>
</div>

{invoiceTotals.allVerlegd && (
  <div style={{ color: "#555", marginTop: 4 }}>Btw verlegd</div>
)}

  {gPercentage > 0 && (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          borderTop: "1px solid #eee",
          paddingTop: 6,
          marginTop: 4,
        }}
      >
        <span>G-rekening ({gPercentage}%)</span>
        <b>{euro(gAmount)}</b>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>IBAN ({100 - gPercentage}%)</span>
        <b>{euro(ibanAmount)}</b>
      </div>
    </>
  )}
</div>

<hr style={{ margin: "10px 0" }} />

<div style={{ fontWeight: 600, marginBottom: 6 }}>Betalingen (deelbetalingen)</div>



<div style={{ display: "grid", gap: 8, marginBottom: 10, width: "100%", minWidth: 0 }}>
  <div
    style={{
      display: "grid",
gridTemplateColumns: "130px 1fr",
      gap: 8,
      width: "100%",
      minWidth: 0,
    }}
  >

    <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
      <label style={{ fontSize: 12, color: "#555" }}>Betaaldatum</label>
      <input
  ref={payDateRef}
  type="date"
  value={payDraft.paid_on}
  onChange={(e) => setPayDraft({ ...payDraft, paid_on: e.target.value })}
  style={{ ...dateInputStyle, width: "140px" }}
  disabled={!canEditPayments}
/>
    </div>

    <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
      <label style={{ fontSize: 12, color: "#555", paddingLeft: 32 }}>Bedrag</label>
<input
  ref={payAmtRef}
  value={payDraft.amount}
  onChange={(e) => setPayDraft({ ...payDraft, amount: e.target.value })}
  placeholder="bijv. 250,00"
  style={{
    ...dateInputStyle,
    textAlign: "right",
    paddingRight: 50,
    width: "100%",
  }}
  disabled={!canEditPayments}
/>
    </div>
  </div>

  <div
    style={{
      border: "1px solid #e5e5e5",
      borderRadius: 8,
      overflow: "hidden",
      width: "100%",
      minWidth: 0,
    }}
  >
    {payments.length === 0 ? (
      <div style={{ padding: "8px 10px", fontSize: 12, color: "#777" }}>
        (nog geen betalingen)
      </div>
    ) : (
      payments.map((p) => (
        <div
          key={p.id}
          style={{
            display: "grid",
            gridTemplateColumns: "minmax(0,1fr) 76px 44px",
gap: 3,
padding: "0px 6px",
borderTop: "1px solid #eee",
fontSize: 12,
lineHeight: "1.2",
            alignItems: "center",
          }}
        >
          <div
            style={{
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {formatNlDate(p.paid_on) || "-"}
          </div>

          <div style={{ textAlign: "right" }}>{euro(p.amount)}</div>

          <div style={{ textAlign: "right" }}>
            <button
              onClick={() => deletePayment(p.id)}
              style={{
                padding: "4px 6px",
                borderRadius: 6,
                border: "1px solid #ddd",
                background: "#fff",
                cursor: "pointer",
              }}
              title="Verwijderen"
            >
              ✕
            </button>
          </div>
        </div>
      ))
    )}
  </div>

<button
  onClick={addPayment}
  disabled={!canEditPayments}
  style={
    !canEditPayments
      ? { ...buttonPrimary("#2f7dd1"), opacity: 0.5, cursor: "not-allowed" }
      : buttonPrimary("#2f7dd1")
  }
>
  + Betaling toevoegen
</button>

<hr style={{ margin: "14px 0 10px 0" }} />

<div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
  <label style={{ fontSize: 13, color: "#333" }}>Opmerking</label>

<input
  ref={payNotesRef}
  value={form.notes || ""}
  onChange={(e) => setForm({ ...form, notes: e.target.value })}
  placeholder="(optioneel)"
  style={{
    ...inputStyle,
    marginTop: 6
  }}
  disabled={isFormLocked || isFormDisabled || !form.id}
/>

  </div>
</div>

<hr style={{ margin: "10px 0" }} />

<label style={{ fontSize: 13, color: "#333" }}>Status</label>
<select
  ref={statusRef}
  value={form.status || "DRAFT"}
  onChange={(e) => setForm((p) => ({ ...p, status: e.target.value }))}
  style={{
    ...selectStyle,
    minWidth: 0,
    background: isAdmin && !isFormLocked ? "white" : "#f5f5f5",
    color: "#333",
    cursor: isAdmin && !isFormLocked ? "pointer" : "not-allowed",
  }}
  disabled={isFormLocked || isReadonly || !isAdmin}
  title={
    isFormLocked
      ? "Kies eerst Nieuw of selecteer eerst een regel"
      : (isAdmin ? "Administrator mag status aanpassen" : "Status wordt automatisch bepaald door het proces")
  }
>
  <option value="DRAFT">Concept</option>
  <option value="FINAL">Gefactureerd</option>
  <option value="PARTIAL">Deelbetaling</option>
  <option value="PAID">Betaald</option>
</select>

<div style={{ fontSize: 12, color: "#666" }}>
  {isAdmin ? (
    <div>
      <b>Admin:</b> status mag handmatig worden aangepast.
    </div>
  ) : isLocked ? (
    <div>
      <b>Let op:</b> na <i>Gefactureerd</i> zijn de kop en regels vergrendeld.
    </div>
  ) : (
    <div>Conceptfactuur is nog wijzigbaar.</div>
  )}
</div>

<hr style={{ margin: "10px 0" }} />

<div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap" }}>
<button
  onClick={openInvoicePopupPreview}
  disabled={isFormLocked}
  style={
    isFormLocked
      ? { ...buttonPrimary("#6c757d"), opacity: 0.5, cursor: "not-allowed" }
      : buttonPrimary("#6c757d")
  }
>
  {isCreditInvoice ? "Voorbeeld creditnota" : "Voorbeeld factuur"}
</button>

<button
  onClick={finalizeInvoice}
  disabled={
    isFormLocked ||
    normalizeDbStatus(form.status || "DRAFT") !== "DRAFT"
  }
  style={
    isFormLocked || normalizeDbStatus(form.status || "DRAFT") !== "DRAFT"
      ? { ...buttonPrimary("#28a745"), opacity: 0.5, cursor: "not-allowed" }
      : buttonPrimary("#28a745")
  }
>
  {isCreditInvoice ? "Creditnota definitief" : "Factuur definitief"}
</button>

<button
  onClick={saveItem}
  disabled={isFormLocked || isReadonly || (isLocked && !isAdmin)}
  style={
    (isFormLocked || isReadonly || (isLocked && !isAdmin))
      ? { ...buttonPrimary("#2f7dd1"), opacity: 0.5, cursor: "not-allowed" }
      : buttonPrimary("#2f7dd1")
  }
>
  Opslaan
</button>

<button
  onClick={deleteItem}
  disabled={isFormLocked || !formHasId()}
  style={
    isFormLocked || !formHasId()
      ? { ...buttonPrimary("#dc6454"), opacity: 0.5, cursor: "not-allowed" }
      : buttonPrimary("#dc6454")
  }
>
  Verwijderen
</button>
</div>

<div style={{ marginTop: 10, opacity: 0.7, fontSize: 12 }}>
  Factuur-id: {formHasId() ? String(form.id) : "(nieuw)"}{" "}
  {isLocked ? "— read-only" : ""}
</div>


    </div>
    </div>
    </div>
    </div>
    </div>

{showLinesPopup && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: silentDocumentPreview ? "transparent" : "rgba(0,0,0,0.35)",
      zIndex: 99999,
      overflowY: "auto",
      overflowX: "auto",
      padding: "20px",
      opacity: silentDocumentPreview ? 0 : 1,
      pointerEvents: silentDocumentPreview ? "none" : "auto",
    }}
  >
    <div
      ref={popupPrintRef}
      style={{
        fontFamily: "Calibri, Carlito, Arial, sans-serif",
        fontSize: "11pt",
        width: 1120,
        minWidth: 1120,
        margin: "0 auto",
        background: "#fff",
        borderRadius: 8,
        boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
        padding: "42px 56px 40px 56px",
      }}
    >

{/* KNOPPEN BOVEN */}
<div
  className="invoice-top-actions"
  style={{
    display: "flex",
    justifyContent: "flex-end",
    gap: 8,
    marginBottom: 18,
    paddingRight: 4,
    flexWrap: "wrap",
  }}
>
  <button
    onClick={() => openAiPopup("popup")}
    style={buttonPrimary("#6f42c1")}
  >
    ✨ AI
  </button>

  {popupMode === "preview" && (
    <>
      <button
        onClick={printInvoicePopup}
        style={buttonPrimary("#6c757d")}
      >
        Printen
      </button>

{["FINAL", "PARTIAL", "PAID"].includes(normalizeDbStatus(form.status || "DRAFT")) &&
  safeTrim(form.invoice_number || "") && currentInvoiceUbl && (
    <button
      type="button"
      onClick={downloadInvoiceUbl}
      style={buttonPrimary("#6c757d")}
      title="Download de UBL 2.1 XML-factuur; voor handmatige verzending samen met de PDF"
    >
      UBL XML
    </button>
  )}
{["FINAL", "PARTIAL", "PAID"].includes(normalizeDbStatus(form.status || "DRAFT")) &&
        safeTrim(form.invoice_number || "") && (
          <button
            onClick={sendInvoiceEmail}
            disabled={sendingEmail || !formHasId() || !currentInvoiceEmail || !currentInvoiceDigital}
            style={
              sendingEmail || !formHasId() || !currentInvoiceEmail || !currentInvoiceDigital
                ? { ...buttonPrimary("#198754"), opacity: 0.5, cursor: "not-allowed" }
                : buttonPrimary("#198754")
            }
          >
            {sendingEmail ? "Bezig..." : "E-mailen"}
          </button>
        )}
    </>
  )}

  <button
    onClick={() => setShowLinesPopup(false)}
    style={buttonPrimary("#2f7dd1")}
  >
    {popupMode === "preview" ? "Sluiten" : "Opslaan/Sluiten"}
  </button>

  {popupMode !== "preview" && (
    <button
      onClick={annuleerInvoicePopup}
      style={buttonStyle}
    >
      Annuleren
    </button>
  )}
</div>

{/* HEADER */}
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  }}
>
        
{/* LOGO + KLANT */}


<div>
{!useOwnLetterhead ? (
  effectiveInvoiceSettings.logo_url ? (
    <img
      src={effectiveInvoiceSettings.logo_url}
      alt="logo"
      style={{ height: 92, marginBottom: 34, objectFit: "contain" }}
    />
  ) : (
    <div style={{ height: 92, marginBottom: 34 }} />
  )
) : null}

  <div style={{ lineHeight: 1.6, fontSize: "11pt" }}>
    <div style={{ fontWeight: 600, marginBottom: 2 }}>
      {recipientName || ""}
    </div>

{selectedContact?.attention ? (
  <div>{selectedContact.attention}</div>
) : null}

    {recipientAddressLines.map((line, idx) => (
      <div key={idx}>{line}</div>
    ))}
  </div>
</div>

{/* BEDRIJF */}
{!useOwnLetterhead ? (
<div style={{ textAlign: "right", lineHeight: 1.55, fontSize: "11pt" }}>
  {effectiveInvoiceSettings.company_name ? (
    <>
      <strong>{effectiveInvoiceSettings.company_name}</strong><br />
    </>
  ) : null}

  {effectiveInvoiceSettings.invoice_contact_person ? <>{effectiveInvoiceSettings.invoice_contact_person}<br /></> : null}

  {effectiveInvoiceSettings.company_address_1 ? <>{effectiveInvoiceSettings.company_address_1}<br /></> : null}
  {effectiveInvoiceSettings.company_address_2 ? <>{effectiveInvoiceSettings.company_address_2}<br /></> : null}

  {effectiveInvoiceSettings.company_postcode || effectiveInvoiceSettings.company_city ? (
    <>{[effectiveInvoiceSettings.company_postcode, effectiveInvoiceSettings.company_city].filter(Boolean).join(" ")}<br /></>
  ) : null}

  {effectiveInvoiceSettings.company_country ? <>{effectiveInvoiceSettings.company_country}<br /></> : null}

  {effectiveInvoiceSettings.company_email || effectiveInvoiceSettings.company_phone ? <><br /></> : null}

  {effectiveInvoiceSettings.company_email ? <>{effectiveInvoiceSettings.company_email}<br /></> : null}
  {effectiveInvoiceSettings.company_phone ? <>{effectiveInvoiceSettings.company_phone}<br /></> : null}

  {effectiveInvoiceSettings.company_kvk || effectiveInvoiceSettings.company_vat || effectiveInvoiceSettings.company_iban || effectiveInvoiceSettings.company_g_iban ? <><br /></> : null}

  {effectiveInvoiceSettings.company_kvk ? <>KvK: {effectiveInvoiceSettings.company_kvk}<br /></> : null}
  {effectiveInvoiceSettings.company_vat ? <>Btw: {effectiveInvoiceSettings.company_vat}<br /></> : null}
  {effectiveInvoiceSettings.company_iban ? <>Bank: {effectiveInvoiceSettings.company_iban}{effectiveInvoiceSettings.company_g_iban ? <br /> : null}</> : null}
  {effectiveInvoiceSettings.company_g_iban ? <>G-rekening: {effectiveInvoiceSettings.company_g_iban}</> : null}
</div>
) : null}
      </div>

{/* TITEL + KENMERK */}
<div style={{ marginTop: 34, marginBottom: 22 }}>
<div style={{ fontSize: "11pt", fontWeight: 500, marginBottom: 4 }}>
    {invoiceDocumentLabel}{" "}
    {form.invoice_number || "(nog geen factuurnummer)"}
  </div>

  {form.reference_code ? (
    <div style={{ fontSize: "11pt" }}>
      <span style={{ display: "inline-block", width: 110 }}>Kenmerk:</span>
      {form.reference_code}
    </div>
  ) : null}

  {invoiceTotals.allVerlegd && orgVatNumber ? (
    <div style={{ fontSize: "11pt", marginTop: 4 }}>
      <span style={{ display: "inline-block", width: 110 }}>Btw-id:</span>
      {orgVatNumber}
    </div>
  ) : null}
</div>

{/* DATUMBLOK */}
<div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 320px",
    gap: 20,
    marginTop: -32,
    marginBottom: 22,
  }}
>
  <div />

<div
  style={{
    fontSize: "11pt",
    lineHeight: 1.7,
    textAlign: "right",
    position: "relative",
    top: -12,
  }}
>
<div
  style={{
    display: "grid",
    gridTemplateColumns: "130px 100px",
    columnGap: 10,
    rowGap: 4,
    justifyContent: "end",
    textAlign: "left",
  }}
>
  <div>Factuurdatum:</div>
  <div>{formatNlDate(form.invoice_date) || "\u00A0"}</div>

  <div>Vervaldatum:</div>
  <div>{formatNlDate(form.due_date) || "\u00A0"}</div>
</div>
  </div>
</div>

{(form.invoice_intro_text || effectiveInvoiceSettings.intro_text || form.invoice_payment_text || effectiveInvoiceSettings.payment_text) ? (
  <div
    style={{
      marginTop: 6,
      marginBottom: 20,
      fontSize: "11pt",
      lineHeight: 1.55,
      whiteSpace: "pre-wrap",
      width: "68%",
      maxWidth: "68%",
    }}
  >
    {(form.invoice_intro_text || effectiveInvoiceSettings.intro_text) ? (
      <div style={{ marginBottom: 10 }}>
        {form.invoice_intro_text || effectiveInvoiceSettings.intro_text}
      </div>
    ) : null}

    {(form.invoice_payment_text || effectiveInvoiceSettings.payment_text) ? (
      <div>{form.invoice_payment_text || invoiceSettings.payment_text}</div>
    ) : null}
  </div>
) : null}

{/* Artikelkop wordt eenmaal getoond, direct vóór de eerste Artikelregel. */}

{/* REGELS */}

<div style={{ marginTop: 8 }}>
  {(lines || []).length === 0 ? (
    <div style={{ padding: "14px 0", color: "#777", fontSize: "11pt" }}>
      (nog geen factuurregels)
    </div>
  ) : (
    (lines || []).map((ln, idx) => {
      const showArticleHeader = invoiceAmountLine(ln) &&
        !(lines || []).slice(0, idx).some(invoiceAmountLine);
      const isEditing = String(editingLineId || "") === String(ln.id || "");
      const qty = isEditing ? Number(lineDraft.quantity || 0) : lineQty(ln);
      const unit = isEditing
        ? Number(String(lineDraft.unit_price || "").replace(",", ".") || 0)
        : lineUnitPrice(ln);
      const total = qty * unit;
      const rate = isEditing ? lineDraft.vat_rate : lineVatRate(ln);

      return (
        <React.Fragment key={ln.id}>
          {showArticleHeader && (
            <InvoiceArticleHeader
              popupMode={popupMode}
              hideVatColumnOnInvoice={invoiceTotals.hideVatColumnOnInvoice}
            />
          )}
        <div
          style={{
            display: "grid",
gridTemplateColumns:
  popupMode === "preview"
    ? invoiceTotals.hideVatColumnOnInvoice
      ? "70px 1fr 110px 110px"
      : "70px 1fr 110px 110px 70px"
    : invoiceTotals.hideVatColumnOnInvoice
      ? "70px 1fr 110px 110px 56px"
      : "70px 1fr 110px 110px 70px 56px",
            gap: 12,
            padding: !isEditing && !invoiceAmountLine(ln) ? "4px 0 8px" : "8px 0",
            borderBottom: "none", // vFCT-042: geen grijze lijnen onder factuurregels (ook niet in PDF)
            fontSize: "11pt",
            lineHeight: 1.45,
            alignItems: "start",
            background: isEditing ? "#eef6ff" : "transparent",
          }}
        >
          {!isEditing && !invoiceAmountLine(ln) ? (
            <div style={{
              gridColumn: "1 / -1",
              paddingLeft: 0,
              whiteSpace: "pre-wrap",
              overflowWrap: "anywhere",
              fontWeight: ["heading", "subtotal", "total"].includes(invoiceLineType(ln)) ? 700 : 400,
            }}>
              {lineDescription(ln)}
              {popupMode !== "preview" && !isLocked && (
                <span style={{ float: "right", whiteSpace: "nowrap" }}>
                  <button type="button" title="Tekstregel bewerken" onClick={() => startEditInvoiceLine(ln)}
                    style={{ border: "none", background: "transparent", cursor: "pointer" }}>✏️</button>
                  <button type="button" title="Tekstregel verwijderen" onClick={() => {
                    if (window.confirm("Regel verwijderen?")) deleteInvoiceLine(ln.id);
                  }} style={{ border: "none", background: "transparent", cursor: "pointer" }}>🗑️</button>
                </span>
              )}
            </div>
          ) : (
            <>
          {isEditing ? (
            <input
              ref={qtyInputRef}
              value={lineDraft.quantity}
              onChange={(e) =>
                setLineDraft({ ...lineDraft, quantity: e.target.value })
              }
              onFocus={(e) => e.target.select()}
              style={{
                ...inputStyle,
                textAlign: "right",
                padding: "6px 6px",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          ) : (
<div style={{ textAlign: "right", cursor: "default" }}>
  {qty}
</div>
          )}

          {isEditing ? (
            <div>
              <select
                aria-label="Regeltype"
                value={invoiceAmountLine(lineDraft) ? "item" : "text"}
                onChange={(e) => setLineDraft((prev) => ({ ...prev, line_type: e.target.value,
                  quantity: e.target.value === "item" ? (Number(prev.quantity) > 0 ? prev.quantity : 1) : 0,
                  unit_price: e.target.value === "item" ? (prev.unit_price || "0,00") : "0,00",
                  vat_rate: e.target.value === "item" ? "hoog" : "0" }))}
                style={{ ...selectStyle, marginBottom: 6 }}
              >
                <option value="item">Artikel</option><option value="text">Tekst</option>
              </select>
            <textarea
              ref={lineDescRef}
              value={lineDraft.description}
              onChange={(e) => {
                setLineDraft({ ...lineDraft, description: e.target.value });
                e.target.style.height = "auto";
                e.target.style.height = `${e.target.scrollHeight}px`;
              }}
              placeholder={"Omschrijving\nBijv. Artikel / Naam / Activiteit"}
              style={{
                ...inputStyle,
                minHeight: 44,
                resize: "none",
                overflow: "hidden",
                overflowWrap: "anywhere",
                wordBreak: "break-word",
                width: "100%",
                boxSizing: "border-box",
                fontFamily: "Calibri, Carlito, Arial, sans-serif",
                fontSize: "11pt",
                whiteSpace: "pre-wrap",
                padding: "6px 8px",
                lineHeight: "1.4",
              }}
            />
            </div>
          ) : (
<div
  title=""
  style={{
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    width: "100%",
    cursor: "default",
  }}
>
  {lineDescription(ln)}
</div>
          )}

          {isEditing ? (
            <input
              ref={linePriceRef}
              value={lineDraft.unit_price}
              onChange={(e) =>
                setLineDraft({ ...lineDraft, unit_price: e.target.value })
              }
              onBlur={handleUnitPriceCommit}
              style={{
                ...inputStyle,
                textAlign: "right",
                padding: "6px 6px",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          ) : (
<div style={{ textAlign: "right", cursor: "default" }}>
  {euro(unit)}
</div>
          )}

          <div style={{ textAlign: "right", fontWeight: isEditing ? 700 : 400 }}>
            {euro(total)}
          </div>

          {!invoiceTotals.hideVatColumnOnInvoice && (
            isEditing ? (
              <div style={{ textAlign: "right" }}>
                <select
                  ref={lineVatRef}
                  value={lineDraft.vat_rate}
                  onChange={(e) =>
                    setLineDraft({ ...lineDraft, vat_rate: e.target.value })
                  }
                  style={{
                    ...selectStyle,
                    padding: "6px 6px",
                    width: 70,
                    display: "inline-block",
                  }}
                >
                  <option value="hoog">21%</option>
                  <option value="laag">9%</option>
                  <option value="0">0%</option>
                  <option value="verlegd">verlegd</option>
                </select>
              </div>
            ) : (
<div style={{ textAlign: "right", cursor: "default" }}>
  {normalizeVatRate(rate) === "verlegd" ? "0%" : vatLabelForRate(rate).replace(" btw", "")}
</div>
            )
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 4,
              alignItems: "center",
            }}
          >
            {popupMode !== "preview" && !isLocked && (
              isEditing ? (
                <>
                  <button
                    type="button"
                    onClick={addInvoiceLine}
                    title="Regel opslaan"
                    style={{
                      border: "1px solid #ddd",
                      background: "#2f7dd1",
                      color: "#fff",
                      cursor: "pointer",
                      fontSize: 12,
                      borderRadius: 6,
                      padding: "4px 7px",
                      fontWeight: 700,
                    }}
                  >
                    ✓
                  </button>
                  <button
                    type="button"
                    onClick={cancelEditInvoiceLine}
                    title="Annuleren"
                    style={{
                      border: "1px solid #ddd",
                      background: "#f5f5f5",
                      color: "#333",
                      cursor: "pointer",
                      fontSize: 12,
                      borderRadius: 6,
                      padding: "4px 7px",
                      fontWeight: 700,
                    }}
                  >
                    ×
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    onClick={() => startEditInvoiceLine(ln)}
                    title="Bewerken"
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      fontSize: 15,
                      opacity: 0.7,
                      padding: 0,
                      margin: 0,
                    }}
                  >
                    ✏️
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      if (window.confirm("Regel verwijderen?")) {
                        deleteInvoiceLine(ln.id);
                      }
                    }}
                    title="Verwijderen"
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      fontSize: 15,
                      opacity: 0.7,
                      padding: 0,
                      margin: 0,
                    }}
                  >
                    🗑️
                  </button>
                </>
              )
            )}
          </div>
            </>
          )}
        </div>
        </React.Fragment>
      );
    })
  )}

{!isLocked && popupMode !== "preview" && !editingLineId && (
  <div style={{ marginTop: 18 }}>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: invoiceTotals.hideVatColumnOnInvoice
          ? "70px 1fr 110px 110px 56px"
          : "70px 1fr 110px 110px 70px 56px",
        gap: 12,
        alignItems: "center",
        marginBottom: 10,
      }}
    >
      <div></div>

      <div
        style={{
          gridColumn: "2 / 3",
          display: "grid",
          gridTemplateColumns: "110px auto minmax(320px, 1fr)",
          gap: 12,
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontWeight: 700,
            fontSize: 13,
            whiteSpace: "nowrap",
          }}
        >
          Projectbeheer?
        </div>

        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontSize: 13,
            whiteSpace: "nowrap",
            userSelect: "none",
            cursor: "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={includeChildProjects}
            onChange={(e) => setIncludeChildProjects(e.target.checked)}
            disabled={!formHasId() || isLocked}
          />

          Onderliggende onderdelen?
        </label>

        <select
          value={selectedProjectLineId}
          onChange={(e) => vulRegelUitProjectbeheer(e.target.value)}
          disabled={!formHasId() || isLocked}
          style={{
            ...selectStyle,
            width: "100%",
          }}
        >
          <option value="__manual__">Handmatig invoeren</option>

          {projectItems.map((p) => (
            <option key={p.id} value={p.id}>
              {`${p.full_code || p.code || ""} ${p.name || ""}`.trim()}
            </option>
          ))}
        </select>
      </div>

      <div></div>
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: invoiceTotals.hideVatColumnOnInvoice
          ? "70px 1fr 110px 110px 56px"
          : "70px 1fr 110px 110px 70px 56px",
        gap: 12,
        alignItems: "start",
      }}
    >
      <input
        ref={qtyInputRef}
        value={lineDraft.quantity}
        onChange={(e) =>
          setLineDraft({ ...lineDraft, quantity: e.target.value })
        }
        onFocus={(e) => e.target.select()}
        onClick={(e) => e.target.select()}
        placeholder="1"
        style={{
          ...inputStyle,
          textAlign: "right",
          padding: "8px 8px 8px 12px",
        }}
      />

      <div>
      <select
        aria-label="Regeltype"
        value={invoiceAmountLine(lineDraft) ? "item" : "text"}
        onChange={(e) => setLineDraft((prev) => ({ ...prev, line_type: e.target.value,
          quantity: e.target.value === "item" ? 1 : 0,
          unit_price: e.target.value === "item" ? "" : "0,00",
          vat_rate: e.target.value === "item" ? pickOrgDefaultVatRate(activeOrg) : "0" }))}
        style={{ ...selectStyle, marginBottom: 6 }}
      >
        <option value="item">Artikel</option><option value="text">Tekst</option>
      </select>
      <textarea
        ref={lineDescRef}
        value={lineDraft.description}
        onChange={(e) => {
          setLineDraft({ ...lineDraft, description: e.target.value });
          e.target.style.height = "auto";
          e.target.style.height = `${e.target.scrollHeight}px`;
        }}
        placeholder={"Omschrijving\nBijv. Artikel / Naam / Activiteit"}
        style={{
          ...inputStyle,
          minHeight: 64,
          resize: "none",
          overflow: "hidden",
          overflowWrap: "anywhere",
          wordBreak: "break-word",
          width: "100%",
          boxSizing: "border-box",
          fontFamily: "Calibri, Carlito, Arial, sans-serif",
          fontSize: "11pt",
          whiteSpace: "pre-wrap",
          padding: "8px 8px",
          lineHeight: "1.4",
        }}
      />
      </div>

      <input
        ref={linePriceRef}
        value={lineDraft.unit_price}
        onChange={(e) =>
          setLineDraft({ ...lineDraft, unit_price: e.target.value })
        }
        onBlur={handleUnitPriceCommit}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            focusNextPopupField(+1);
          }
        }}
        placeholder="excl. btw"
        style={{
          ...inputStyle,
          textAlign: "right",
          padding: "8px 8px",
        }}
      />

      <div
        style={{
          textAlign: "right",
          fontSize: "11pt",
          fontWeight: 600,
          paddingTop: 10,
        }}
      >
        {euro(
          Number(lineDraft.quantity || 0) *
            Number(String(lineDraft.unit_price || "").replace(",", ".") || 0)
        )}
      </div>

      {!invoiceTotals.hideVatColumnOnInvoice && (
        <div style={{ textAlign: "right" }}>
          <select
            ref={lineVatRef}
            value={lineDraft.vat_rate}
            onChange={(e) =>
              setLineDraft({ ...lineDraft, vat_rate: e.target.value })
            }
            disabled={!formHasId() || isLocked}
            style={{
              ...selectStyle,
              padding: "6px 6px",
              width: 70,
              display: "inline-block",
            }}
          >
            <option value="hoog">21%</option>
            <option value="laag">9%</option>
            <option value="0">0%</option>
            <option value="verlegd">verlegd</option>
          </select>
        </div>
      )}

      <div style={{ textAlign: "center", paddingTop: 2 }}>
        <button
          type="button"
          onClick={addInvoiceLine}
          disabled={!formHasId() || isLocked}
          title="Regel opslaan"
          style={{
            border: "1px solid #ddd",
            background: !formHasId() || isLocked ? "#f2f2f2" : "#2f7dd1",
            color: !formHasId() || isLocked ? "#999" : "#fff",
            cursor: !formHasId() || isLocked ? "not-allowed" : "pointer",
            fontSize: 12,
            borderRadius: 6,
            padding: "6px 8px",
            fontWeight: 700,
            whiteSpace: "nowrap",
          }}
        >
          ✓
        </button>
      </div>
    </div>
  </div>
)}

  {lineError && (
    <div style={{ marginTop: 10, color: "crimson", fontSize: 13 }}>
      {lineError}
    </div>
  )}
</div>

<div className="invoice-total-footer-block">
  {/* TOTALEN */}
  <div className="invoice-totals-block" style={{ marginTop: 22 }}>
    <div
      style={{
        display: "grid",
        gridTemplateColumns:
          popupMode === "preview"
            ? invoiceTotals.hideVatColumnOnInvoice
              ? "70px 1fr 110px 110px"
              : "70px 1fr 110px 110px 70px"
            : invoiceTotals.hideVatColumnOnInvoice
              ? "70px 1fr 110px 110px 56px"
              : "70px 1fr 110px 110px 70px 56px",
        gap: 12,
        fontSize: "11pt",
        lineHeight: 1.9,
        alignItems: "center",
      }}
    >
      <div></div>
      <div></div>
      <div style={{ textAlign: "right" }}>Subtotaal</div>
      <div style={{ textAlign: "right" }}>{euro(invoiceTotals.subtotal)}</div>
      {!invoiceTotals.hideVatColumnOnInvoice && <div></div>}
      {popupMode !== "preview" && <div></div>}

      {invoiceTotals.vatRows.map((row) => (
        <React.Fragment key={row.rate}>
          <div></div>
          <div></div>
          <div style={{ textAlign: "right" }}>{row.label}</div>
          <div style={{ textAlign: "right" }}>{euro(row.vat)}</div>
          {!invoiceTotals.hideVatColumnOnInvoice && <div></div>}
          {popupMode !== "preview" && <div></div>}
        </React.Fragment>
      ))}

      <div></div>
      <div></div>
      <div
        style={{
          borderTop: "2px solid #222",
          paddingTop: 8,
          textAlign: "right",
          fontWeight: 700,
        }}
      >
        Totaal
      </div>
      <div
        style={{
          borderTop: "2px solid #222",
          paddingTop: 8,
          textAlign: "right",
          fontWeight: 700,
        }}
      >
        {euro(invoiceTotals.total)}
      </div>
      {!invoiceTotals.hideVatColumnOnInvoice && <div></div>}
      {popupMode !== "preview" && <div></div>}
    </div>
  </div>

{!useOwnLetterhead && String(form.invoice_footer_text || effectiveInvoiceSettings.footer_text || "").trim() ? (
<div
    className="invoice-footer-block"
    style={{
      marginTop: 60,
      borderTop: "none", // vFCT-042: geen ongewenste lijn boven de voettekst
      paddingTop: 10,
      fontSize: "11pt",
      color: "#555",
      whiteSpace: "pre-wrap",
      width: "68%",
      maxWidth: "68%",
    }}
  >
    {form.invoice_footer_text || effectiveInvoiceSettings.footer_text || ""}
  </div>
) : null}

{/* KNOPPEN ONDER */}
  <div
    className="invoice-bottom-actions"
    style={{
      display: useOwnLetterhead ? "none" : "flex",
      justifyContent: "flex-end",
      gap: 8,
      marginTop: 28,
      paddingRight: 4,
      flexWrap: "wrap",
    }}
  >
    <button
      onClick={() => openAiPopup("popup")}
      style={buttonPrimary("#6f42c1")}
    >
      ✨ AI
    </button>

    {popupMode === "preview" && (
      <>
        <button
          onClick={printInvoicePopup}
          style={buttonPrimary("#6c757d")}
        >
          Printen
        </button>

{["FINAL", "PARTIAL", "PAID"].includes(normalizeDbStatus(form.status || "DRAFT")) &&
  safeTrim(form.invoice_number || "") && currentInvoiceUbl && (
    <button
      type="button"
      onClick={downloadInvoiceUbl}
      style={buttonPrimary("#6c757d")}
      title="Download de UBL 2.1 XML-factuur; voor handmatige verzending samen met de PDF"
    >
      UBL XML
    </button>
  )}
{["FINAL", "PARTIAL", "PAID"].includes(normalizeDbStatus(form.status || "DRAFT")) &&
          safeTrim(form.invoice_number || "") && (
            <button
              onClick={sendInvoiceEmail}
              disabled={sendingEmail || !formHasId() || !currentInvoiceEmail || !currentInvoiceDigital}
              style={
                sendingEmail || !formHasId() || !currentInvoiceEmail || !currentInvoiceDigital
                  ? { ...buttonPrimary("#198754"), opacity: 0.5, cursor: "not-allowed" }
                  : buttonPrimary("#198754")
              }
            >
              {sendingEmail ? "Bezig..." : "E-mailen"}
            </button>
          )}
      </>
    )}

    <button
      onClick={() => setShowLinesPopup(false)}
      style={buttonPrimary("#2f7dd1")}
    >
      {popupMode === "preview" ? "Sluiten" : "Opslaan/Sluiten"}
    </button>

    {popupMode !== "preview" && (
      <button
        onClick={annuleerInvoicePopup}
        style={buttonStyle}
      >
        Annuleren
      </button>
    )}
  </div>
</div>

    </div>

  </div>
)}

{(letterheadPdfPreviewBusy || letterheadPdfPreviewUrl || letterheadPdfPreviewError) && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 100005,
      background: "rgba(0,0,0,0.55)",
      padding: 14,
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      gap: 10,
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 8,
        flexWrap: "wrap",
        background: "#fff",
        padding: "8px 10px",
        borderRadius: 8,
        boxShadow: "0 5px 18px rgba(0,0,0,0.25)",
      }}
    >
      <button
        type="button"
        onClick={closeLetterheadPdfPreview}
        disabled={letterheadPdfPreviewBusy}
        style={buttonPrimary("#2f7dd1")}
      >
        ✏️ Bewerken
      </button>

      <button
        type="button"
        onClick={printLetterheadPdfPreview}
        disabled={letterheadPdfPreviewBusy || !letterheadPdfPreviewUrl}
        style={
          letterheadPdfPreviewBusy || !letterheadPdfPreviewUrl
            ? { ...buttonPrimary("#6c757d"), opacity: 0.5, cursor: "not-allowed" }
            : buttonPrimary("#6c757d")
        }
      >
        Printen
      </button>

      {["FINAL", "PARTIAL", "PAID"].includes(normalizeDbStatus(form.status || "DRAFT")) &&
        safeTrim(form.invoice_number || "") && currentInvoiceUbl && (
          <button
            type="button"
            onClick={downloadInvoiceUbl}
            style={buttonPrimary("#6c757d")}
            title="Download de UBL 2.1 XML-factuur; voor handmatige verzending samen met de PDF"
          >
            UBL XML
          </button>
        )}
      {["FINAL", "PARTIAL", "PAID"].includes(normalizeDbStatus(form.status || "DRAFT")) &&
        safeTrim(form.invoice_number || "") && (
          <button
            type="button"
            onClick={sendInvoiceEmail}
            disabled={
              letterheadPdfPreviewBusy ||
              sendingEmail ||
              !formHasId() ||
              !currentInvoiceEmail ||
              !currentInvoiceDigital
            }
            style={
              letterheadPdfPreviewBusy ||
              sendingEmail ||
              !formHasId() ||
              !currentInvoiceEmail ||
              !currentInvoiceDigital
                ? { ...buttonPrimary("#198754"), opacity: 0.5, cursor: "not-allowed" }
                : buttonPrimary("#198754")
            }
          >
            {sendingEmail ? "Bezig..." : "E-mailen"}
          </button>
        )}

      <button
        type="button"
        onClick={closeLetterheadPdfPreview}
        disabled={letterheadPdfPreviewBusy}
        style={buttonPrimary("#2f7dd1")}
      >
        Sluiten
      </button>
    </div>

    <div
      style={{
        flex: 1,
        minHeight: 0,
        width: "min(1120px, 100%)",
        margin: "0 auto",
        background: "#707070",
        borderRadius: 6,
        overflow: "hidden",
        boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
      }}
    >
      {letterheadPdfPreviewBusy ? (
        <div style={{ color: "white", padding: 24, fontSize: 16 }}>
          PDF-voorbeeld wordt opgebouwd…
        </div>
      ) : letterheadPdfPreviewError ? (
        <div style={{ color: "#b00020", background: "white", margin: 20, padding: 16, borderRadius: 6 }}>
          {letterheadPdfPreviewError}
        </div>
      ) : (
        <iframe
          ref={letterheadPdfPreviewFrameRef}
          title="PDF voorbeeld factuur"
          src={letterheadPdfPreviewUrl}
          style={{
            width: "100%",
            height: "100%",
            minHeight: "calc(100vh - 95px)",
            border: 0,
            background: "#707070",
          }}
        />
      )}
    </div>
  </div>
)}

{aiOpen && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.35)",
      zIndex: 100000,
      padding: isMobile ? 10 : 24,
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <div
      style={{
        width: isMobile ? "100%" : 900,
        height: isMobile ? "92vh" : "82vh",
        background: "#fff",
        borderRadius: 12,
        boxShadow: "0 20px 70px rgba(0,0,0,0.30)",
        padding: 18,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12,
          flexWrap: "wrap",
          marginBottom: 12,
        }}
      >
        <h2 style={{ margin: 0 }}>
          {aiSource === "popup" ? "AI Factuur" : "AI Facturen"}
        </h2>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button onClick={printAiDocument} disabled={aiBusy} style={aiBusy ? buttonDisabledStyle : buttonStyle}>
            Printen
          </button>
          <button
            onClick={startAiSpeak}
            disabled={!voice.supported || voice.listening || aiBusy}
            style={!voice.supported || voice.listening || aiBusy ? buttonDisabledStyle : buttonStyle}
          >
            {voice.listening ? "🎤 Luistert…" : "🎤 Spreek"}
          </button>
          <button onClick={closeAiPopup} disabled={aiBusy} style={aiBusy ? buttonDisabledStyle : buttonStyle}>
            Sluiten
          </button>
        </div>
      </div>

      <div style={{ marginBottom: 10, fontWeight: 700 }}>Kies een actie:</div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr 1fr",
          gap: 8,
          marginBottom: 14,
        }}
      >
        <button onClick={runAiOrganisationData} disabled={aiBusy} style={aiBusy ? buttonDisabledStyle : buttonStyle}>
          Relatie gegevens
        </button>

        {aiSource === "popup" ? (
          <button onClick={runAiInvoiceCheck} disabled={aiBusy} style={aiBusy ? buttonDisabledStyle : buttonStyle}>
            Factuur controleren
          </button>
        ) : (
          <button onClick={runAiContactData} disabled={aiBusy} style={aiBusy ? buttonDisabledStyle : buttonStyle}>
            Contactpersoon gegevens
          </button>
        )}

        <button onClick={runAiDossierOverview} disabled={aiBusy} style={aiBusy ? buttonDisabledStyle : buttonStyle}>
          Dossier overzicht
        </button>

        <button onClick={runAiChat} disabled={aiBusy} style={aiBusy ? buttonDisabledStyle : buttonStyle}>
          Chat met AI
        </button>
      </div>

      <div style={{ marginBottom: 8, fontWeight: 700 }}>AI venster</div>

      <textarea
        ref={aiTextRef}
        value={aiText}
        onChange={(e) => setAiText(e.target.value)}
        placeholder="Klik op een AI-keuze, of typ hier je vraag voor Chat met AI."
        style={{
          width: "100%",
          flex: 1,
          minHeight: 0,
          padding: 12,
          border: "1px solid #ccc",
          borderRadius: 8,
          fontFamily: "inherit",
          fontSize: 15,
          lineHeight: 1.45,
          boxSizing: "border-box",
          resize: "none",
          whiteSpace: "pre-wrap",
          overflowY: "auto",
        }}
      />
    </div>
  </div>
)}

</>
  );
}
